var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1080 1080",
    width: 1280,
    height: 1280,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h1080v1080h-1080z",
    fill: "#3C050F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h1080v1080h-1080zm493 44-11 2-20 2-20 4-2 1v2h-8l-22 6-10 1-35 12-16 6-10 5-15 7-16 8-11 5v2l-5 2-7 4-3 3-7 3-17 11-10 8v2l-5 1-17 13-10 9-11 9-34 34-9 11-12 14-7 9-6 8-9 13-9 14-12 20-12 22-9 19-9 21-9 25-7 22-2 8-2 13-2 6v8h-2l-3 12-1 9-2 7-1 16-2 10v97l2 10 1 17 2 7 3 18 7 30 7 24 7 20 11 27 14 29 9 17 12 19 2 1 3 7 6 10 6 8 4 6h2l2 5 6 8h2l2 4 11 13 8 10 8 7 15 15h2l2 4 4 4h2v2h2v2l10 8 7 6h2v2l5 4 4 1 5 5 7 6 6 4h2v2l11 7 18 11 7 3 4 4 21 11 23 11 30 12 20 7 25 7 14 4 11 2 13 2 15 3 17 2 6 1 34 1h35l32-1 12-2 14-1 11-3 12-1 17-4 22-6 19-6 18-6 11-5 10-4v-2l9-3 21-10 12-5 7-4 3-3 16-10 7-3 4-4 7-3 2-3 4-2v-2l5-2 7-4 11-9 2-3 5-2 4-5 8-7 8-6 9-10 4-4 3-1 3-5 5-5v-2l4-1 4-4v-2l3-1 3-5v-2l4-1 8-10v-2l3-1 10-14 1-4 4-2 7-10v-4l3-1 5-7 3-8 8-13 5-6 6-12 4-10 1-4h2v-2h2l5-12 2-8v-5h3l8-20 6-17 8-30 3-10 2-10 2-12 3-16 3-24 1-32v-37l-1-35-2-8-1-16-3-11-2-13-3-15-4-15-5-15-5-17-5-13h-2l-4-16-6-13h-2l-3-9-3-5-3-13h-2v-2h-2l-2-5-5-9-3-3-3-7-8-13-9-14h-2l-2-5-10-13-7-9-10-12-7-9h-2v-2l-20-20-4-5-7-6-3-5-6-2v-2l-8-6h-2v-2l-7-6h-2v-2l-10-7-3-1v-2l-7-3-5-5-13-9h-2l-1-3-7-3-21-13-16-8-21-10-18-8-14-3-1-3-13-2v-2l-9-3h-4v-2l-8-2-22-5-6-2-11-2-25-5-14-1-10-2z",
    fill: "#010101"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(512,217)",
    d: "m0 0h55l25 3 20 4 26 7 21 7 11 5 12 5 19 10 16 10 12 8 14 10 7 6 8 7 12 11 12 12 7 8 9 11 10 14 8 11 9 15 10 19 5 11 7 17 8 23 7 29 3 24 1 2 1 12v51l-1 12-1 3-3 24-4 18-8 25-8 21-8 18-5 9-7 13h-2l-2 6-5 7-1 3h-2l-2 4-8 12h-2l-2 4-7 9-2 3h-2l-2 4-24 24-7 6-10 8-4 3h-2l-1 3-7 4-5 4-7 4-9 6-11 6-15 8-7 3-25 10-15 5-11 3-9 2-20 4-21 3-20 1h-29l-21-2-21-3-2-1-10-1-5-2-17-4-10-3-17-6-7-3-21-10-8-4-14-8-14-9-11-8-9-7-11-9-6-5v-2l-4-2-7-6-7-8-6-6v-2h-2l-8-10-12-16v-2h-2l-12-20-6-9-6-12v-3h-2l-7-16-9-24-8-27-5-26-2-19-1-4v-56l4-28 4-20 6-23 4-13 5-11 7-17 10-19 5-9h2l1-5 11-16 8-11 9-11 4-5h2l2-4 11-12 9-9h2v-2l14-11 8-7 6-4 11-8 21-13 15-8 13-6 20-8 17-6 15-4 14-3 15-3z",
    fill: "#811121"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(528,138)",
    d: "m0 0h32l24 2 9 1 4 3 6 2 6 5 4 7v15l-2 3h-2l-1 7-3 3-1 3 4 2 5 5 7 3 19 3 9 5 7 1 9 4 4 3 10 1 2 1v2l7 2 11 6 5 3 9 3 8 6 5 3 12 8 5 4 6 3 10 7 8 6 10 5 9-2 5-2 2-5 9-11 8-2h7l9 3 7 6 5 3 7 7 7 8 5 5 4 5 7 10 5 6 7 11 12 18 4 8 3 7 3 3 5 13 5 8 3 9 5 10 1 7h2l4 14 2 8 3 5 3 13 2 5 1 11 4 11 2 28 2 9 1 9v61l-2 11-1 12-1 3-1 14-9 39-1 3h-2l-1 7-3 10-4 11-2 6-4 11-7 12-2 7h-2l-1 9-4 6-3 2-4 9-4 2-3 9-2 3h-2l-2 8h-2l-2 5-6 10-5 2-2 4-5 7-3 5-6 7-4 6-12 11-22 22-11 9-10 8-6 4-6 5-10 7-5 3-6 4-9 1-2 4-6 4h-3l-2 4-12 5-7 4-24 10-16 6-8 1-3 2-8 2-10 4-14 3-13 1-5 2-12 1-12 3-25 1-5 1h-40l-10-1-22-1-7-2-14-1-11-4-15-2-10-3-7-2v-2l-9-1-13-5-9-3-12-6-14-5-10-6-8-5-10-4-10-6-9-6-7-4-11-8-7-6-9-6-8-7v-2l-5-2-5-5-8-7-12-12-4-5-4-4-7-8-6-8-11-14v-3l-4-2-6-10-6-8-4-7-6-11-10-18-6-13-6-11-2-6-6-16v-6l-3-1-6-23-2-7-2-16-1-1-4-25-2-7-1-3-1-14v-64l3-29 2-3 1-5v-10l6-24h2v-8l9-27 5-14 5-12 24-48 7-10 3-5 7-10 11-13 7-10 6-8 5-3 8-11 5-6h2l1-3 15-11 4-6 3-3 7-4 4-4 5-3 11-9 13-7 8-6 7-5 9-5 16-8 8-5 19-8 15-6 13-4 18-6 37-7 1-1h10v-2l16-2 3-1zm-16 79-29 4-16 4-10 2-14 4-23 8-19 8-19 10-20 12-10 7-16 12-14 12-2 1v2l-4 2-15 15-5 6v2h-2l-9 11-4 5-13 18-7 11v3h-2l-9 16-10 21-7 18-7 21-6 24-4 24-2 16v56l2 16 5 28 7 26 9 25 7 16 2 5h2l1 5 6 11 12 20 5 8h2l2 4 10 14 8 10h2l2 4 6 7 8 7 6 6h2l2 4 10 8 11 9 11 8 22 14 11 6 16 8 11 5 16 6 10 4 19 5 9 2 2 1 10 1 13 3 16 2 15 1h29l20-1 27-4 16-4 10-2 18-5 30-12 9-4 13-7 16-9 8-6 7-4 5-4 4-2v-2l4-2 8-6 7-5 30-30v-2h2l11-14v-2h2l9-13 1-3h2l5-9 3-5v-2h2l11-21 7-15 6-14 7-20 5-16 5-24 2-18 1-3 1-12v-51l-1-12-1-2-3-24-5-21-5-16-7-20-8-19-9-17-4-8-9-14-7-10-10-14-12-14-12-13-12-12-8-7-10-8-12-9-15-10-13-8-18-10-22-10-33-11-23-6-16-3-25-3z",
    fill: "#821121"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(548,260)",
    d: "m0 0 22 1 11 7 10 2 1 3 6 1 14 4 22 3 8-3 6 1 8 4 9 3 15 8v4l-2 1-2 5-3 3 1 5 11-2 11 1 2 2-10 9-15 11v43l-1 16-2 8-1 16-4 13-6 11-8 8-9 4h-2l-4 17-4 14-8 18-7 11-9 11-3 3h-2v2l-3 3h-2v15l3 16 7 14 8 3 13 2 21 3 18 4 18 6 16 8 14 9 13 11 7 8v2h2l10 13 2 5h2l5 9 9 15 9 19v4h2l-1 4-5 8h-2l-3-10-6-11-2-6-9-15-7-11-6-8-2-5-1-3-3-1-5-6-2-5-4-1-7-8-2-3-6-3-2-2-8-3-5-3v-2l-16-4-17-5v-2h-7l-3 1h-9l-7 3-6 5-5-1 1-2h2v-6l-2-2-16-2h-4v2l-4 2-4 4-6 3-7 2-2 2-7 3-19 3h-17l-9-3-7-2-9-3-9-4-4-2v-2l-5-2-6-3-3-2h-8l-7 3-1 2 3 6 5 6 16 12 14 9 1 4 9 2v2l9 1 5 2 10 1h14l10-2 12-3 3-2h5l1-3 5-2 4-2 2-2 4 1-3 3h-2v2l-3 1-4 4-5 3-4 1-3 4v4l3 2h108l13 1 4 1v2l3-1 5 3v2h2l5 14 1 37v54h2v2l-7 4-3 2 1-15-1-16v-46l-2-16h-1v-12l-3-4v-2l-5-1-3-1h-315l-5 3-3 4-1 104-4-1-7-6-4-2-1-2-4-2-24-24v-2l-3-1-8-13-5-9 2-11 12-23 12-19 7-9 5-6h2l2-4 12-12 13-10 14-8 12-6 21-7 30-6 13-4 12-3 4-3 5-13 2-11v-8l-3-6-9-7v-2h-2v-2h-2l-10-13-7-12-7-17-6-24-2-4-12-6-8-9-6-15-2-16-5-24-3-24-1-14 1-26 4-22 4-4 9-4 3 1-3 10-1 1-1 4-2 4v7h-2v8h1v20l-1 12h1l2 11h12l3-3 3-1 2-10 3-10 3-2-1-4 2-8h2l1-6 3-3 1-3h2l2-4 7-7 2-5 2-2 2-5 5-2 10 9 6 7 7 5 4 4 5 4 26 13 12 4 10 3 12 1 9 1 2 1h22l21-3 16-5 11-5 1-2h-43l-25-4-6-4-1-5 4-3h11l16 2h39l8-6 3-5 3-3 4-1 2-5h-35l-16-1-26-8-12-5-11-4-21-10-2-2v-3z",
    fill: "#110405"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(493,44)",
    d: "m0 0h99l10 2 14 1 16 3 12 3 11 2 19 5 12 2 2 1v2l8 1 5 2v2l13 2 1 3 16 4 27 12 22 11 27 16 6 3v2l5 2 14 10 3 3 5 2v2l4 2 9 6v2l4 2 5 4v2l5 2 5 4v2l6 2 6 8 7 6 7 8 14 14v2h2l11 14 9 10 16 22v2h2l7 11 12 19 2 6 4 4 5 9v2h2v2h2l3 13 6 12v2h2l7 16 3 13h2l9 25 5 18 3 10 3 11 2 11 3 16 2 8 1 16 2 8 1 35v37l-1 32-2 12-1 14-3 14-2 12-4 17-7 26-10 30-6 14h-3l-1 7-2 8-4 10h-2v2h-2l-2 6-7 16-4 7-3 3-10 17-2 5-5 7h-2l-1 5-7 10-3 1-1 4-11 15h-2l-2 4-7 9h-3l-4 8h-2l-2 4-3 3h-3l-2 4-5 5-1 3-5 3-9 9-5 6-5 3-9 8-4 5-5 2-4 5-12 9-6 3h-2l-1 3-3 1-5 5-4 1-5 5-9 4-13 8-6 5-10 5-6 2-25 12-5 1-1 3-19 7-10 4-14 5-25 7-14 4-14 3-12 1-11 3-14 1-12 2-32 1h-35l-34-1-11-2-18-2-9-2-13-2-15-3-21-6-20-6-27-10-24-10-16-8-23-12-2-3-7-3-15-9-14-9v-2l-5-2-9-7-5-4-1-2-5-2-4-3v-2l-4-2-11-9-4-3v-2h-2v-2l-4-2-4-4v-2l-4-2-13-13-5-4-7-8-12-14-5-6v-2h-2l-8-11v-2h-2l-9-13-6-9-3-5-1-4-5-5-12-20-8-16-13-27-11-27-10-31-5-19-3-12-4-20-2-11-1-4-1-17-2-10v-97l2-10 1-16 2-7 3-19 1-2h2v-8l3-10 2-12 3-11 11-33 6-15 8-19 8-16 13-24 8-13 11-17 9-13 8-10 11-14 12-14 11-12 27-27 11-9 10-9 12-9 5-4h4l2-4 8-6 20-13 6-2 4-4 7-4h2l1-3 10-4 17-9 23-10 12-5 22-8 18-6 13-2 19-5h8v-2l10-3 12-2 26-3zm11 22-20 3-14 1-5 2-12 1-5 2-13 2-5 2-10 2-12 3-4 2-7 1-2 2-9 2-10 4-12 5-11 4-12 6-5 1-1 2-7 3-6 3-7 3v2l-6 2-8 5-10 5v2l-5 2-11 7v3l-4 1-5 5-4 2v2h-3l-1 2-5 1-8 6-3 2v2l-4 2-11 9-12 11-7 6-5 6-6 5-3 4v2l-4 2-10 12v2l-4 2-3 4v2l-3 1-6 9-2 4h-2l-4 5-3 5-4 5-4 7v2h-2l-3 6-2 2v3h-2l-3 6-7 12-7 13-5 10-3 5-6 15-5 11-3 7-5 15-2 4-2 7-5 15-2 9-3 13-2 7-2 10-1 3-2 15-1 2-2 23-2 11v77l2 11 2 24 2 4 1 12 2 5 2 12 2 4 1 10 2 3 2 10 2 5 2 7 3 10 4 10 6 17 5 10 6 14 5 8 1 5 2 1 6 12 11 19 9 14 9 13 1 3 4 4h2l2 5 9 11 3 4h2l2 5 4 5 5 5 5 6 5 4 6 7 5 4 3 5 9 9 5 2 9 8h2v2l13 10 5 2v2l5 4 7 4 5 4 5 3h2v2l10 6 3 2h3v2l18 10 13 7 10 5 5 2 11 5 10 4h3v2l27 9 4 2 8 2 1 1 10 2 5 2 9 2 15 3 7 2 12 1 5 2 21 2 12 2h78l16-2 4-1 17-1 4-2 17-2 5-2 9-1 3-2 10-1 5-3 10-2 10-3 9-3 3-2 7-2 10-4 9-3v-2l6-1 10-5 7-3 7-4 5-2 13-7 12-7 7-5 9-5 11-8 9-5 5-5 5-3v-2l4-2 18-14v-2l4-2 12-12 5-4v-2l3-1v-2l3-1v-2h2l7-8 8-8v-2l4-2 4-6v-2h2l8-10v-2h2l4-6 4-4 5-9 5-6 4-7v-2h2l3-6 5-7 6-11 3-6 5-8 3-7 10-20 3-8 5-13 3-6 2-7 2-5 2-6 3-11 1-1 2-11 2-4 2-9 3-15 2-7 1-11 2-5 1-16 2-8 1-13v-74l-1-13-2-7-1-18-2-4-2-16-2-5-1-10-2-3-1-9-3-6-1-8-2-3-2-8-2-5-2-6-3-10-4-9-6-15-2-2-2-6-6-14h-2l-2-7-7-13-5-8-2-4h-2l-1-5-6-9-1-2h-2l-2-6-8-10-3-5-10-13-6-8h-2l-2-4-12-14-4-5-6-5-5-6-3-3-3-4-5-3-7-7-11-9h-2v-2l-11-9-5-2v-2l-4-1v-2l-11-8h-3l-1-3-10-6-12-8-9-5-8-5-8-4h-3l-1-3-6-2-14-7-18-8-10-4-6-2-10-4-9-2-3-2-10-3-2-1-9-1-3-2-9-1-5-2-12-2-5-2-15-2-2-1-22-2-8-2z",
    fill: "#F2F5F7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(464,591)",
    d: "m0 0m10-6h8l4 3 5 2 5 3v2l10 3 4 3 9 3 12 3 3 1h17l19-3 8-4 3-2 7-2 6-3 4-4h2v-2l8-1 12 2 3 3-1 6-2 1 4 1 9-7 4-1h11l4-1 4 1v2l17 4 12 3 4 2v2l5 2 9 3 1 2 7 3 2 4 3 3v2l3 1v2l5 1 3 6 4 5 5 5 3 7 8 11 12 20 4 9 6 13-1 6-14 16-3 6-11 11-8 7-9 6 2 2-7 7-10 6h-3l-3 3-21 13-19 10-19 8h-3v2l-9 2-4 2-8 2-18 5-12 2-4 1h-87l-7-2-11-2-16-4-11-3-9-3-10-3-9-4-15-8-10-5-13-8-11-7-3-8h-1v-104l4-5 5-3h315l8 3 4 6v11h1l2 17v53l1 16-1 7 6-5h3v-2h-2l-1-6v-60l-1-25-4-11v-3h-2l-3-3-5-1v-2l-17-1h-108l-4-3 1-5 3-4 7-3 4-2 2-3h3v-2h2l1-3-4 2-5 3-4 1-1 2-14 4-8 3-8 1h-14l-10-1-8-3-6-1v-2l-10-1-1-5-16-10-15-12-6-8-1-4 5-4z",
    fill: "#8099AD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(526,118)",
    d: "m0 0h36l22 1 21 3 6 5 19 9 7 9 8 13 12 3 9 3 5-1 3-2h11l3 3 2 10 1 1 24 1 4 2 3 12 1 1 24 1 4 2 3 11 13 3 2 2 2 8v4l15 3 20 1 20 6 8 3 6 5 1 3 7 3 7 8 5 6 2 3 5 2 4 6 5 5 2 5 5 6 2 1 3 7 5 5 1 4h2l4 7 3 2 1 7 3 1 6 15 4 7 4 4 4 12 3 3 4 11 4 7 3 12 6 12 3 13 4 13 2 3 5 29 2 5 3 29 2 8 1 30v20l-2 35-2 8-2 25-3 9-3 12-1 12-3 5-3 11-5 17-5 11-4 11-4 7-4 11-3 4-5 12-3 2-7 14h-2l-2 6-6 10-3 3-3 6-7 7-7 12-6 11-6 4h-2l-2 4-6 9-9 8-6 5-4 8-18 12-4 6-10 5-2 4-5 4-6 4-5 5-10 3-4 5-19 9h-2v2l-7 4-3 3-12 5-4 3-10 3-9 5-11 4-9 3-14 4-4 3-13 3-6 2-10 2-8 2-19 1-8 3-16 3-21 1h-56l-13-1-8-2-27-3-8-2-23-4-9-4-9-3-11-2-15-7-10-2-10-6-9-3-1-2-12-4-6-5-8-4-13-6-8-4-4-4-10-5-5-6-15-10-11-8-5-8-6-3v-2l-4-2-10-9-8-6-3-3-3-8-8-6-3-5-5-5-8-11-3-4-6-12-5-3-10-14-8-16-4-7-4-3-6-19v-2l-4-2-6-15-5-14v-2h-2l-2-3-3-13-1-1-1-12-3-6-3-13-1-13-4-6-1-11-3-10-1-22-1-8v-36l2-46 4-21 2-8 1-9 2-5 1-11 6-16 3-10 4-13 3-6 3-12 4-7 7-13 3-7 6-12 4-4 5-13 6-9 3-3 10-17 5-5 5-7h2v-2l5-5 3-6 8-7h2l2-4 4-6 7-8 6-5 7-8 7-3 7-9 9-5 3-4h2l2-4 6-4 11-8 9-5 5-4 4-4 12-6 3-3 12-5 6-3h2v-2l8-1v-2l6-3h2v-2l12-5 11-3 12-5 13-3 9-4 6-2h7l4-2 20-2 5-3 11-1 13-3zm2 20-29 1-7 2-12 1v2h-10l-6 2-32 6-18 6-16 5-22 9-16 8-7 4-12 6-11 7-10 7-7 4-10 6-10 9-5 3-6 5-5 3-4 5-5 5-12 9v2l-4 2-10 13-1 2-5 3-7 9-6 9-9 10-6 9-5 6-4 8-6 9-4 8-7 15-6 10-8 18-6 16-2 4-2 8-6 18v8h-2l-6 24v10l-2 6-1 2-3 29v64l1 14 2 4 3 21 2 10 1 1 3 22 3 9 4 15 3 1 1 9 5 13 4 9 16 32 7 12 4 8 12 18 5 7h2l1 4 8 10 8 11 7 8 5 5 11 12 10 10 6 4 4 4h2l2 4 10 8 10 7 6 5 11 8 11 6 8 5 16 8 14 8 18 8 12 5 6 2 13 5 9 1v2l12 3 9 3 11 1 11 4 14 1 7 2 22 1 10 1h40l9-1 23-1 10-3 12-1 5-2 13-1 16-4 10-4 8-2 7-2 11-3 11-5 20-8 20-10 1-3 5-1 6-5v-2l9-1 8-6 7-4 10-7 6-5 8-6 10-8 9-7 7-8 19-19 6-5 5-8 5-5 4-7 4-5v-2l5-2 8-13v-2h2l2-8h2l5-10v-2l4-2 5-10 4-4 2-3 1-9h2l3-9 4-7 4-8 3-7 3-12 3-6 3-10v-5h2l6-24 4-18 1-14 1-3 2-20 1-3v-61l-2-16-1-2-2-28-4-11-2-15-3-9-2-7-3-5-3-13-2-7h-2l-1-7-6-12-4-11-4-6-4-11-5-6-3-7-5-10-8-11-6-10-6-8-7-9-4-6-5-5-4-5-13-13-5-3-6-5-8-2-13 1-5 5-6 7-2 5-5 2-9 2-10-5-8-6-10-7-9-5-5-4-10-7-11-7-6-3-8-3-6-4-11-5h-2v-2l-2-1-10-1-6-4-7-3-7-1-9-5-19-3-10-5-4-5h-2l3-5 2-5v-3l3-1 1-2v-15l-5-8-6-5-7-2-2-2-17-2-16-1z",
    fill: "#560617"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(408,294)",
    d: "m0 0 2 1-1 9-2 14-1 15v14l2 29 2 5 2 13 2 7 1 15 5 15 6 10 4 5 8 5 6 3 4 14 3 12 5 13 8 15 8 11 12 12 6 5v17l-4 13-3 6-11 4-8 2-12 4-20 3-13 3-10 3-15 7-18 10-11 10-8 7-6 7h-2l-2 4-3 4h-2l-2 5-6 8-9 14-11 21-4 8-4-2-12-18-3-7-8-17v-4h-2l-5-15-3-7-7-28-1-9-2-9v-76l2-8 2-14 4-15 3-11 4-12 5-12 5-11 7-14 10-16 7-11 10-13 13-15 20-20 5-4h2l1-3 15-11 10-7 3-3h4v-2l12-7z",
    fill: "#FBFDFD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(701,313)",
    d: "m0 0 4 1 13 9 13 12 8 7 13 13 20 25 6 10 7 11 10 19 5 10 5 14 5 12 3 11 5 21 3 19v69l-4 26-4 14-6 20-6 14-4 10-8 17-10 15-4-2-6-14-4-7-10-16-2-5h-2l-7-11-8-9v-2l-4-2-4-4v-2l-4-2-12-10-13-7-15-7-15-5-10-2-11-2-11-1-8-2-13-2-7-3-6-12-2-5-1-8v-18l10-9 11-15 4-7 6-12 6-19 4-15 3-3 9-5 3-1 2-4h2l2-5 4-8 3-8 2-21 2-12 1-14v-22l-1-16 5-5 8-6 8-7h2v-2z",
    fill: "#FBFDFD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(394,656)",
    d: "m0 0h302l3 2v4h-3l-2 4-5 5-10 7h-2v2h-2v2l-5 3-5 5-7 4h-2l-2 4-20 13-9 7-10 7-5 1v2l-17 10-8 4h-2v3l-4-2-7-10-10-8-8-4h-26v2l-10 4-5 5-4 6-2 1-3 6-2 16 2 13 1 6-6 4-27 10-7 2-21 7-7-1-10-5-5-2-9-5-7-2-6-4v-2l-4-1-11-7-5-2-3-3v-106l3-5 1-1z",
    fill: "#BACFDD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(435,379)",
    d: "m0 0 4 1 6 8 3 5 4 13 3 3 7-1h3l6 15 6 9 12 6h23l7-3 6-4 5-7 4-22 3-4h10l3 4 3 18 5 9 5 5 9 4 16 1 12-2 8-6 5-6 4-12 2-10h2v3l5 2 3 1 5-2 2-10 6-12 5-6h5l3 5 1 8v24l-5 12-4 6-5 4-13 2-2 14-4 15-6 17-7 14-10 13-8 7-10 6-8 4-11 3-7 1h-28l-16-4-14-7-4-3v-2l-5-2-7-8v-2h-2l-9-16-5-13v-5h-2l-5-18-1-14-13-2-8-6-3-6v-2h-2l-3-16v-11l3-15z",
    fill: "#DE8F70"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(522,153)",
    d: "m0 0h40l27 2 9 2 2 2-1 4-1 1-27-2h-59l-28 3-29 6-23 6-27 9-11 5-12 5-26 13-24 15-10 7-11 8-5 4h-2v2l-7 5h-2l-1 3-4 3h-2l-2 4h-2v2h-2v2h-2v2l-8 7-6 7h-2l-2 4-4 4h-2l-2 4-9 11-18 24-3 5-7 11-7 12-5 9-8 16-5 11-6 15-3 8-7 21-8 33-3 17-3 27-1 24v16l2 28 2 20 2 9 1 9 5 18 4 16 8 25 4 9 4 10 14 28 9 16 3 4 5 9 8 10 3 5 14 18 7 8v2l3 1 4 5v2l4 2 5 6 3 2v2h2l5 5 5 4v2l4 2 9 8 2 1v2l4 2 6 4v2l4 1 9 7 11 7 22 13 17 9 20 9 12 5 20 7 21 6 24 5 8 2 40 4h43l29-3 10-1 30-6 24-7 24-8 9-4 17-7 12-7 14-7 15-9 11-8 8-5h2v-2l4-1 1-3 8-5 5-5 11-9 5-5 8-7 16-17 11-13 1-2h2l2-5 4-5h2l1-4h2l2-5 3-5h2l2-5 10-16 7-12 8-16 2-5h2l1-6 5-10 8-24 2-3 11-43 2-14 1-2 3-26 1-22v-26l-1-19-3-25-5-25-5-22-5-15-6-17-4-9-7-17-10-19-9-16-9-14-7-10-4-6v-2l-3-1-10-13-1-3h-2l-5-6v-2l-3-1-6-7v-2h-2v-2l-3-1-3-4 1-5h4l8 7 4 4v2h2l3 4v2l4 2 18 22 14 20 9 14 6 12 3 4 11 23 5 11 9 24 3 9 8 29 5 26 3 24 1 16v40l-1 22-4 29-4 19-4 16-4 14-3 8-6 17-2 3-2 6-4 10-11 22-13 22-6 10-6 8-4 6-9 11-12 15-7 8-1 2h-2v2l-7 6-5 5-4 5-9 7-3 3-8 7-3 1v2l-6 4h-2l-1 3-4 1v2l-10 6-4 2v2l-25 15-12 7-18 8-10 5-20 8-14 4-7 3-22 6-20 4-27 4-21 1h-44l-20-1-23-3-27-6-26-7-23-8-13-6-12-5-10-5-17-9-21-13-16-11-13-10-11-9v-2l-4-2-15-14-13-13-8-10-5-5-13-16-8-12-6-8-11-18-9-16-7-14-3-7-5-12-5-13-4-10-5-18-4-14-3-13-3-18-1-11-2-12-1-23v-29l1-24 4-29 5-24 9-32 7-19 4-10 7-15 8-17 10-16 6-11 14-19 4-6 11-14 3-4h2v-2l14-14 7-8 16-14 1-2h2v-2l8-6h2v-2l9-7 26-18 14-8 5-3 8-5 23-11 19-8 30-10 18-5 14-3 16-3 11-1 13-2z",
    fill: "#F85B6C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(512,217)",
    d: "m0 0h55l25 3 20 4 26 7 21 7 11 5 12 5 19 10 16 10 12 8 14 10 7 6 8 7 12 11 12 12 7 8 9 11 10 14 8 11 9 15 10 19 5 11 7 17 8 23 7 29 3 24 1 2 1 12v51l-1 12-1 3-3 24-4 18-8 25-8 21-8 18-5 9-7 13h-2l-2 6-5 7-1 3h-2l-2 4-8 12h-2l-2 4-7 9-2 3h-2l-2 4-24 24-7 6-10 8-4 3h-2l-1 3-7 4-5 4-7 4-9 6-11 6-15 8-7 3-25 10-15 5-11 3-9 2-20 4-21 3-20 1h-29l-21-2-21-3-2-1-10-1-5-2-17-4-10-3-17-6-7-3-21-10-8-4-14-8-14-9-11-8-9-7-11-9-6-5v-2l-4-2-7-6-7-8-6-6v-2h-2l-8-10-12-16v-2h-2l-12-20-6-9-6-12v-3h-2l-7-16-9-24-8-27-5-26-2-19-1-4v-56l4-28 4-20 6-23 4-13 5-11 7-17 10-19 5-9h2l1-5 11-16 8-11 9-11 4-5h2l2-4 11-12 9-9h2v-2l14-11 8-7 6-4 11-8 21-13 15-8 13-6 20-8 17-6 15-4 14-3 15-3zm14 7-32 3-21 4-24 6-20 7-24 10-16 8-5 2v2l-5 2-12 7-5 3v2l-4 1-20 15v2l-4 2-11 9-17 17v2h-2l-9 11-5 6v2h-2l-2 5h-2l-4 6v2h-2l-5 9-6 9-9 16-8 15-5 12-6 15-7 23-5 21-3 16-2 16-1 16v32l3 32 5 24 5 19 3 10 8 22 4 8 8 17 9 16 6 9 7 11 12 16 5 5 6 8h2l2 4 6 7 7 6 5 5 4 2v2l11 9 14 11 15 10 13 8 21 11 16 7 12 5 10 3 8 3 10 3 28 6 9 2 24 2h44l29-3 18-4 6-2 14-3 24-8 24-10 17-9 8-5 7-4 5-3 14-10 16-12 7-6v-2l4-2 20-20v-2l3-1 7-8 4-5 12-16 4-5v-3h2l4-7 6-9 4-8v-3h2l7-16 5-10 9-25 7-24 4-21 4-33v-41l-3-28-2-7-3-19-8-26-7-20-5-11-8-17-8-14-6-9-7-11-16-21-1-2h-2v-2h-2l-2-4-8-8-7-8-8-8-8-7-3-3h-2v-2h-3v-2l-6-4h-2v-2l-10-7-3-1v-2l-8-4-18-11-16-8-13-6-25-10-19-5-16-4-17-3-36-3z",
    fill: "#FD6572"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(474,585)",
    d: "m0 0h8l4 3 5 2 5 3v2l10 3 4 3 9 3 12 3 3 1h17l19-3 8-4 3-2 7-2 6-3 4-4h2v-2l8-1 12 2 3 3-1 6-2 1 4 1 9-7 4-1h11l4-1 4 1v2l17 4 12 3 4 2v2l5 2 9 3 1 2 7 3 2 4 3 3v2l3 1v2l5 1 3 6 4 5 5 5 3 7 8 11 12 20 4 9 6 13-1 6-14 16-3 6-11 11-8 7-9 6 2 2-7 7-10 6-2-1-1-106-4-7-5-2h-314l-5 3-1 2-1 108-3-4v-104l4-5 5-3h315l8 3 4 6v11h1l2 17v53l1 16-1 7 6-5h3v-2h-2l-1-6v-60l-1-25-4-11v-3h-2l-3-3-5-1v-2l-17-1h-108l-4-3 1-5 3-4 7-3 4-2 2-3h3v-2h2l1-3-4 2-5 3-4 1-1 2-14 4-8 3-8 1h-14l-10-1-8-3-6-1v-2l-10-1-1-5-16-10-15-12-6-8-1-4 5-4z",
    fill: "#081015"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(535,150)",
    d: "m0 0h17l30 1 7 2 12 2 2 7-2 4-2 1h-13l-8-2h-71l-5 2-21 1-5 3h-15v2l-2 1-11 1-9 3-7 1v2l-10 2-3 2-15 5-3 2-5 1-5 3-18 8-3 2h-3v2l-7 3-6 4-6 3-14 8-5 4h-2v2l-13 8h-2l-2 4-13 10-5 6-4 1v2l-8 6-7 8-5 5-6 7-5 5-7 8-7 10-3 3-8 12h-2l-2 5-4 5-3 6-6 10-4 8-4 6h-2v5l-3 4-3 6-4 13-3 5-2 4-3 9-2 7-1 3h-2l-4 16-3 11-1 9-2 2-2 16-2 11-1 15-2 5-1 30 1 40 2 4 2 24 2 8 2 11 3 13 6 18v6h2l2 9 3 7 5 11 8 18 1 5h2l1 7h2l8 14 6 11 6 8 2 5 4 4 7 10 3 3v2l4 2 2 4v3l3 1 4 5 6 4 1 5h2l4 4v2h2l8 8v2l4 2 5 5 3 1 4 5 3 4 8 4 11 10 7 4 6 5 10 6 11 7 7 3 1 2 5 2 6 4 7 3 7 4 9 3 10 4 8 3 1 1 9 1-1 3h10l1 3 11 2 1 1 13 2 5 2 9 1 4 2 22 2 7 2 42 1 36-1 6-2 20-2 5-2 11-1 6-3h10v-2l12-3 5-2 6-2 9-2 2-2 8-3 13-5 13-6 6-1v-2l11-6 11-7 8-4 3-1 1-3 7-3 8-7 5-2 10-8 7-5 7-8 8-7h2v-2l8-7 6-7h2l2-4 2-3h2v-2h2l2-4 4-4h2l2-4 4-6 7-8 5-9 4-4 3-7 7-10 7-11 6-13h2l1-5 2-2 3-9 5-14 3-4 1-6 2-1 4-16 3-5 2-10 2-6 1-10 2-3 1-11 1-3h2v-18l3-8v-78l-3-14-1-12-3-14-3-9-2-12-2-9v-2h-2l-2-12h-2l-1-7-2-2-2-6-2-2-2-9-2-3-2-7-2-6h-2l-3-10-8-11-3-7-7-10-6-10-7-9-3-5-2-4-4-2-2-2-2-5-2-4-6-3-4-7-5-5v-2h-2l-7-8-2-3 1-7 2-2h6v2l4 1 6 5v2h2l5 8 5 3v3h2l7 9v2l4 2 7 10 6 8v3l3 1 4 6 8 14 3 5v2l3 1 4 9 8 17 5 9 2 6 6 16 2 3v7h2l5 13 2 11 2 6 2 10 1 2 1 11 2 3 2 19 2 5 1 35v26l-1 30-2 5-1 15-3 9-1 12-2 2-1 11-2 3-4 16-5 16-2 2-2 7-8 18-2 6-5 9-3 7-2 5-2 1-2 5-7 11-8 13-6 8-3 5-7 9-2 3h-2l-2 4-8 10-7 9-23 23-13 11-12 9-3 3-8 7-9 5-8 6-7 4-9 6h-4l-1 3-6 1v2l-11 6-7 3-8 4-9 3-3 2h-5l-1 3-9 3-7 2-3 2-10 1v2l-10 2-4 2-10 2-2 1-15 2-7 1-1 1-15 1-5 2-30 1h-35l-26-1-3-2-18-1-8-3-11-1-4-2-12-2v-2h-8l-15-5-2-2-8-1-1-2-9-3-8-4-9-3-22-11-9-4-5-4-11-6-9-6-11-8-6-5-7-4-13-12-5-2-2-6-4-1-12-11-5-5-4-5-5-4-4-6v-2l-3-1-7-8-8-11-4-5-1-5h-2l-13-19-6-10v-3h-2l-6-13-2-1-2-6-6-11-3-10-3-3-2-8-5-11-2-7-4-12-3-13-1-2-1-9-3-8-1-13-2-2-1-18-2-5-1-25v-31l1-24 2-8 1-20 1-4h2v-10l3-7 1-10 2-4 2-10 5-15 2-7 4-9 5-12 1-4h2l1-7 4-7 1-2h2v-5l2-2 2-5 3-4 2-5 7-11 6-10 2-5h3l1-4 5-6 3-5 4-5 7-9 14-15 7-8 4-5 8-7h2v-2l6-5 4-4 7-6 4-4 10-7 1-2 5-1v-2l12-8 5-3 6-4h3l1-3 8-5 9-4 3-2h3v-2l7-3 9-5 7-1v-2l16-6 10-5 10-2 9-3 14-4 1-1 11-1 6-3 11-1 8-2 14-1 10-2zm-13 3-28 2-3 1-16 2-25 5-22 6-21 7-12 5-21 9-19 10-25 15-14 10-10 7-8 6v2l-5 2-5 4v2h-2l-12 12-8 7-12 13-4 5-2 1v2h-2l-13 17-4 5-12 17-7 11-9 16-6 10-10 22-9 21-8 25-8 32-3 16-3 24-1 24v29l1 23 2 12 2 18 5 24 7 25 5 16 5 10 3 10 5 9 4 10 11 21 8 13 7 11 8 11 12 16 8 10 5 5 14 15 13 13 8 7h2l2 4 9 7 10 8 12 8 10 7 10 6 9 6 32 16 18 7 10 4 17 6 35 9 22 4 16 2 20 1h44l21-1 39-6 14-4 16-4 7-3 14-4 20-8 15-7 16-8 21-12 13-8v-2l4-2 10-6v-2l5-2v-2l5-2 3-2v-2l4-2 7-6 8-7 5-5 7-6 6-7 2-1v-2h2l5-7 3-3 9-11 11-14 4-5 6-9 4-5 3-6 10-17 5-9 8-17 4-9 2-3 2-7 4-9 4-11 5-17 4-17 3-10 5-32 1-8 1-22v-40l-2-24-3-23-5-22-7-26-3-9-10-26-4-9-9-19-6-11-9-15-7-11-9-12-3-5-10-12-9-11-3-1-3-6h-2l-2-4-8-8-5-2-2 2 1 5 3 4h2v2h2l2 4 5 6h2l2 4 3 4h2l2 4 10 13h2l2 4 6 10 7 10 8 13 6 11 12 24 5 12 5 11 10 30 5 22 3 15 3 19 2 16 1 19v26l-1 22-3 26-2 9-3 15-9 35-3 7-7 20-5 10-1 6h-2l-8 17-7 12-4 7-10 16v2h-2l-5 8v2l-3 1v3l-3 1-5 7v2h-2l-8 10-22 24-16 14-10 8-4 4-6 4v2l-4 1v2l-5 2-15 10-7 5-11 6-19 10-12 6-10 4-12 5-21 7-24 7-30 6-26 3-13 1h-43l-40-4-13-3-23-5-23-7-21-8-10-4-23-11-18-10-13-8-11-7-10-8h-3l-1-3-7-5h-2v-2l-10-8-3-3h-2l-1-3-8-6-1-2h-2l-1-3-6-5-3-4h-2l-2-4-3-4h-2l-2-4-9-11-11-14-6-9-8-11-3-6-6-10-6-11-8-16-6-13-5-13-3-8-9-28-5-22-1-2-2-14-2-15-2-18-1-19v-16l1-24 3-27 5-25 4-17 6-21 5-15 3-5 5-14 16-32 6-9 6-11 5-6 4-7 13-17 8-10 5-6v-2l4-2 4-4v-2h2l7-8 7-6v-2h2v-2h2v-2l4-2v-2l4-2 3-2v-2l4-2 5-3v-2l4-2 15-11 9-6 11-7 12-7 9-5 16-8 11-5 13-5 9-4 30-9 25-6 16-3 28-3h59l27 2 2-2-1-4-6-2-13-2-18-1z",
    fill: "#A10C2F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(548,260)",
    d: "m0 0 22 1 11 7 10 2 1 3 6 1 14 4 22 3 8-3 6 1 8 4 9 3 15 8v4l-2 1-2 5-3 3 1 5 11-2 11 1 2 2-10 9-15 11v43l-1 16-2 8-1 16-2 3-1-3v-19l2-16 1-16-7 2-1 3h-5l-4-4v2h-2l2 5 9 5 1 6v8l-1 6h-1v-5h-2l1 16 1 3h-2l-1 7-3 7-2 1 1-6 2-5v-27l-3-9h-5l-7 10-4 10-2 7-5 3-8-4v-3h-2l-1 10-4 12-9 10-5 3-12 2-16-1-12-6-6-9-2-4-3-18-2-3h-10l-2 3-4 22-6 8-9 6-4 1h-23l-12-6-5-6-5-12-3-7-4 2h-5l-5-6-3-11-6-9-3-4-4 1-2 7-2 9v11l2 10v6h2l3 6v2l-4 1v-3h-2l-1-4 1-2h-2l-2-6 1-2-2-2v-22h2l1-7 3-7 2-2h5l7 8 3 6 3 13 3 4 5-1v-9l2-3 6 1 3 4 4-2 7-1 1-4-1-2-5-1 1-2 10-1v-2h22l5 2v1l14 1 3-1h22l1 1 17-3 2-1h23l8 2h6l10-5 10-4 8-7 1-4 6-3h8l5 1v-14l-1-7-18 7-12 3-16 3-24 1-14-1-9-4-9-2-11-3-5-3-1-1-3 1-12-6-1-3-12-6v-2l-5-1v-4l5 1 7 3v2l6 2v2l8 2 8 3 18 5 16 1 10 3 21 1 19-2v-2l12-2 10-4h2l1-4 5-2-2-4-15-1-3-2h-21l-21-1-2-1v-2h-6v-4h28l6 1v1l24 1v-2l10-4h3l5-5 5-6v-3l2-5h-35l-16-1-26-8-12-5-11-4-21-10-2-2v-3z",
    fill: "#130405"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(635,597)",
    d: "m0 0h13l6 2 12 2 22 8 11 6 5 4 10 7 12 12 9 11 9 14 9 15 9 17 4 11v6l-9 11-14 15-8 7-5 4-7 2-1-1-1-62-1-24-5-13-6-5-5-3-8-1-112-1v-4l6-3h2v-2l7-4 17-13 5-4 7-8 3-3h3z",
    fill: "#199FAF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(520,263)",
    d: "m0 0h16l10 4 16 7 8 5 6 1v2l9 3 11 4 15 3 2 1 25 2h26l-3 6-7 7-4 3h-2v2l-8 1h-27l-16-2-16-4v2h-2v2l-3 1-5-7-11-4v-2h-10l-4-6-8-4-5 2-2 3v7l5 3v2h9l4 5v2l5 1 9 4 5 1h4l2-4h2l2 6 6 3 17 3 11 1h28l5 1-4 4-13 4-13 3-11 1h-23l-23-4-14-4-9-4-17-9-9-5-6-4v-2l-4-2-8-6-13-13-2-3 1-6 6-5 1-4h10l12-5 6-2z",
    fill: "#E26044"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(440,597)",
    d: "m0 0h13l9 8 13 13 5 3v2l5 2 18 12-1 3-4 1-114 1-10 1-6 5h-2l-1 4-3 10v13l-1 21-1 6v42l-2 7-5-2-12-11-9-7-4-4v-2l-3-1-5-8v-8l6-15 3-5h2l2-6 6-12 6-7 7-11 4-6 4-4h2l2-4 5-4 5-6 10-8 15-9 16-7 9-3z",
    fill: "#199FAF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(526,224)",
    d: "m0 0h26l36 3 25 5 27 7 15 6 13 5 30 15 17 11 5 2v2l4 2 9 6v2l5 2 3 2v2h3v2l4 2 5 4 18 18 7 8 4 4v2h2v2h2l14 19 8 11 12 20 9 17 5 11 8 20 8 27 3 12 2 13 2 7 3 28v41l-4 33-5 24-7 24-10 27-6 12-4 9h-2l-1 5-8 14-4 5-1 3h-2l-1 4-10 13-8 11-5 5-4 5h-2l-2 4-20 20h-2v2l-8 7-19 14-10 7-5 3-7 4-13 8-19 9-22 9-26 8-10 2-10 3-27 4-13 1h-44l-24-2-42-9-21-7-13-5-8-4-23-11-19-11-11-8-10-7-16-13-4-3v-2l-4-2-5-5-7-6-7-8-1-3-4-2-7-10-5-5-9-12-7-11-4-5-6-11-12-23-4-10-5-12-5-13-7-27-3-16-2-8-3-32v-32l1-16 3-20 5-25 7-24 3-10 5-12 6-13 8-16 9-16 7-10 3-6h2l4-8h2l2-5h2l2-5 11-12 1-2h2l2-4 18-18 8-6 4-2v-2l17-13 4-3h3v-2l20-12h2v-2l23-11 30-12 19-6 17-4 21-4zm10 2-12 2-20 1h-9l-7 3-11 1-5 2-10 1-4 2v2h-10l-1 2-10 2-12 5-8 3-12 5-8 4-2 2-5 2-14 8-2 4-6 1-12 9-4 1-3 5-11 8-20 18-6 6v2h-2l-6 7v2l-4 2-7 9-5 5-3 5-4 6-6 8-1 5h-2l-5 9-4 7-6 9-5 13-2 2-1 8h-2l-5 16-3 5v5l-2 2-2 12h-2l-1 16h-2l-2 16-2 4-1 27-1 7v20l1 7 1 27 2 5 2 15 1 1 2 14 2 2 2 10 2 2 1 8 3 6 1 5h2l1 6 4 11 4 7 3 7 5 9 7 13 2 3h2l2 5 3 3 5 9 4 7h2v2h2l2 4 13 15 6 7h2l2 4 3 1 2 4 4 3h2l2 4 9 7 4 5 7 5h2l1 3 5 2 5 4 11 7 6 4 11 6 17 9 9 4 9 2 5 3 4 1 8 3 6 3 8 1 3 2 12 2 1 1 13 1 6 3 20 1 13 2h33l8-2 23-1 3-1v-2l16-1v-2l12-1 3-2 10-2 16-6 7-2 7-3 3-2 6-1v-2l6-2 1-2 7-2 2-1v-2l5-1 7-4 4-1 3-3 7-4 1-2 5-2v-2l5-2 3-1 5-5 10-8 9-8v-2l5-1 7-8 5-5 8-10 5-5 3-2 3-5 6-7 4-7 4-5v-2h2l9-16 1-3h2l3-7 5-9 8-17 4-10 3-8 4-12 2-10 3-5 1-10 2-2 1-14 2-3 2-26 2-10v-30l-3-16-1-19-2-2-1-14-2-5-1-8h-2l-2-11-8-24-3-8h-2l-1-7-7-12-3-8-3-1-1-6h-2l-2-6-6-9-6-10-11-14h-2l-2-5-5-5-4-6-3-2-1-3h-2l-2-4-4-1-1-4h-2v-2l-6-5-5-5-4-3h-2v-2l-6-4h-2l-1-3-5-2v-2h-2v-2l-12-7-9-7h-3v-2l-24-12-7-4h-3v-2l-8-3-1-1h-5v-2l-21-6h-3v-2l-9-1h-2v-2l-2-1-9-1-10-3-10-1-4-2-30-1-12-2z",
    fill: "#BF2E27"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(528,213)",
    d: "m0 0h34l6 2 20 1 7 2 14 1 6 3 11 2v1l11 2v2l9 1 5 3 17 5 34 17 18 11 6 5 3 1v2l5 2 5 3v2l8 4 1 2 3 1 5 5 4 3v2l4 2 5 5 8 7 9 11 5 5 9 10 2 3v3l4 2 2 6 3 1 3 5 2 1 2 5 5 9 3 3 3 7 3 4v5h2l5 8 1 8h2l4 8 3 8 3 10 2 3 2 8 4 13 3 13 3 15 2 12 1 13 1 4 1 13v32l-3 27-1 11-2 6-1 10-3 10-4 16-2 4-2 9-2 2-2 8-4 9-3 8h-2l-1 6-4 8-3 5-7 13-7 12-7 9-7 10-2 4h-2l-2 4-7 9h-2l-2 4-3 1-1 4-5 5-8 7-13 13-5 2v2l-6 5-5 4-4 2-3 3-4 2-4 4-6 3-7 5-9 5-7 4-22 11-7 3-9 3-3 2-7 2-9 3-5 2-10 2-12 3-2 1-11 1-8 3-17 1-10 2h-51l-5-2-17-1-15-3-9-2-1-1-12-1v-2l-11-1-7-3-6-2-15-6v-2l-9-1-5-3-16-8-15-9-3-1v-2l-6-2-7-5-3-1-5-5-8-6-9-6v-2l-4-2-8-7-13-12-6-7v-2l-4-2-3-3v-2h-2l-1-4-4-2-16-22-4-5v-3h-2l-8-14-2-3v-3l-3-1v-5h-2l-9-19-3-7-3-6-2-6-3-10-2-6v-4h-2l-8-32-2-13-2-14-2-29v-21l1-6 2-27 2-8 2-14 4-17 2-6 1-5h2v-8l3-4 2-9h2v-6l3-5 4-11 3-4 2-5 8-15 5-9 5-8 1-4 5-5 9-12 5-7h2l2-4 5-7 3-2 1-3h3l2-4 15-15 4-2v-3l7-4 7-7 13-9 8-6 9-6 9-5 3-3 5-2 14-7 13-7 7-1 1-2 8-1v-2l11-4 7-1 2-2 12-3 11-2 3-2 16-2 8-2 18-1 3-1zm-16 4-29 4-16 4-10 2-14 4-23 8-19 8-19 10-20 12-10 7-16 12-14 12-2 1v2l-4 2-15 15-5 6v2h-2l-9 11-4 5-13 18-7 11v3h-2l-9 16-10 21-7 18-7 21-6 24-4 24-2 16v56l2 16 5 28 7 26 9 25 7 16 2 5h2l1 5 6 11 12 20 5 8h2l2 4 10 14 8 10h2l2 4 6 7 8 7 6 6h2l2 4 10 8 11 9 11 8 22 14 11 6 16 8 11 5 16 6 10 4 19 5 9 2 2 1 10 1 13 3 16 2 15 1h29l20-1 27-4 16-4 10-2 18-5 30-12 9-4 13-7 16-9 8-6 7-4 5-4 4-2v-2l4-2 8-6 7-5 30-30v-2h2l11-14v-2h2l9-13 1-3h2l5-9 3-5v-2h2l11-21 7-15 6-14 7-20 5-16 5-24 2-18 1-3 1-12v-51l-1-12-1-2-3-24-5-21-5-16-7-20-8-19-9-17-4-8-9-14-7-10-10-14-12-14-12-13-12-12-8-7-10-8-12-9-15-10-13-8-18-10-22-10-33-11-23-6-16-3-25-3z",
    fill: "#B92A25"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(476,311)",
    d: "m0 0 6 1v2l4 2 12 9 15 9 17 9 18 6 10 3 16 3 20 1 18-1 22-4 22-8h2l2 7v14l-4 1-2-1h-8l-8 5-8 7-6 3-5-1-2-7-5-4-12-4h-31l-5 5 3 7 3 4-1 2-5 1h-47l1-5 3-4v-8l-1-3-32 1-16 6-3 3-1 4 1 4h2l-1 4-9-3-6-4-1-1v-13l2-14 6-18 8-14h2l2-5z",
    fill: "#DE8F70"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(594,620)",
    d: "m0 0 4 1-3 3h-2v2l-3 1-4 4-5 3-4 1-3 4v4l3 2h108l13 1 4 1v2l3-1 5 3v2h2l5 14 1 37v54h2v2l-7 4-3 2 1-15-1-16v-46l-2-16h-1v-12l-3-4v-2l-5-1-3-1h-315l-5 3-3 4-1 104-4-1-6-5v-58l1-36 1-8 3-5 6-4 10-1 9-1h106l15-2 3-2-1-3-5-3-5-2-4-3v-3l-2-1h6v2l9 2v2l9 1 5 2 10 1h14l10-2 12-3 3-2h5l1-3 5-2 4-2z",
    fill: "#010101"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(435,379)",
    d: "m0 0 4 1 6 8 3 5 4 13 3 3 7-1h3l6 15 6 9 12 6h23l7-3 6-4 5-7 4-22 3-4h10l3 4 3 18 5 9 5 5 9 4 16 1 12-2 8-6 5-6 4-12 2-10h2v3l5 2 3 1 5-2 2-10 6-12 5-6h5l3 5 1 8v24l-5 12-4 6-5 4-13 2-2 14-4 15-6 17-7 14-10 13-8 7-10 6-8 4-11 3-7 1h-28l-16-4-14-7-4-3v-2l-5-2-7-8v-2h-2l-9-16-5-13v-5h-2l-5-18-1-14-13-2-8-6-3-6v-2h-2l-3-16v-11l3-15zm213 2-5 8-1 4-2 1-2 7-3 9-3 1h-12l-2 9v4h-2l-2 7-4 2-8 6-6 2h-24l-11-5-3-5-4-1-5-15-2-13-1-1-10 1v18h-2l-4 9-4 5-7 3-5 2h-26l-8-2-7-4-1-4-3-2-1-3h-2l1 9 1 7 8 28 3 3 4 11 3 1v5h2v2l4 3 1 3h2l1 5 5 5 2 1 1 3 9 3 3 2 8 2 1 1 9 2 8 2h18l16-1v-2l8 1 4-3 6-2 7-7 8-12 1-6h2l9-23 5-17 3-11 11-2 8-8 3-5v-7l3-1 1-19-1-10h-1l-2-6z",
    fill: "#BE7D6D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(534,722)",
    d: "m0 0h17l9 4 6 4 5 5 6 8 4 9v16l-2 7-6 10-7 7-12 6-7 2h-11l-10-3-10-7-7-8-5-13v-19l6-12 10-10 11-5z",
    fill: "#010101"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(477,291)",
    d: "m0 0 6 4 13 13 5 4 4 4 5 4 26 13 12 4 10 3 12 1 9 1 2 1h22l21-3 16-5 11-5 1-2h-43l-25-4-6-4-1-5 4-3h11l16 2h39l8-6 3-5 3-3 5 1-4 6-5 4-3 3-9 3h-3v2h-27l-3-2h-16l-12-1v4h6v2l23 1h21l9 1v1l9 1 2 2v3l-5 3-1 3-12 5-12 1v2l-2 1-17 2-21-1-10-3-16-1-18-5-16-6v-2l-6-2v-2l-7-2-5-2v4l5 1v2l5 2 8 4 4 4 8 4 4-1 1 2 7 3 20 5 5 2v1l-8-1-11-2-24-8-21-11-14-9-13-10v-2h-8l-2 5h-2l-2 5-7 14-4 13-2 14v13l7 5 7 2 2-1v-2h-2l-2-6 3-5 14-6 4-1h32l2 3v8l-4 5-1 4 29-1h23l-1-4-4-5v-4l-2-1 7-5h31l12 4 7 6 1 6 6-1 9-6 5-4-1 4-8 7-13 5-7 4-11-1-3-1h-23l-6 2-16 2v-1h-20l-3 1-15-1-4-3-22-1v2l-5 1h-15l-10-5-5-3-2-5v-10l4-20 4-12 7-13 5-6v-3l8-2 5 3 4 3v2l4 2 6 4 1-2 3-1-5-5-1-4-5-2-5-4-2-5-7-3h-3-2l2-4z",
    fill: "#760F1F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(580,542)",
    d: "m0 0 3 1 1 2 2 12 3 11 6 12-2 4-9 6-12 5-9 3-7 2h-20l-17-4-16-8-6-4-2-4 8-18 2-15 3-3 12 2 5 2h30l9-1 12-3z",
    fill: "#DF9071"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(548,260)",
    d: "m0 0 22 1 11 7 10 2 1 3 6 1 14 4 22 3 8-3 6 1 8 4 9 3 15 8v4l-2 1-2 5-3 3 1 5 11-2 11 1 2 2-5 2-8 7-6 1-2 5-4 1-4 4-1 13-4-1-2-3-6-1-8 4-18 6-10-1v2l-4 2-22 1h-21l-8-3-9-2-11-3-5-3-1-1-3 1-12-6-1-3-12-6v-2l-5-1v-4l5 1 7 3v2l6 2v2l8 2 8 3 18 5 16 1 10 3 21 1 19-2v-2l12-2 10-4h2l1-4 5-2-2-4-15-1-3-2h-21l-21-1-2-1v-2h-6v-4h28l6 1v1l24 1v-2l10-4h3l5-5 5-6v-3l2-5h-35l-16-1-26-8-12-5-11-4-21-10-2-2v-3z",
    fill: "#110303"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(631,600)",
    d: "m0 0v3l-3 5h-2l-1 5-4 5-11 7-3 4-5 1 2 6 8 1h89l8 4 7 3 6 4 5 5 1 5 4 1 3 3 3 4 3 5 5 5 5 9 3 5v2h2l3 8 4 5 1 9-7 9-14 15-8 7-5 4-7 2-1-1-1-62-1-24-5-13-6-5-5-3-8-1-112-1v-4l6-3h2v-2l7-4 17-13 5-4 7-8z",
    fill: "#217B89"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(528,213)",
    d: "m0 0h34l6 2 20 1 7 2 14 1 6 3 11 2v1l11 2v2l9 1 5 3 17 5 34 17 18 11 6 5 3 1v2l5 2 5 3v2l8 4 1 2 3 1 5 5 4 3v2l4 2 5 5 8 7 9 11 5 5 9 10 2 3v3l4 2 2 6 3 1 3 5 2 1 2 5 5 9 3 3 3 7 3 4v5h2l5 8 1 8h2l4 8 3 8 3 10 2 3 2 8 4 13 3 13 3 15 2 12 1 13 1 4v37l-1 16-2 13h-1v-63l-1-12-1-2-3-24-5-21-5-16-7-20-8-19-9-17-4-8-9-14-7-10-10-14-12-14-12-13-11-11-8-7-10-8-12-9-15-10-13-8-18-10-22-10-33-11-23-6-16-3-25-3h-55l-29 4-16 4-10 2-14 4-23 8-19 8-19 10-20 12-10 7-16 12-14 12h-2v2l-8 7-10 10-6 8h-2l-2 4-9 10-6 9-10 14-5 8-1 3h-2l-2 5-16 32-7 18-7 21-6 24-4 24-2 16-1 56h-1l-1-15v-29l2-29 2-8 2-14 4-17 1-1 1-11h2v-8l3-4 2-9h2v-6l3-5 4-11 3-4 2-5 8-15 5-9 5-8 1-4 5-5 9-12 5-7h2l2-4 5-7 3-2 1-3h3l2-4 15-15 4-2v-3l7-4 7-7 13-9 8-6 9-6 9-5 3-3 5-2 14-7 13-7 7-1 1-2 8-1v-2l11-4 7-1 2-2 12-3 11-2 3-2 16-2 8-2 18-1 3-1z",
    fill: "#B92A25"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(424,288)",
    d: "m0 0 4 1-3 10-1 1-1 4-2 4v7h-2v8h1v20l-1 12h1l2 11h12l3-3 3-1 2-10 3-10 3-2-1-4 2-8h2l1-6 3-3 1-3h2l2-4 7-7 2-5 5-5h3l8 4 2 4 7 6 2 1 1 3 5 4 1 3-7 2-8-6v-2l-4-2-5-3-8 2v3l-7 10-5 10-4 14-3 16v10l1 5 5 2 10 5 10 1 4 2 2 4h-2v3l-4 2-7 1-1 2-2-5-6-1-1 7v5l-6 1-4-5-3-13-5-8-4-5h-5l-3 4-3 11h-2l1 20 2 4-1 3-4 2 1 7-2-3-3-14-3-15-1-1-4-31-1-40 1-7v-9h2l1-15z",
    fill: "#110303"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(432,591)",
    d: "m0 0 20 1 6 3v2l5 2h3l-2-4 1-4 2 3 7 9 16 12 14 9 1 2-4 1 1 3 4 3 5 2 6 4-2 4-7 2-16 1h-100l-15 1-10 4-2 5-1 8-1 36v53l-2 4-4-2-1-2-4-2-14-14-2-1 1-2 16 14 5 3 1-7v-42l1-6 1-29 1-8 4-11 8-6 10-1 114-1 4-1v-2l-14-9-8-5v-2l-5-2-9-9-8-7-5-5h-13l-22 6-13 5-18 10-9 7-7 6-5 5-4 5h-2l-2 4h-2l-2 5-4 5-4 7-3 4h-2l-2 5-8 16h-2l-8 20-1 6-3-3v-9l4-8 6-10 4-7 4-8 5-9 3-2 1-3h2l2-5 4-7h2l1-3 3-1 1-2h2l1-4 5-5 13-10 3-3 8-5 7-4 13-6 9-3 4-2h8z",
    fill: "#081015"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(475,589)",
    d: "m0 0 8 1 10 7 8 5 18 7 13 3h24l16-4 14-5 21-12 8 1 3 3-6 7-5 4h-2v2l-16 11-16 8-13 4-5 1h-19l-12-2-14-5-16-9-10-7-4-3v-2l-4-2-6-5-1-6z",
    fill: "#ADCFD8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(363,653)",
    d: "m0 0 1 2-2 7v13l-1 21-1 6v42l-2 7-5-2-12-11-9-7-4-4v-2l-3-1-5-8v-8l6-15 3-5h2l2-6 6-12 3-3-1 5-4 6-2 7 5-6 4-7 3-1 3-6 6-3 3-3h2z",
    fill: "#199EAE"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(411,291)",
    d: "m0 0h2l-1 10-3 17-1 26 3 32 5 27 2 13 2 9 5 12 7 8 13 7 3 7 5 21 7 17 9 15 7 8v2h2v2h2v2l4 2 7 6 2 5v8l-3 15-5 10-4 3-25 7-10 2-24 5-19 7-6 3-18 10-10 8-10 9-7 8-5 5-6 7-10 16-9 15-9 19-5 5-9-13-3-5v-3h-2l-12-24-5-14-4-10-3-9-5-18-2-13-1-2-1-10v-74l1-13 2-5 2-12 4-14 2-9 3-7 3-6 2-7 5-10 2-5 6-12 8-14h2l1-4 9-13 5-7h2l2-4 7-9 2-3h2l1-3 5-5h2l1-3h2l1-3 8-7 3-1 2-4 8-6h2l1-3 4-1v-2l9-6 14-9 9-6zm-3 3-9 6-4 2v2h-4l-3 3-10 7-16 12v2l-4 2-10 9-5 4-7 8-11 12-11 14-7 11-9 14-4 6-2 5-4 8-5 11-3 6-4 13-3 7-2 9-4 15-3 17-1 5v76l2 9 2 14 4 15 3 10 3 9 4 11h2l1 7 9 17 2 5 7 11 4 6 4 2 8-16 11-20 8-11 5-7v-2h2l5-6v-2l3-1 7-8 10-9 9-7 10-6 17-8 8-3 9-3 21-4 9-1 14-5 12-3 5-2 6-14 1-5v-17l-15-14-7-8-5-7-10-21-4-12-4-18-4-4-8-4-5-5-6-8-4-10-3-9-1-15-3-12-2-11-1-2-2-29v-14l2-25 2-7v-6z",
    fill: "#8597A8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(600,571)",
    d: "m0 0 2 1 1 5 5 1 4 1 14 1 7 2 17 2 18 4 18 6 16 8 14 9 13 11 7 8v2h2l10 13 2 5h2l5 9 9 15 9 19v4h2l-1 4-5 8h-2l-3-10-6-11-2-6-9-15-7-11-6-8-2-5-1-3-3-1-5-6-2-5-4-1-7-8-2-3-6-3-2-2-8-3-5-3v-2l-16-4-17-5v-2h-7l-3 1h-9l-7 3-6 5-5-1 1-2h2v-6l-2-2-16-2h-4v2l-2-1 1-11z",
    fill: "#030303"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(700,310)",
    d: "m0 0 5 1 10 7v2l4 1v2l4 2 10 8 5 5 7 6 6 7 5 5 8 10v2h2l2 5h2l7 11 4 5 6 11 4 6 2 5 5 9 2 5 5 10 2 7 4 10 2 9 2 4 2 10 2 7 2 11 1 3 1 21v50l-1 21-2 7-2 13-5 15-2 9-4 10-3 9h-2l-1 7-3 5-1 3h-2l-1 6-4 8h-2l-1 5-8 11-5-3-11-23-11-17v-3h-2l-9-13-3-3v-2h-2l-6-8-10-9-14-10-16-8-15-6-15-4-17-3-14-2-16-3-6-3-7-14-3-16v-11l1-4h2l1-3h2v-2l7-6 8-11 9-16 7-19 4-16 2-6 8-4 5-3 7-8 5-10 3-11 1-16 2-8 1-16v-43l13-10 14-12zm1 3-5 3v2l-4 2-12 10-6 4-1 6 1 12v22l-2 23-2 11-1 13-5 12-4 7v2l-4 2v2l-14 7-4 13-5 17-6 15-7 12-13 16-7 6v18l2 10 4 10 4 6 10 3 14 2 3 1 19 2 6 2 10 2 12 4 15 7 16 9 11 10h2v2l5 5 3 1 2 4 8 10 5 8h2l2 5 10 16 11 22h4l10-16 12-27 6-16 6-18 3-12 4-26v-69l-4-24-2-6-2-10-4-13-6-17-5-10-3-7-8-15-5-9-5-7-5-9-13-16-11-13-15-15-8-7-12-10-9-6z",
    fill: "#8597A8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(487,574)",
    d: "m0 0 1 4-2 3h2l1 6 8 5 9 5-4 1-6-3v-2l-5-2-6-3-3-2h-8l-7 3-2 2 1 8 2 1-7-1-4-4-5-2-20-2v4l-11 2-5 3-9 3-13 6-9 6-4 1-2 4-12 9-2 4h-3l-1 4h-2l-1 3h-3l-1 4-4 4-4 7h-2l-1 4-3 1-1 4-5 9-4 7-6 10-6 12-1 8-2-3-3-5 2-11 12-23 12-19 7-9 5-6h2l2-4 12-12 13-10 14-8 12-6 21-7 30-6 9-1h5v-2l8-1h8z",
    fill: "#020202"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(512,217)",
    d: "m0 0h55l25 3 20 4 26 7 21 7 11 5 12 5 19 10 16 10 12 8 14 10 7 6 8 7 12 11 12 12 7 8 9 11 10 14 8 11 9 15 10 19 5 11 7 17 8 23 7 29 3 24 1 2 1 12v51l-1 12-1 3-3 24-4 18-8 25-8 21-8 18-4 6-1-3 4-8 7-15 5-14 1-4h2l1-10 2-2 4-14 2-10 1-2 2-14 1-1 3-28 1-15v-27l-1-13-1-4-1-17-3-12-2-12-1-2-1-9-3-9-3-7-2-9-5-11-2-6-5-10-4-10-11-20v-2h-2l-4-8-4-6v-2h-2l-2-5h-2v-3h-2l-5-8v-2l-3-1-8-10-3-3-5-6-2-1v-3l-3-1v-2l-5-2-3-4v-2l-3-1v-2h-3l-4-4v-2l-5-2-10-9-4-2v-2l-4-2-15-10-13-8-11-6-10-5-15-7-8-3-4-1v-2l-8-1-7-3-9-3-8-2-1-1-9-1-9-3-13-2-4-1-41-3h-20l-34 3-8 2-13 2-16 4-1 1-10 2-9 3-20 8-8 3-14 7-1 2-9 3-14 8h-2v2l-18 11-4 4-6 4-1 2-5 3-3 1-1 3h-2v2l-11 9-3 4h-2v2l-7 6-7 8-2 3h-2l-2 4-8 9-5 8h-2l-2 4-7 11-5 7-2 5-3 5h-2l1-4 2-4h2l1-5 11-16 8-11 9-11 4-5h2l2-4 11-12 9-9h2v-2l14-11 8-7 6-4 11-8 21-13 15-8 13-6 20-8 17-6 15-4 14-3 15-3z",
    fill: "#E55344"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(476,311)",
    d: "m0 0 6 1v2l4 2 12 9 15 9 17 9 18 6 10 3 16 3 20 1 18-1 22-4 22-8h2l2 7v14l-4 1-2-1h-8l-8 5-8 7-6 3-5-1-2-7-5-4-12-4-26-1 2-1-1-3-11-1-17-4-15-5-7-3v-2l-6-1-13-7v-2l-4-1-5-3v-2l-4-1-5-4v-2l-5-2-4-3-4 2-7 10h-2v5l-4 10-2 12-2 6-2 16h3v2h5v-6l3-4 8-3 4 1-9 4-2 6 1 4h2l-1 4-9-3-6-4-1-1v-13l2-14 6-18 8-14h2l2-5z",
    fill: "#AB766A"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(580,542)",
    d: "m0 0 3 1 1 2 2 12 3 11 6 12-2 4-9 6-12 5-9 3-7 2h-20l-17-4-16-8-6-4-2-4 8-18 2-15 3-3 12 2 5 2h30l9-1 12-3zm-55 20-9 2-5 4v-2h-3v2l-6 2-1 7h-2l-2 5 7 4 5 3 7 3 7 1 3 2 5 1h27l10-2 9-4 5-2 7-3v-2l4-1-1-4h-2l-1-6-4-5-5 1-1-3-6-1-12-1-7-1z",
    fill: "#BD7D6D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(484,271)",
    d: "m0 0h13l-5 4-5 6-1 5h-2v2l6 3 3 3v2h2l2 4v3l5 2 9 4 9 6 14 7 4 3 7 3 15 4 1 2 24 3h10l9-1 3-1v-2l-10-2-20-3-8-3-17-5-5-6-3-2v-2l-10-2-4-2-3-3v-7l3-5 4-3h8l12 4 6 6 10 1 9-1 4 4v3l3 1v2l2 1-7-1v2h-2v2l-3 1-5-7-11-4v-2h-10l-4-6-8-4-5 2-2 3v7l5 3v2h9l4 5v2l5 1 9 4 5 1h4l2-4h2l2 6 6 3 17 3 11 1h28l5 1-4 4-13 4-13 3-11 1h-23l-23-4-14-4-9-4-17-9-9-5-6-4v-2l-4-2-8-6-13-13-2-3 1-6 6-5z",
    fill: "#A9624D"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(852,480)",
    d: "m0 0h2l2 10 3 24 1 9v41l-4 33-5 24-7 24-10 27-6 12-4 9h-2l-1 5-8 14-4 5-1 3h-2l-1 4-10 13-8 11-5 5-4 5h-2l-2 4-20 20h-2v2l-8 7-19 14-10 7-5 3-7 4-13 8-19 9-22 9-26 8-10 2-10 3-27 4-13 1h-44l1-2h40l10-2 17-1 5-1v-2l5-1h11v-2l12-2 3-2 10-2 16-6 7-2 7-3 3-2h6v-2l5-2 2-3 9-2v-2l5-2 7-4h4l1-3 6-3 3-1 1-3 5-1v-2l5-3h3l2-4 12-9 9-8 1-2 5-1 2-4h2l2-4 5-5 9-11 5-5 3-1 1-4 7-8 4-7 5-7h2l2-6 5-8 3-5h2l1-5 6-11 8-17 4-10 3-8 4-12 2-10 3-5 1-10 2-2 1-14 2-3 2-26 2-10v-30l-3-16-1-23z",
    fill: "#BE2E27"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(635,597)",
    d: "m0 0h13l6 2 12 2 22 8 11 6 5 4 10 7 12 12 9 11 9 14 9 15 9 17 4 11v6l-2 1-3-9-5-8v-4h-2l-7-12-4-6v-2l-4-2-4-7-3-2v-2l-4-1-2-5-5-5-11-7-6-6v-3h-3l-3-3-6-4-4-1v-2l-5-1-3-1v-2l-5-1-5-2-9-2-7-2-19-3h-7l2-5 2-3h2z",
    fill: "#79A2B3"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(440,597)",
    d: "m0 0h13l5 5v5l-15 2-13 5-6 1v2l-8 1v2l-7 2-1 2-6 2-14 10-15 8-5 4h-2l-1 4-3 5-7 7-5 2-3 6h-3l-2 4-3 5-5 5 1-4 3-7 6-11 4-5 4-7 4-6 4-4h2l2-4 5-4 5-6 10-8 15-9 16-7 9-3z",
    fill: "#79A2B3"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(713,643)",
    d: "m0 0 5 2 8 7 2 2v4l4 1 3 3 3 4 3 5 5 5 5 9 3 5v2h2l3 8 4 5 1 6-10 13-8 7-4-1-2-6-4-8-2-6-4-9-6-16-1-9v-22l-3-2-1-3-2-1v-2l-4-2z",
    fill: "#199FAF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(523,222)",
    d: "m0 0h35l4 1 26 2 8 2 12 1v2l13 2 5 2 9 2 13 4 16 6 3 2 5 1v2l8 2v2l5 1 15 8 4 2v2l6 2 7 5 5 3 9 6v2l5 1v2l11 7 5 5 8 7v2h2v2h2l4 5 2 1v2l3 1 7 8 10 11 7 10v2h2l3 4v2h2l5 9 7 11 8 13 3 6 3 7 5 9 5 14 2 2 5 17 4 14 1 1 3 14 1 1 1 12 2 5 2 25 1 2v45l-3 27-2 7-1 12-3 9-2 7-7 24-3 8-4 9-6 15-3 5-11 21-4 6h-2l-2 6-4 5-4 7-9 11-6 8h-2l2-4 18-24 2-4h2l1-4 8-12 5-11h2l1-5 8-16 10-27 4-13 4-14 4-21 4-33v-41l-3-28-2-7-3-19-8-26-7-20-5-11-8-17-8-14-6-9-7-11-16-21v-2h-2v-2h-2l-7-8-14-15-8-7v-2l-4-2-5-4v-2h-3v-2l-8-4v-2l-5-2-8-6v-2l-6-2-20-12-16-8-13-6-25-10-19-5-16-4-17-3-36-3h-26l-32 3-21 4-13 3-4-1 3-2 13-3 2-1 16-2 6-2 21-1z",
    fill: "#E55144"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(548,260)",
    d: "m0 0 22 1 11 7 10 2 1 3 6 1 14 4 22 3 8-3 6 1 8 4 9 3 15 8-1 3-11-3h-36l-16-1-26-8-12-5-11-4-21-10-2-2v-3z",
    fill: "#3E050F"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(488,362)",
    d: "m0 0h32l2 3v8l-4 5-1 4 29-1h23l-1-4-4-5v-4l-2-1 7-5 4 1-4 2-1 6v2h2v2h17l13 2 11 4-2 4-12-2h-23l-15 3-7-1h-18l-4 1h-7l-14-3h-17l-14 2h-8l-1-3h2v-2h-2l-2-6 3-5 14-6z",
    fill: "#BB7968"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(381,652)",
    d: "m0 0h315l8 3 4 6v11h1v95h-2l-1 3-1-106-4-7-5-2h-314l-5 3-1 2-1 108-3-4v-104l4-5z",
    fill: "#2A363B"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(477,291)",
    d: "m0 0 6 4 13 13 5 4 4 4 5 4 26 13 12 4 10 3 12 1 9 1 2 1h22l21-3 16-5 11-5 1-2h-43l-25-4-6-4-1-5 4-3h11l16 2h39l8-6 3-5 3-3 5 1-4 6-5 4-3 3-9 3h-3v2h-27l-3-2h-16l-12-1v4h6v2l23 1h21l9 1v1l9 1 2 2v3l-5 3-1 3-12 5-12 1v2l-2 1-17 2-21-1-10-3-16-1-18-5-16-6v-2l-6-2v-2l-7-2-5-2v4l5 1v2l5 2 8 4 6 6-5-1-2-1v-2l-5-2-8-3v-2l-14-7 2-1 1-2 3-1-5-5-1-4-5-2-5-4-2-5-7-3h-3-2l2-4z",
    fill: "#550516"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(448,594)",
    d: "m0 0 5 1 3 1v2h2v2h2l4 5 8 7 9 8 15 10 12 6 4 5-3 1-13 1h-110l-10 2-6 4h-2l-2 6-1 1-1 8-1 36v53l-2 4-4-2-1-2-4-2-14-14-2-1 1-2 16 14 5 3 1-7v-42l1-6 1-29 1-8 4-11 8-6 10-1 114-1 4-1v-2l-14-9-8-5v-2l-5-2-9-9-8-7-5-5h-13l-22 6-13 5-18 10-9 7-7 6-5 5-4 5h-2l-2 4h-2l-2 5-4 5-4 7-3 4h-2l-2 5-8 16h-2l-8 20-1 6-3-3 3-9 8-16 9-16 4-7 3-1 1-4 14-18h2l2-4 6-7 14-11 16-10 17-7 12-4 10-2z",
    fill: "#29393E"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(635,595)",
    d: "m0 0h16l22 5 15 6 16 9 11 9 14 14 4 5v2l3 1 9 13 13 21 2 3 2 6 7 15-1 6-2 2-2-9-4-9-10-20-8-13-8-12-13-15-9-9-11-7-5-4-13-6-21-7-10-2-4-1h-13l-1 2-5 3-10 11-24 18h-3v2l-8 4v2l112 1 10 2 8 6 4 6 3 9 1 24 1 62 9-3 9-9 8-7 3-2-2 4-10 10-8 7-10 7-2-2-1-87-3-12-4-5v-2l-5-2-6-3-117-1-7-1-1-2 5-5 9-4 12-8 9-7h2v-2l8-7 3-1 2-4 7-6z",
    fill: "#29373C"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(536,736)",
    d: "m0 0h13l10 6 5 7-1 6-8 5-6 2-16 8-8 3-4-1-3-4v-15l6-10 7-5z",
    fill: "#809AAE"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(512,474)",
    d: "m0 0h5l11 9 6 3 7 2h11l8-3 8-5 6-6h6l3 3v7l-7 9-8 5-8 3-6 1h-15l-9-2-12-6-9-9-1-7z",
    fill: "#110303"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(411,291)",
    d: "m0 0h2l-1 8-1-4-4 1-10 6h-2v2h-4l-1 3-9 6-14 10-10 9-8 7-4 4h-2l-2 4-9 9-9 11-8 10-7 11-9 14-4 6-2 5-4 8-5 11-3 6-4 13-3 7-2 9-4 15-3 17-1 5v76l2 9 2 14 4 15 3 10 3 9 3 8v3h2l3 8 8 16 2 5 7 11 4 6 4 4-3 3-9-13-3-5v-3h-2l-12-24-5-14-4-10-3-9-5-18-2-13-1-2-1-10v-74l1-13 2-5 2-12 4-14 2-9 3-7 3-6 2-7 5-10 2-5 6-12 8-14h2l1-4 9-13 5-7h2l2-4 7-9 2-3h2l1-3 5-5h2l1-3h2l1-3 8-7 3-1 2-4 8-6h2l1-3 4-1v-2l9-6 14-9 9-6z",
    fill: "#C07861"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(520,263)",
    d: "m0 0h16l10 4 16 7 8 5 6 1v2l9 3 11 4 15 3 2 1 25 2h26l-3 6-7 7-4 3h-2v2l-8 1h-27l-16-2-9-2v-1l15-1h8l8-2 7-1 7 3 8-2 4-4-2-3-18-1-9-2-15-1-12-2-5-3-13-3-5-5-5-3-9-3-1-3-5-2-2-1v-2h-17l-14 1-1 1-15 1 3-3 12-4z",
    fill: "#A9624D"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(486,396)",
    d: "m0 0h24l7 1 3 2v13l-3 9-7 4h-19l-5-3-4-5-2-5-1-12 3-3z",
    fill: "#A88986"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(572,396)",
    d: "m0 0h25l6 2 2 3-2 13-3 7-4 3-4 1h-18l-5-3-3-4-2-7v-11l4-3z",
    fill: "#B98275"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(475,589)",
    d: "m0 0 8 1 10 7 8 5 18 7 13 3h24l16-4 14-5 21-12 8 1 3 3-6 7-5 4h-2v2l-16 11-16 8-13 4-5 1h-19l-12-2-14-5-16-9-10-7-4-3v-2l-4-2-6-5-1-6zm0 3-2 3 4 3h3v4l6 4 4 4 7 4 5 3 6 4h4v2l12 4 14 2 2 1h9l19-4 15-7v-2l5-1v-2l4-1 5-4v-2l4-1 5-4 3-3 4-2v-3h-6l-8 5-2 2-11 5v2l-7 1-4 2-8 2-2 1-9 1h-24l-16-4-9-3h-3v-2l-7-3-6-4-10-7z",
    fill: "#7E9BAE"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(536,734)",
    d: "m0 0h13l7 3 7 5 4 8 1 13-3 10-3 4h-2v2l-8 5-5 2h-11l-11-6-2-4-3-1v-2h-2l-3-10 1-9 2-7 8-9zm0 2-10 5-6 8-2 4v15l4 5 9-2 17-8 2-2 6-2 7-4 1-6-6-8-9-5z",
    fill: "#2A373C"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(367,651)",
    d: "m0 0 1 3v7h3v-6l7-3h3l-8 8-1 104-4-1-6-5v-58l1-36 1-8z",
    fill: "#091116"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(363,653)",
    d: "m0 0 1 2-2 7v13l-1 21-1 6v42l-2 7-5-2-12-11-9-7-4-4v-2l-3-1-5-8v-8l6-15 3-5h2l2-6 6-12 3-3-1 5-4 6-3 8-6 13-3 9v8l6 8 5 5v2h5l2-3 1-5h2l1-5 3-10 5-12h2l1-36 3-1z",
    fill: "#227886"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(700,310)",
    d: "m0 0 5 1 10 7v2l4 1v2l4 2 10 8 5 5 7 6 6 7 5 5 8 10v2h2l2 5h2l7 11 4 5 6 11 4 6 2 5 5 9 2 5 5 10 2 7 4 10 2 9 2 4 2 10 2 7 2 11 1 3 1 21v50l-1 21-2 7-2 13-5 15-2 9-4 10-3 9h-2l-1 7-3 5-1 3h-2l-1 6-4 8h-2l-1 5-8 11-3-3 5-5 8-13 12-27 6-16 6-18 3-12 4-26v-69l-4-24-2-6-2-10-4-13-6-17-5-10-3-7-8-15-5-9-5-7-5-9-13-16-11-13-14-14-8-7-12-10-9-6z",
    fill: "#BF7761"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(437,432)",
    d: "m0 0 8 5 9 1 4 2 3 18 3 10v4h2l4 13 8 16 2 5h2l7 9 5 3v2l18 9 16 4h28l15-3 10-4 9-6 8-6 9-11 6-10 8-20 6-24 2-9 8-2h5v2l-6 2-4 3-2 6v5h-2l-1 8-4 15-6 13 1 2-2 1-1 3-2 4-3 4-1-1-8 10-7 6-1 2-4 2-5 5-5 3-9 1-26 4h-9l-7-1-5-1-15-5-13-7-10-9-9-10-7-12-6-15-3-2v-4h-2l-2-22-3-8-1-1-10-2-3-2v-2h-2z",
    fill: "#600C1C"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(499,65)",
    d: "m0 0h89l17 3 13 1 3 2 14 1 4 2 12 2 5 2 10 2 1 1 12 2 9 3 3 2 9 2 3 2 7 2 8 3 10 4 8 4 7 3 6 3 9 4 18 9v2l-6-2-7-3-1-2-6-2-14-7-18-8-10-4-6-2-10-4-9-2-3-2-10-3-2-1-9-1-3-2-9-1-5-2-12-2-5-2-15-2-2-1-22-2-8-2h-80l-20 3-14 1-5 2-12 1-5 2-13 2-5 2-10 2-12 3-4 2-7 1-2 2-9 2-10 4-12 5-11 4-12 6h-5l-1 3-7 3-10 5h-3v2l-6 3-8 5-7 4h-3v2l-15 9-1 3-3 1-5 5-4 2-1 2h-3l-1 3-5 1-8 6-7 6-2-1 3-3h2l1-3 10-7 4-2v-2l11-7 5-4 9-6 7-4h2l1-3 10-5 12-7 3-2h4v-2l14-7 7-3 5-2h3v-2l9-4 7-2 2-2 7-2 13-5 7-2 1-1 10-2 5-2 8-2 2-1 12-1v-2l13-2 5-2 12-1 5-2 21-2z",
    fill: "#959098"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(581,633)",
    d: "m0 0m-4 1h4v2l-4 4v1l7 1 117 1 11 6 5 7 3 12 1 89 4 1-7 7-10 6v-92l2 4 1 13v46l1 16-1 7 6-5h3v-2h-2l-1-6v-60l-1-25-4-11v-3h-2l-3-3-5-1v-2l-17-1h-108l-4-3 1-5z",
    fill: "#091116"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(704,272)",
    d: "m0 0 5 2 7 5 7 2 10 7v2l5 2 3 2v2h3v2l4 2 5 4 18 18 7 8 4 4v2h2v2h2l14 19 8 11 12 20 9 17 5 11 8 20 8 27 3 12v10l1 8-3-2-1-14-2-5v-8h-2l-7-24-2-3-2-8-2-6v-2h-2l-3-8-6-11-3-8-2-1-1-6h-2l-3-6-6-9-6-10-10-13-3-3-2-5-4-2-4-6-4-3v-3h-2l-4-4-2-1-1-3-2-1v-2l-4-2-4-5-9-6v-2l-8-4-4-4-2-1v-2h-2v-2l-6-2-11-8-7-4z",
    fill: "#BB2B26"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(694,313)",
    d: "m0 0 2 2-11 9-12 9v43l-1 16-2 8-1 16-2 3-1-3v-19l2-16 1-16-7 2-1 3h-5l-3-4-13 1 4-3 2-1h8l5 1v-14l-1-7-18 7-12 3-16 3-24 1-14-1v-1l42-2 4-1v-2h10l12-4 10-4 4-2 6 1 2 4 4 1v-13l3-4h2l1-2h3l2-4 4-2 5-1 2-4z",
    fill: "#0F0708"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(474,587)",
    d: "m0 0h8l17 11 11 5 19 6 17 1 15-1 16-5 19-9 9-6 13 1 2 3-1 5-7 7-4 3h-2l-1 3-15 10-9 5-15 6-18 3h-9l-16-3-19-7-17-11-15-12-6-8 1-4zm1 2-6 2 1 6 8 7h2v2l8 6 16 10 16 7 7 2 9 1h19l16-4 16-8 11-7 7-5v-2l5-2 8-8-1-3-6-2-6 1-11 7-18 8-14 4-6 1h-24l-15-4-16-6-17-11-4-2z",
    fill: "#29373C"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(828,696)",
    d: "m0 0 1 3-7 13h-2l-2 6-5 7-1 3h-2l-2 4-8 12h-2l-2 4-7 9-2 3h-2l-2 4-24 24-7 6-10 8-4 3h-2l-1 3-7 4-5 4-7 4-9 6-11 6-15 8-7 3-25 10-15 5-11 3-9 2-20 4-21 3-20 1h-29l-21-2-21-3-2-1-10-1-5-2-9-2v-1h10l9 3 9 1 7 2 21 2 6 1h46l13-2 15-1 19-4 5-2 10-2 1-1 10-2 20-7 12-5 5-3 13-5 16-9 10-6 15-10 11-8 11-9h2v-2l11-9 4-5 8-7 5-5 10-12 10-13 14-20 5-9h2l2-5 4-8z",
    fill: "#E55443"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(666,293)",
    d: "m0 0 9 2 3 1v2l2 1h-2l-2 5-3 3 1 5 11-2h5l-4 5-13 1-5-2v-2l-5 2-8 2-1 2h-2l-1 5 7 2v5l-4 1-2-4-15-1-3-2h-21l-21-1-2-1v-2h-6v-4h28l6 1v1l24 1v-2l10-4h3l5-5 5-6v-3z",
    fill: "#100303"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(326,306)",
    d: "m0 0m-1 1m-1 1m-1 1m-1 1m-1 1m-1 1m-1 1m-1 1m-1 1v3l-5 5-5 6-7 8-2 3h-2l-2 4-5 7-2 5-8 11-4 7-1 2h-2l-2 5-10 18-3 5-5 11-3 9h-2l-1 7-4 10-2 4v5l-2 2-3 12h-2l-1 16h-2v9l-2 9-2 3-2 24-1 37-2-2v-32l1-16 3-20 5-25 7-24 3-10 5-12 6-13 8-16 9-16 7-10 3-6h2l4-8h2l2-5h2l2-5 11-12 1-2h2l2-4z",
    fill: "#BC2C26"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(318,301)",
    d: "m0 0h2v2l-8 7-10 10-6 8h-2l-2 4-9 10-6 9-10 14-5 8-1 3h-2l-2 5-16 32-7 18-7 21-6 24-4 24-2 16-1 56h-1l-1-15v-29l2-29 2-8 2-14 4-17 1-1 1-11h2v-8l3-4 2-9h2v-6l3-5 4-11 3-4 2-5 8-15 5-9 5-8 1-4 5-5 9-12 5-7h2l2-4 5-7 3-2 1-3h3l2-4 5-3z",
    fill: "#BA2B25"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(647,379)",
    d: "m0 0h5l3 5 1 8v24l-5 12-4 6-5 4-13 2-2 14-4 15-6 17-7 14-7 9v-3l3-7 4-9h2l3-10 5-13 5-17 3-11 5-2h7l1-3 4-2 5-8 1-7 2-1 1-19-1-9h-1l-1-6h-3l-4 7-2 5h-2v7h-2l-1 7-2 3-3 1h-7l-5-1-1 9-1 4h-2l-2 7-12 9-6 2h-24l-12-6 1-3 11 5 16 1 12-2 8-6 5-6 4-12 2-10h2v3l5 2 3 1 5-2 2-10 6-12z",
    fill: "#BA7766"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(578,540)",
    d: "m0 0h6l2 2 2 14 2 2h1v6l3 8 3 7v5h-2l-1 3-14 7-13 5-4 2-8 1-3 1h-16v-2h-8l-12-4h-2l-9-3v-3l-10-5-3-5 7-16 3-9 1-12 2-3 11 1 9 3h29l15-2zm2 2-7 3-9 2-9 1h-30l-5-2-12-2-3 3-2 15-6 13-2 7 6 5 16 8 9 3 10 2h20l15-4 20-10 4-4-2-6-5-10-3-12-1-9-3-3z",
    fill: "#710D1D"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(918,248)",
    d: "m0 0h2l8 11 7 10 1 3h2l3 6 5 7 3 5 1 4h2l6 12 5 8 13 26 2 5v3h2l3 7 3 8 4 10 5 15 3 7 1 7 2 3 2 10 2 3 1 9 2 3 2 13 2 6 1 12 2 3 1 16 2 7 1 12 1 51-1 37-1 9-1 2-2 21-2 5-2 16-2 5-1 9-2 4-2 10-2 6-2 7-3 11-3 4v-5l2-3 2-9 1-1 2-11 2-4 2-9 3-15 2-7 1-11 2-5 1-16 2-8 1-13v-74l-1-13-2-7-1-18-2-4-2-16-2-5-1-10-2-3-1-9-3-6-1-8-2-3-2-8-2-5-2-6-3-10-4-9-6-15-2-2-2-6-3-7-2-4v-3h-2l-9-19-3-3-4-8v-2h-2l-3-6-5-8v-2h-2l-3-6-8-10-3-5-7-9z",
    fill: "#9D8C8F"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(488,362)",
    d: "m0 0h25l5 3 2 6-4 5-24 1-9 2-5 2h-7l-3-3-1-4 3-5 14-6z",
    fill: "#680A1B"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(653,346)",
    d: "m0 0 4 1 1 1 1 13-1 1-14 1-5 3h-4l-2 4-3 4-7 1-3-6-12-6-12-2 4-2 12-2 14-1 4-2 14-3 3-2h5z",
    fill: "#DE8F70"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(536,289)",
    d: "m0 0 7 2 6 5 1 3 10 1v2l6 1 8 8-2 9-7 1-10-4-6-3-4-6-9-1v-2l-5-2-1-1v-7l4-5z",
    fill: "#460512"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(458,603)",
    d: "m0 0 4 2 13 13 5 3v2l5 2 18 12-1 3-4 1-121 1 5-4 16-2 22 1h53l16-1v-3l-9-6v-2l-6-2-9-9-6-5z",
    fill: "#217B89"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(137,288)",
    d: "m0 0 1 3h-2l-1 5-6 9-6 11-8 16-3 5-6 15-5 11-3 7-5 15-2 4-2 7-5 15-2 9-3 13-2 7-2 10-1 3-2 15-1 2-2 23-2 11v77l2 11 2 24 2 4 1 12 2 5 2 12 2 4 1 10 2 3 2 10 2 5 2 7 3 10 8 20-1 4-3-5-2-7-4-10-2-9-2-2-2-9-2-5-1-7-2-3-2-12-2-5-2-11-1-2-1-13-2-4-2-22-2-10v-87l2-11 2-21 2-5 1-12 2-5 2-13 2-3 1-9 2-4 2-10 2-4 2-7 3-11h2l2-10 3-8 4-9 6-15 2-2 2-6h2l1-6 4-8h2l1-6 5-8 6-10 3-6z",
    fill: "#93919A"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(810,358)",
    d: "m0 0 4 2 7 11v2h2l3 3 3 7 3 4v5h2l5 8 1 8h2l4 8 3 8 3 10 2 3 2 8 4 13 3 13 3 15 2 12 1 13 1 4v37l-1 16-2 13h-1v-63l-1-12-1-2-3-24-5-21-5-16-7-20-8-19-9-17-4-8-9-14z",
    fill: "#BD2D27"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(474,295)",
    d: "m0 0h3l8 4 2 4 7 6 2 1 1 3 5 4 1 3-7 2-8-6v-2l-4-2-5-3-8 2v3l-7 10-5 10-5 1-1-1-1-7-1-2 2-5 2-1 1-3h2l2-4 7-7 2-5z",
    fill: "#110304"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(689,311)",
    d: "m0 0h7l2 2-5 2-8 7-6 1-2 5-4 1-4 4-1 13-4-1-2-3-3-1v-2h-3v-8l2-6-8-1 2-6h2l1-3 10-2 3-1 1 2 7 1 10-1z",
    fill: "#010101"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(415,300)",
    d: "m0 0 3 2-1 3v56l1 3h2l1 6 5 1 2 5-6 15-1 10-1 2h2l3 11 1 7h-2l1 7-2-3-3-14-3-15-1-1-4-31-1-40 1-7v-9h2z",
    fill: "#010101"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(496,217)",
    d: "m0 0h11l-3 2-26 4-11 3-10 2-14 4-23 8-19 8-19 10-20 12-10 7-16 12-14 12-5 2-13 13-2-1 14-14 4-2v-3l7-4 7-7 13-9 8-6 9-6 9-5 3-3 5-2 14-7 13-7 7-1 1-2 8-1v-2l11-4 7-1 2-2 12-3 12-1 10-3 13-2z",
    fill: "#BA2B25"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(255,384)",
    d: "m0 0 1 4-3 4-6 13-4 8-2 6-4 9-3 10h-2l-1 9-2 3-2 10-2 6-3 12-2 16-1 2-2 32-1 5v22l1 5 2 31 1 1 3 20 2 10 3 7 1 11h2l1 9h2l3 10 4 9 3 8 4 8v4h-2l-7-16-9-24-8-27-5-26-2-19-1-4v-56l4-28 4-20 6-23 4-13 5-11 7-17 10-19z",
    fill: "#E55443"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(498,640)",
    d: "m0 0m-114 1h114l-2 2h-110l-10 2-6 4h-2l-2 6-1 1-1 8-1 36v53l-2 4-4-2-1-2-4-2-14-14-2-1 1-2 16 14 5 3 1-7v-42l1-6 1-29 1-8 4-11 8-6z",
    fill: "#2A373C"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(320,776)",
    d: "m0 0 4 2 4 3v2l4 2 13 11 17 12 14 9 16 9 21 10 14 6 13 4 8 3 10 3 28 6 9 2 24 2h44l21-2h8v2l-32 3-2 1h-30l-16-2-16-1-12-3-11-1-4-2-9-1-8-3-7-2-21-7-9-4-14-6-13-7-14-8-5-3-5-4-7-4-3-3-5-3-18-14-3-2v-2h-2l-5-5z",
    fill: "#E55543"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(576,272)",
    d: "m0 0 5 1 1 4h13l5 2 13 1v1l11 1h13l5-1 19 7v3h-29l-22-1v-1l-16-4-3-2-7-2v-3h-6l-2-1-1-4z",
    fill: "#100202"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(445,240)",
    d: "m0 0h3l-1 3-10 2-12 5-8 3-12 5-8 4-2 2-5 2-14 8-2 3-7 3-11 8h-4l-1 4-18 14-17 16-4 5h-2l-2 4-4 5-5 5-9 11-2-1 8-11 5-5 3-4h2l2-5h2l2-4 5-5 7-8 12-11h2v-2l17-13 4-3h3v-2l20-12h2v-2l23-11 17-7 10-2 4-2z",
    fill: "#C33129"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(413,294)",
    d: "m0 0h2l1 6-2 8-1 1v8l-1 8 1 39 3 22v9l2 1 3 15 3 14 2 5 1 7 3 3v2h2l-1 3-8-10-5-13-2-16-5-24-3-24-1-14 1-26 4-22z",
    fill: "#0D1116"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(986,370)",
    d: "m0 0 3 4 3 10 2 6 3 7 2 8 1 1 2 10 2 4 1 9 2 3 2 13 2 8 1 10 2 4 1 18 2 7 1 13v74l-1 13-2 8-1 16-2 5-2 16-2 5-2 12-3 12-2 4-1 8-3 7h-1v-7l2-3 2-10 2-5 1-8 2-3 1-12 1-2h2v-11l1-8 2-2 1-19 1-8 1-1 1-31v-29l-1-26-2-9v-23l-3-1-1-5-1-14-2-3-1-10-2-4-1-10-3-5-2-10-3-9-2-3v-7h-2l-2-9-2-2z",
    fill: "#521825"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(636,595)",
    d: "m0 0h15l22 5 15 6 16 9 11 9 14 14 4 5v2l3 1 9 13 13 21 2 3 2 6 7 15-1 6-2 2-2-9-4-9-10-20-8-13-8-12-13-15-9-9-11-7-5-4-13-6-21-7-10-2-4-1-13-1z",
    fill: "#284047"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(726,982)",
    d: "m0 0 2 1-7 3-10 4-9 3-10 4-9 2-3 2-10 2-3 2-9 1-4 2-13 2-4 2-13 1-4 2-20 2-12 2-47 1-45-1-16-3-13-1-5-2-14-1-8-3-10-1-4-2-10-2-5-2-8-2-1-1-9-2-5-2v-1l7 1 10 3 1 1 10 2 5 2 9 2 15 3 7 2 12 1 5 2 21 2 12 2h78l16-2 4-1 17-1 4-2 17-2 5-2 9-1 3-2 10-1 5-3 10-2 10-3 9-3 3-2 7-2 10-4z",
    fill: "#8996A4"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(859,512)",
    d: "m0 0h1l2 8v45l-3 27-2 7-1 12-3 9-2 7-7 24-3 8-4 9-6 15-3 5-11 21-4 6h-2l-2 6-4 5-4 7-9 11-6 8h-2l2-4 18-24 2-4h2l1-4 8-12 5-11h2l1-5 8-16 10-27 4-13 4-14 4-21 4-33z",
    fill: "#E55144"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(265,490)",
    d: "m0 0h1l-1 9-1 5v76l2 9 2 14 4 15 3 10 3 9 3 8v3h2l3 8 8 16 2 5 7 11 4 6 4 4-3 3-9-13-3-5v-3h-2l-12-24-5-14-4-10-3-9-5-18-2-13-1-2-1-10v-74z",
    fill: "#C67C64"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(534,722)",
    d: "m0 0h17l9 4 6 4 5 5 6 8 4 9v16l-2 7-6 10-7 7-12 6-7 2h-11l-10-3-10-7-7-8-5-13v-19l6-12 10-10 11-5zm5 2-12 2-10 7-8 9-3 8-1 2v14l3 10 4 7 5 4 5 5 9 4 3 1h15l9-3 10-7 7-9 4-10v-17l-5-10-6-8-11-7-9-2z",
    fill: "#2A373C"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(223,453)",
    d: "m0 0h1v6l-2 5-4 18-2 14-1 3-2 29v44h2l2 16 5 28 7 26 3 9 1 7 6 17 3 5-1 3-4-7-3-9-4-9-2-8-2-6v-4h-2l-8-32-2-13-2-14-2-29v-21l1-6 2-27 2-8 2-14 4-17z",
    fill: "#B32623"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(512,474)",
    d: "m0 0h5l11 9 6 3 7 2h11l8-3 8-5 6-6h6l3 3v7l-7 9-8 5-8 3-6 1h-15l-9-2-12-6-9-9-1-7zm62 3-1 3-4 1-6 4-3 3-9 3-11-1-12-4-6-4-3-3-6 1-1 5 8 7 5 4 9 2v1h20l7-3 1 2 9-4 5-4v-2l3-1 2-4v-5l-1-1z",
    fill: "#6C0B1B"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(534,730)",
    d: "m0 0 13 1 2 1h11l-1 4 6 5 4 8h1l1 14-3 10-5 8-7 4-3 2-5 1h-12l-8-3-8-6v-2h-3l-4-12-1-13h3l1-5 2-5h2v-4l8-3 5-3zm2 4-10 4-8 9-3 10 1 9 2 7h2l1 3h2l2 4 11 6h11l10-5 3-2v-2l3-1 3-5 2-11-2-13-3-5-10-7-4-1z",
    fill: "#091116"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(578,363)",
    d: "m0 0h14l10 2 9 3 5 3 1 5-1 2h-8l-16-4h-18l-4-3 1-5 2-2z",
    fill: "#100304"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(511,472)",
    d: "m0 0h9l4 5 11 7 5 1v2h15v-2l4-2h5l-5 4-7 2h-11l-10-3-8-6-6-5h-5l-3 3 1 7 8 8 14 7 7 1h15l9-2 10-5 3-1 2-4 4-5v-7l-2-2h-6l-7 7v-3l7-7 7 1 3 3v11l-7 8h-3l-1 3-6 4-9 2-4 1h-16l-15-4-3-3-7-4v-3l-4-1-3-6v-8z",
    fill: "#B4705E"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(368,668)",
    d: "m0 0h3l1 96-4-1-5-4 2-5 2-6v-9l-1-1v-68z",
    fill: "#010101"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(782,752)",
    d: "m0 0h2l-2 4-11 12-9 9h-2v2l-8 7-8 8-7 4-10 8h-2v2l-18 11-11 6-10 6-6 3-5 2h-3v2l-8 3-9 4-19 6-7 2-6 2-2 1-10 1-3 2-16 1 3-2 10-2 11-3 14-3 24-8 24-10 17-9 8-5 7-4 5-3 14-10 16-12 5-5h2v-2l8-7 15-15z",
    fill: "#E54E45"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(224,592)",
    d: "m0 0 2 3 3 17 5 20 4 13 8 22 4 8 8 17 9 16 6 9 7 11 11 14v2l3 1 8 11 10 10v2l4 2 4 4v2l-4-2-12-12v-2l-4-2v-2l-4-2v-2h-2l-6-9-4-5v-2h-2l-5-8-5-6-5-9-9-15-8-17-5-9-6-16-4-11-4-13-3-9-2-12-2-4z",
    fill: "#E55244"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(476,311)",
    d: "m0 0 6 1v2l4 2 12 9 15 9 13 7-3 1-15-8-6-2-5-3v-2l-4-1-5-4v-2l-5-2-4-3-4 2-7 10h-2v5l-4 10-2 12-2 6-2 16h3v2h5v-6l3-4 8-3 4 1-9 4-2 6 1 4h2l-1 4-9-3-6-4-1-1v-13l2-14 6-18 8-14h2l2-5z",
    fill: "#B36F5C"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(440,856)",
    d: "m0 0 8 1 20 5 2 1 10 1 13 3 16 2 15 1h29l20-1 14-2h5v2l-2 1-14 1-1 1-10 2h-51l-5-2-17-1-15-3-9-2-4-2-8-2-16-5z",
    fill: "#C33129"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(647,376)",
    d: "m0 0h5l4 5 1 3 2 25 1 3h-2l-1 7-3 7-2 1 1-6 2-5v-27l-3-9h-5l-7 10-4 10-2 7-5 3-8-4v-3h-2l-1 10-4 12-9 10-5 3-4-1 2-4 4-1 7-6v-2l3-3 5-24 2-3h5l2 9 1 2h3l1-2 2-2 3-11 2-1 2-5z",
    fill: "#5E0B19"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(434,376)",
    d: "m0 0h5l7 8 3 6 3 13 3 4h6l2-4h3v2h2l4 10 5 15 8 4 1 3-6-2-5-4-6-10-5-13-4 2h-5l-5-6-3-11-6-9-3-4-4 1-2 7-2 9v11l2 10v6h2l3 6v2l-4 1v-3h-2l-1-4 1-2h-2l-2-6 1-2-2-2v-22h2l1-7 3-7z",
    fill: "#7B1020"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(461,578)",
    d: "m0 0h2v2l-9 3-17 3-15 3-19 7-6 3-18 10-10 8-10 9-7 8-5 5-6 7-10 16-9 15-9 19-4 1 9-19 10-18 8-11 6-9h2l2-4 11-12 3-3h2l1-3 11-9 9-6 19-10 11-4 9-3 21-4 9-1z",
    fill: "#8A95A2"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(771,322)",
    d: "m0 0 5 3 8 8 11 14 2 5h2l3 4v2h2l5 9 7 11 8 13 3 6 3 7 5 9 5 14 2 2 5 17 4 14 1 1 3 14 1 1 1 12 2 5 1 19-2 2-3-24-2-10-3-13-7-24-7-20-5-11-8-17-8-14-6-9-7-11-16-21v-2h-2v-2h-2l-7-8-4-4z",
    fill: "#E54D45"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(800,362)",
    d: "m0 0 5 5 8 12 5 5 9 17 7 15 8 20 8 27 3 12v10l1 8-3-2-1-14-2-5v-8h-2l-7-24-2-3-2-8-2-6v-2h-2l-3-8-6-11-3-8-2-1-1-6h-2l-3-6-6-9-5-8z",
    fill: "#C13028"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(477,308)",
    d: "m0 0 6 2 5 4v2l4 2 7 6 8 4 3 2v2l5 1 8 4v2l11 3 4 1 2-1 1 2 7 3 20 5 5 2v1l-8-1-11-2-24-8-21-11-14-9-13-10v-2h-8l-2 5h-2l-2 5-7 14-4 13-4 28-2-3v-10l4-20 4-12 7-13 5-6v-3z",
    fill: "#690D1D"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(908,430)",
    d: "m0 0 2 2 3 12 1 1 3 15 3 16 1 3 2 19 2 12v62l-1 12-2 8-2 16-3 18-2 5-5 21-3 12h-2l-2 8-1-4 3-7 11-43 2-14 1-2 3-26 1-22v-26l-1-19-3-25-5-25-5-22z",
    fill: "#E33050"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(255,397)",
    d: "m0 0 1 3-6 12-7 17-4 11-4 12-7 28-3 16-2 16-1 16v32l2 21v11h-2l-1-7-2-31v-20l2-33 2-6 1-13 3-10 1-8h2l2-12 6-19 5-12 5-11v-3l3-3z",
    fill: "#E55443"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(381,651)",
    d: "m0 0h319l8 6 2 4-1 11-2 1v-12l-3-4v-2l-5-1-3-1-315-1z",
    fill: "#091116"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(477,291)",
    d: "m0 0 6 4 13 13 5 4 4 4 5 4 26 13 12 4 13 4v2l-11-2-10-3-16-6v-2l-6-2v-2l-7-2-5-2v4l5 1v2l5 2 8 4 6 6-5-1-2-1v-2l-5-2-8-3v-2l-14-7 2-1 1-2 3-1-5-5-1-4-5-2-5-4-2-5-7-3h-3-2l2-4z",
    fill: "#3A040E"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(569,362)",
    d: "m0 0 4 1-4 2-1 6v2h2v2h17l13 2 11 4-2 4-12-2h-23l-15 3-7-1h-18l-4 1h-7l-3-2h8l3-1h30l4-2h4l-1-4-4-5v-4l-2-1z",
    fill: "#B27869"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(637,438)",
    d: "m0 0h5v2l-6 2-4 3-2 6v5h-2l-1 8-4 15-6 13 1 2-2 1-1 3-2 4-3 4-1-1-8 10-7 6-1 2-4 2-5 5-5 3-9 1-4-1 12-4 5-5 9-5 9-8 9-13 7-14 6-17 5-25 3-3z",
    fill: "#690E1D"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(696,657)",
    d: "m0 0 3 1v4h-3l-2 4-5 5-10 7h-2v2h-2v2l-5 3-5 5-7 4h-2l-2 4-20 13-9 7-10 7-5 1v2l-17 10-8 4h-2l2-4 5-1v-2l13-6 2-3 9-3 1-3 8-4 1-2 3-1 2-3 7-4 9-6h3v-2l6-2 2-4 6-4h2v-2l3-1 4-4 1-3 9-5 4-1 1-3 4-4 1-6h5z",
    fill: "#ADCFD8"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(528,213)",
    d: "m0 0h34l6 2 20 1 7 2 14 1 6 3 5 1v1h-7l-10-3h-11l-25-3h-71l-9 2-13 2-6 2h-5l4-2 3-2 16-2 8-2 18-1 3-1z",
    fill: "#BB2C26"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(668,364)",
    d: "m0 0 2 1-2 27-2 22-2 2-1-1v-8l1-4-3-5v-17l-1-3-8-4-2-3v-3h2v-2l-2-1 4 1 2 4 5-1-1-2 5-2z",
    fill: "#010101"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(419,837)",
    d: "m0 0h7l5 3 4 1 8 3 6 3 8 1 3 2 12 2 1 1 13 1 6 3 20 1 13 2h33l8-2h21v1l-17 1-10 2h-53l-16-2-29-6-11-3-3-1v-2l-11-3-13-5-5-2z",
    fill: "#B82A25"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(821,523)",
    d: "m0 0h1v65l-2 7-2 13-5 15-2 9-4 10-3 9h-2l-1 7-3 5-1 3h-2l-1 6-4 8h-2l-1 5-8 11-3-3 5-5 8-13 12-27 6-16 6-18 3-12 4-26z",
    fill: "#C07862"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(667,834)",
    d: "m0 0h4v2l-22 9-26 8-10 2-10 3-27 4-13 1h-44l1-2h40l10-2 17-1 5-1v-2l5-1h11v-2l12-2 3-2 10-2 16-6 7-2 1-1 8-1z",
    fill: "#BD2D26"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(475,589)",
    d: "m0 0 8 1 10 7 8 5 3 1 4 4 17 5 11 2h19l13-3 4 1-7 3-9 1h-24l-16-4-12-4v-2l-7-2-6-4-10-7h-6v3l5 2v4l5 2 5 5 7 4 5 3 6 4-1 2-5-1-17-11-5-4v-2l-4-2-6-5-1-6z",
    fill: "#7F9AAE"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(328,781)",
    d: "m0 0 4 2 10 8 7 4 4 4 5 2 5 4 11 7 6 4 11 6 17 9 9 4 2 1v2l5 1 13 5 9 3 2 2-7-1-9-3-13-5-8-4-23-11-19-11-11-8-10-7-16-13-4-3z",
    fill: "#BB2C26"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(448,235)",
    d: "m0 0h8l-4 2-23 8-24 10-16 8-5 1v2l-17 10-5 2v2l-7 4-13 10-4 2v2l-10 8-8 7-13 13-1 2h-2v-3l5-5h2l1-3h2l1-3h2l1-3h2v-2l5-5h3l1-3 12-9 4-4 5-2 1-3 7-4 10-7h2v-2l10-5 9-6 11-5 3-2 7-2 3-2h4v-2l20-7 7-2z",
    fill: "#E45045"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(426,283)",
    d: "m0 0h6l-1 5-5 16-3 18v41l5 1 4-2h8l-4 4-6 1-8-1-2-6h-2v-10l1-7v-17h-1l1-11 1-1v-8l3-3-1-4 2-1 3-8-3-1-8 4h-1v-5z",
    fill: "#480512"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(497,400)",
    d: "m0 0h8l6 7-1 9-6 5-9-1-5-6v-7l5-6z",
    fill: "#100404"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(579,400)",
    d: "m0 0h7l6 4 1 2v10l-7 5h-6l-7-6-1-7 3-5z",
    fill: "#140406"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(642,278)",
    d: "m0 0 6 1 8 4 9 3 15 8-1 3-11-3h-36l-16-1-6-2v-1l8-1 14 1 29 1v-3l-6-1-13-5-5 1h-8v-2l8-1z",
    fill: "#420511"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(416,599)",
    d: "m0 0m-5 1h5v2l-17 7-16 10-14 11-8 10-5 5-11 14-1 3-5 5-8 16-6 10-5 13-3 3v-7l4-8 6-10 4-7 4-8 5-9 3-2 1-3h2l2-5 4-7h2l1-3 3-1 1-2h2l1-4 5-5 13-10 3-3 8-5 7-4z",
    fill: "#091116"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(474,585)",
    d: "m0 0h8l4 3 5 2 5 3v2l10 3 4 3 9 3 12 3 3 1h17l19-3 8-4 3-2 7-2 6-3 4-4h2v-2l8-1 10 2v1h-13l-13 8-15 7-16 5-19 1-13-1-24-8-6-3-17-11h-8l-9 3 5-5z",
    fill: "#091116"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(580,155)",
    d: "m0 0h9l9 2 2 2-1 4-1 1-27-2h-59l-28 3-29 6-23 6-6 2-4-1 14-5 22-5 6-2 13-2 3-1 21-2 11-2h60l11 2 13 1 2-2-11-3-7-1z",
    fill: "#E33050"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(506,332)",
    d: "m0 0 15 8 20 7 17 5 16 3 14 1v2l7-1h17l-3 2-9 1 3 2h-29l2-1-1-3-11-1-17-4-15-5-7-3v-2l-6-1-13-7z",
    fill: "#B87564"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(537,398)",
    d: "m0 0h10l3 4 3 18 5 9 2 4-6-3-4-7-2-8-2-13h-10v18h-2l-3 9-2 3h-2l-1 3-7 3-5 2h-26l-8-2-8-5v-6l5 5 12 6h23l7-3 6-4 5-7 4-22z",
    fill: "#B78176"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(852,480)",
    d: "m0 0h2l2 10 3 24 1 9v41l-4 33-2 4-1-3 1-22 3-18v-30l-3-16-1-23z",
    fill: "#C33129"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(588,568)",
    d: "m0 0 2 1 5 11-2 4-9 6-12 5-9 3-7 2h-20l-17-4-16-8-1-3 6 2 8 4 7 1 3 2 5 1h27l10-2 9-4 5-2 4-2h3v-2l4-1-1-4h-2z",
    fill: "#BB7968"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(632,236)",
    d: "m0 0 11 2 21 8 3 2 5 1v2l8 2v2l5 1 15 8 4 2v2l6 2 7 5 5 3 9 6v2l5 1v2l11 7 5 5 8 7v2h2v2h2l4 5 2 1v2l3 1-1 2-8-7-7-7-4-3v-2l-4-2-5-4v-2h-3v-2l-8-4v-2l-5-2-8-6v-2l-6-2-20-12-16-8-13-6-25-10-6-2z",
    fill: "#E54E45"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(387,89)",
    d: "m0 0 4 1-9 4-6 2-12 5-11 4-12 6h-5l-1 3-7 3-10 5h-3v2l-6 3-8 5-7 4h-3v2l-15 9-1 3-3 1-5 5-4 2-1 2h-3l-1 3-5 1-8 6-7 6-2-1 3-3h2l1-3 10-7 4-2v-2l11-7 5-4 9-6 7-4h2l1-3 10-5 12-7 3-2h4v-2l14-7 7-3 5-2h3v-2l9-4 7-2 2-2 7-2z",
    fill: "#9C8D90"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(578,540)",
    d: "m0 0h6l2 2 2 14 2 2h1v6l3 8 3 7v5h-2l-1 3h-3l2-4 1-3-7-14-3-12-1-11-5 1-5 2-9 2-9 1h-30l-5-2v-1l34-1 15-2z",
    fill: "#5F1523"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(488,364)",
    d: "m0 0h16v1l9 3 1 3-5 1v1l-15 1-2 1h-9l-4 3-4 1-2-2 2-6 9-5z",
    fill: "#120303"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(165,475)",
    d: "m0 0h1l-1 10-3 27-1 24v16l2 28 2 20 2 9 1 9 5 18 4 16 3 9v3h-2l-4-13-4-14-4-17-2-14-1-2-2-20-2-14v-58l3-21 1-11z",
    fill: "#E33050"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(504,66)",
    d: "m0 0h80l8 2 22 2 6 2 11 1 5 2 15 3 2 1 9 1 3 3-4-1-13-1-2-1v-2l-16-1-1-2-15-1-3-2-26-2-10-2h-63l-11 2-27 2-2 1h-6l1-2 3-1 22-2z",
    fill: "#701221"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(681,590)",
    d: "m0 0 17 7 8 5 10 6 10 9 2 1v2l4 2 7 8 8 10 4 6v2h2l11 18 7 12 5 12v4l-3-3-10-21-11-17v-3h-2l-9-13-3-3v-2h-2l-6-8-10-9-14-10-16-8-10-4z",
    fill: "#8498A9"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(859,469)",
    d: "m0 0h3l2 5 4 24 1 13 1 4v37l-1 16-2 13h-1v-63l-1-12-1-2-3-24z",
    fill: "#BA2B25"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(442,1007)",
    d: "m0 0 21 2 7 2 2 1 20 1 7 2 41 1h17l29-1 10-2 20-1 4-1-3 3-17 1-8 2-12 1h-78l-12-2-21-2-5-2-17-2-5-2z",
    fill: "#501724"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(655,392)",
    d: "m0 0h1v24l-5 12-4 6-5 4-13 2-2 14-4 15-6 17-7 14-7 9v-3l3-7 4-9h2l3-10 5-13 5-17 3-11 5-2h7l1-3 4-2 5-8 1-7 2-1z",
    fill: "#B4705D"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(320,784)",
    d: "m0 0 4 2 7 5 5 5 18 14 5 3 17 11 9 5 8 4 7 3v2l7 2 12 5 13 4v2l10 2 13 4 1 2-8-1-10-3-17-6-7-3-21-10-8-4-14-8-14-9-11-8-9-7-11-9-6-5z",
    fill: "#E55344"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(447,465)",
    d: "m0 0h2l5 17 6 15 9 15 7 8v2h2v2h2v2l4 2 7 6 2 5v8l-3 15-5 10-4 3-15 4-3-1 3-2 12-3 5-1 3-9 3-10v-17l-13-12-7-7-7-10-10-21-4-12z",
    fill: "#8896A5"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(647,334)",
    d: "m0 0 1 3-12 5-12 1v2l-2 1-17 2-21-1-10-3-13-2v-2l18 2 2 1h22l21-3 13-4z",
    fill: "#3C050F"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(540,395)",
    d: "m0 0 9 1 3 3 2 7 1 3v10l5 8v3l4 2v2l6 1 2 1v2l-5-1-7-4-6-9-2-4-3-18-2-3h-10l-2 3-4 22-6 8-7 5-2-1 3-4 4-2 3-6h2l1-13v-3h2l1-8 4-4z",
    fill: "#5C1220"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(653,341)",
    d: "m0 0 7 1 3 7 2 3-2 12-5 3-11-1-7 1 4-3 2-1h8l5 1v-14l-1-7-18 7-12 3-16 3-24 1-14-1v-1l42-2 4-1v-2h10l12-4 10-4z",
    fill: "#670E1D"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(752,293)",
    d: "m0 0 4 2 8 5 5 5 8 7 9 11 5 5 9 10 2 3v3l4 2 2 6 3 1 3 5 2 1 2 5 4 6-1 3-9-14-6-5-9-13-12-14-12-13-11-11-8-7z",
    fill: "#BE2D27"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(456,859)",
    d: "m0 0h10l9 3 9 1 7 2 21 2 6 1h46l13-2 15-1 3-1h9l-4 2-27 4-20 1h-29l-21-2-21-3-2-1-10-1-5-2-9-2z",
    fill: "#E44C47"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(567,393)",
    d: "m0 0 33 1 6 3 2 6-1 1-3 14-6 7-8 2h-10l-9-1-5-4-2-9h-2v-13zm5 3-7 3-1 1v11l3 9 4 4 3 1h18l5-2 4-4 3-9 1-9-3-4-5-1z",
    fill: "#691120"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(437,432)",
    d: "m0 0 8 5 9 1 4 2 3 18 3 10v4h2l4 13 8 16 2 5-4-4-6-10v-2h-2l-5-12-3-2v-4h-2l-2-22-3-8-1-1-10-2-3-2v-2h-2z",
    fill: "#7C1221"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(486,394)",
    d: "m0 0h28l7 3 1 2v14l-5 10-3 3-5 1h-13l-10-2-6-7-4-14 1-6 5-3zm0 2-6 2-1 2 1 12 4 8 4 4 3 1h19l7-4 3-9v-13l-3-2-7-1z",
    fill: "#44252F"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(384,617)",
    d: "m0 0m-1 1m-1 1m-1 1m-2 1h2l-2 4-8 7-5 5-4 5h-2l-2 4h-2l-2 5-4 5-4 7-3 4h-2l-2 5-8 16h-2l-8 20-1 6-3-3 3-9 8-16 9-16 4-7 3-1 1-4 14-18h2l2-4 6-7z",
    fill: "#293B41"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(445,240)",
    d: "m0 0h3l-1 3-10 2-12 5-8 3-12 5-8 4-2 2-5 2-14 8-2 3-7 3-11 8h-2l1-3 11-7 5-4h3l2-4 6-4h2v-2l23-11 17-7 10-2 4-2z",
    fill: "#BC2C26"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(597,220)",
    d: "m0 0 11 1 5 2 13 1v1l11 2v2l9 1 5 3 17 5 6 3 1 3 7 2 8 5-2 1-15-7-13-5-10-4-19-6-23-6-11-2z",
    fill: "#BC2C26"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(572,396)",
    d: "m0 0h25v1h-5v2h3v2l6 1v5l-1 5-2 4h-1l-1-8-2-5v-3h-3l3 4v10h-1l-1-10-6-3h-9l-2-1v2h-2l-5 5h-1l1 9 2 4h-3l-3-9v-11l4-3z",
    fill: "#8896A5"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(496,217)",
    d: "m0 0h11l-3 2-26 4-11 3-10 2-14 4-23 8-20 8 1-3 13-5 2-3 8-1v-2l11-4 7-1 2-2 12-3 12-1 10-3 13-2z",
    fill: "#BF2E27"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(499,65)",
    d: "m0 0h74v1l-69 1-20 3-14 1-5 2-12 1-5 2-13 2-5 2-10 2-12 3-4 2-7 1-2 2-4-1 4-3 10-2 5-2 8-2 2-1 12-1v-2l13-2 5-2 12-1 5-2 21-2z",
    fill: "#AE857E"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(512,401)",
    d: "m0 0 5 1v10l-2 9-2 3-3 1h-19l-2-4-4-2-1-4 2-1v2l3-1 4 5h11l5-4 2-9h2l1-3h-2z",
    fill: "#8896A5"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(388,994)",
    d: "m0 0 7 1 10 3 1 1 10 2 5 2 9 2 15 3 7 2 12 1 5 2 21 2 12 2 57 1v1l-18 1-45-1-16-3-13-1-5-2-14-1-8-3-10-1-4-2-10-2-5-2-8-2-1-1-9-2-5-2z",
    fill: "#998E94"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(629,582)",
    d: "m0 0 21 2 18 4 18 6 16 8 11 7-1 2-10-3-1-2-3-1v-2h-2v-2l-4-2-7-1-3-2-13-4-1-1-6 1-1-2-3-1-12-1-3-2-12-1-2-1z",
    fill: "#1F1F25"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(432,915)",
    d: "m0 0 8 1 20 5 10 2 22 3 12 2 32 1h16l38-1v1l-5 1-21 1h-44l-20-1-23-3-27-6-18-5z",
    fill: "#E33050"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(584,266)",
    d: "m0 0h9l11 3 9 2 13 4 11 2-3 3-13-1-18-4-11-3-8-3z",
    fill: "#A9624D"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(320,776)",
    d: "m0 0 4 2 4 3v2l4 2 13 11 17 12 14 9 16 9 21 10 11 5v1h-6l-12-6-17-8-20-12-5-4-7-4-3-3-5-3-18-14-3-2v-2h-2l-5-5z",
    fill: "#E55344"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(681,296)",
    d: "m0 0 5 2 9 6 1 4-4 2-18 3-2-2 1-5 5-7h2z",
    fill: "#8597A8"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(494,155)",
    d: "m0 0h10v1l-19 3-9 1-4 2-12 1-4 2-12 2-4 2-17 4-7 3-15 5-10 5-8 3-13 6-4 2-3-1 16-8 23-10 30-10 18-5 14-3 16-3 11-1z",
    fill: "#E33050"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(65,570)",
    d: "m0 0h1l2 18 2 15 1 13 2 4 1 12 2 5 2 12 2 4 1 10 2 3 2 10 2 5 2 7 3 10 8 20-1 4-3-5-2-7-4-10-2-9-2-2-2-9-2-5-1-7-2-3-2-12-2-5-2-11-1-2-1-13-2-4-2-22-2-10z",
    fill: "#988F94"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(928,496)",
    d: "m0 0h1l2 24v40l-1 22-4 29-4 19-4 16-2 6h-1l1-8 5-19 2-13 1-2 1-15 2-6 1-11 1-42z",
    fill: "#E33050"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(296,400)",
    d: "m0 0h1v6l-2 2-2 5-4 8-5 11-3 6-4 13-3 7-2 9-4 15-5 18h-1v-7l2-5 2-12 4-14 2-9 3-7 3-6 2-7 5-10 2-5 6-12z",
    fill: "#C37B64"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(986,370)",
    d: "m0 0 3 4 3 10 2 6 3 7 2 8 1 1 2 10 2 4 1 9 2 3 2 13 2 8 1 10 2 4 1 18 2 7v7l-3-1-1-7v-23l-3-1-1-5-1-14-2-3-1-10-2-4-1-10-3-5-2-10-3-9-2-3v-7h-2l-2-9-2-2z",
    fill: "#591724"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(231,464)",
    d: "m0 0h1v16h-2v9l-2 9-2 3-2 24-1 37-2-2v-32l1-16 3-20 5-25z",
    fill: "#C33129"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(627,914)",
    d: "m0 0h5l-3 2-8 2-16 3-18 2-3 1-13 1h-60l-15-2-16-2v-1h13l13 2 14 1h43l29-3 10-1 10-2z",
    fill: "#E33050"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(725,800)",
    d: "m0 0 2 1-7 6-5 5-5 3-7 4-13 8-17 8h-6l-2 2-3-1 4-3h6v-2l5-2 2-3 9-2v-2l5-2 7-4h4l1-3 6-3 3-1 1-3 5-1v-2z",
    fill: "#BD2D26"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(411,378)",
    d: "m0 0h2v3h2l1 5v9l2 1 3 15 3 14 2 5 1 7 3 3v2h2l-1 3-8-10-5-13-2-16-5-24z",
    fill: "#14171D"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(708,679)",
    d: "m0 0 2 4 1 13v46l1 16-1 7 6-5h3l1-3 4 1-7 7-10 6z",
    fill: "#091015"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1018,559)",
    d: "m0 0h1v28l-1 9-1 2-2 21-2 5-2 16-2 5-1 9-2 4-2 10-2 6-2 7-3 11-3 4v-5l2-3 2-9 1-1 2-11 2-4 2-9 3-15 2-7 1-11 2-5 1-16 2-8z",
    fill: "#998E94"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(588,621)",
    d: "m0 0m-1 1 2 3-6 2-1 2-14 4-8 3-8 1h-14l-10-1-8-3-6-1v-2l-10-1 1-4 9 3 13 4 12 2h9l18-3 18-7z",
    fill: "#091116"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 414)",
    d: "m0 0 4 4 1 9 2 3 2 13 2 6 1 12 2 3 1 16 2 7 1 12 1 51-1 9h-1l-1-54-1-13-2-7-1-18-2-4-2-16-2-5-1-10-2-3-1-9z",
    fill: "#9B8D91"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(592,397)",
    d: "m0 0h10l3 4-2 13-3 7-5 2h-7l5-6v-13l-2-4h3l3 8 1 7 1-7 2-6-6-1v-2h-3z",
    fill: "#DB8F72"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(411,291)",
    d: "m0 0h2l-1 8-1-4-4 1-10 6h-2v2h-4l-1 3-9 6-14 10-10 9-8 5v-3l5-4h2l2-4 8-6h2l1-3 4-1v-2l9-6 14-9 9-6z",
    fill: "#BD755E"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(453,368)",
    d: "m0 0h1l1 8 7 5 8 3h8l14-2h17l14 3v2h9l-1 2h-9l-8-1-4-3-22-1v2l-5 1h-15l-10-5-5-3z",
    fill: "#6B0D1D"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(496,520)",
    d: "m0 0 5 2 11 5 10 3 10 1h21l15-2 5-3 6-1 1-2 6-2 4-1-4 4-12 6-11 3-7 1h-28l-16-4-14-7z",
    fill: "#A9624D"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(280,941)",
    d: "m0 0 5 2 8 5 3 1v2l5 2 26 14 10 5 5 2 11 5 13 5v2l8 1 2 2 8 2 4 3h-5l-3-2-7-2-10-4-7-3-12-5-5-3-7-3-16-8-4-3-5-2-12-7-15-10z",
    fill: "#959097"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(536,289)",
    d: "m0 0 7 2 6 5 1 3 10 1v2l6 1v1h-6l-3-2h-9l-1-4h-2v-4h-10l-2 1 1 7 5 3h8l3 6 10 5 9 2h3v2l-7 1-10-4-6-3-4-6-9-1v-2l-5-2-1-1v-7l4-5z",
    fill: "#821121"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(376,768)",
    d: "m0 0 5 4 7 3 9 6 3 1 4 4 3 2 8 2 8 5 8 3 5 4v2l-10-3-5-3-21-11-13-8-11-7z",
    fill: "#A87B72"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(512,474)",
    d: "m0 0h5l11 9 6 3 7 2h11l8-3 6-2-1 2h-2l-1 3-11 4-11-1-12-4-7-5v-2h-8l1 4-3 1-1-1v-8z",
    fill: "#660A1A"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(223,460)",
    d: "m0 0 1 4-3 12-4 24-2 16-1 56h-1l-1-15v-29l2-29 2-8 2-14 4-16z",
    fill: "#C33129"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(470,296)",
    d: "m0 0h2l-2 4-3 7-5 4-2 3-4 2-1 4h-2l-2 8h-2l-1 8-1 3 2 1-3 3-3 9-1 8h-1v-12l5-18h2v-4h2l3-10 3-1 1-5 4-6 8-7z",
    fill: "#4D0514"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(180,664)",
    d: "m0 0 2 3 3 10 4 9 4 10 14 28 9 16 3 4 5 9 8 10-1 3-7-9-10-16-5-9-2-2-2-5-8-14-4-10-7-16-3-6-1-7h-2z",
    fill: "#E33050"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(611,513)",
    d: "m0 0 4 1-7 9-3 3h-2v2l-3 3h-2v15l3 18-2-1v-3h-2l-3-12v-17l6-8 4-1v-2h2l1-3h4z",
    fill: "#231C23"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(554,302)",
    d: "m0 0 12 2 7 5 1 4-2 5-6 1-13-5-1-4h-2v-3l5 1v2l4 2 9 2-1-4-14-5z",
    fill: "#430511"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(573,278)",
    d: "m0 0 5 1 14 6 24 7 16 1 35 1-1 5-4 1v-4h-24l-25-2-5-2-12-2-11-4-9-4z",
    fill: "#7E1020"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(762,786)",
    d: "m0 0 2 1-7 7-5 2v2l-6 5-5 4-4 2-3 3-4 2-4 4-6 3-7 5-3-1 8-5 5-5 9-7 3-1 5-5 8-6 5-4h2l2-4z",
    fill: "#BA2B25"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(290,738)",
    d: "m0 0h2l9 11 11 12 6 7 24 21v3l-11-9-6-3-5-4-6-7-10-10-2-5-11-13z",
    fill: "#B02422"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(224,493)",
    d: "m0 0 1 3-2 16-1 16v32l2 21v11h-2l-1-7-2-31v-20l2-33 2-6z",
    fill: "#E45B44"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(699,311)",
    d: "m0 0 4 2-5 3h-2v2l-11 9-10 7-1 6 1 12v22l-1 14-2 2v-57l13-10z",
    fill: "#8A95A3"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(501,312)",
    d: "m0 0 7 2 7 5 17 8 9 4 3 2v2l6 1 10 3 1 2-11-2-11-4-16-7-15-9-7-5z",
    fill: "#560617"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(736,646)",
    d: "m0 0 5 5 2 4h2l6 10 6 9 1 4h2l5 12 5 11 2 1 2-4 3-1-1 4-5 8h-2l-3-10-6-11-2-6-9-15-7-11-6-8z",
    fill: "#091015"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(231,654)",
    d: "m0 0h2l8 21 5 10v3h2l4 9 8 14 12 19-1 2-5-6-6-11-5-7-2-1v-3l-3-1v-5h-2l-6-13-3-9-5-12z",
    fill: "#C13028"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(494,322)",
    d: "m0 0 5 2 8 4 3 2v2l5 1 8 4v2l11 3 4 1 2-1 1 2 7 3 20 5 5 2v1l-8-1-11-2-24-8-21-11-14-9z",
    fill: "#6F0C1C"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(771,312)",
    d: "m0 0 7 6 12 13 8 10 10 14 8 11 9 15 1 2-4-1-2-6h-2l-4-8-4-6v-2h-2l-2-5h-2v-3h-2l-5-8v-2l-3-1-8-10-3-3-5-6-2-1v-3l-3-1v-2h-2z",
    fill: "#E55045"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(648,854)",
    d: "m0 0 2 1-5 3-10 3-10 2-12 3-2 1-11 1-8 3h-16v-1l16-1v-2l24-6 10-2 10-3 10-1z",
    fill: "#B92A25"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(993,696)",
    d: "m0 0h1v6h-2l-2 9-4 10-4 8-2 7-17 34-6 11-4 7-6 8-1 4h-2l2-6 5-7 6-11 3-6 5-8 3-7 10-20 3-8 5-13 3-6 2-7z",
    fill: "#988F94"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(776,329)",
    d: "m0 0 6 5v2h2v2h2l14 19 8 11 6 10-1 2-8-11-4-6-5-5-7-9-3-3-2-5-4-2-4-6z",
    fill: "#BC2C26"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(378,609)",
    d: "m0 0v3l-4 3-1 4-6 5-8 7-3 3h-2v2h-2l-1 4-1 3-8 2 2-4 6-7h2l2-4 12-12z",
    fill: "#11181D"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(589,586)",
    d: "m0 0h2l-1 3-10 5-13 5-4 2-8 1-3 1h-16v-2h-8l-12-4-1-3 11 3 10 2h20l15-4 10-5z",
    fill: "#740D1E"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(255,384)",
    d: "m0 0 1 4-3 4-6 13-4 8-2 6-4 9-3 10h-2l-1 9-2 3-2 10-2 6h-2l4-18 4-11 3-9 10-24 10-19z",
    fill: "#E55144"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(440,856)",
    d: "m0 0 8 1 20 5 2 1 10 1 13 3 10 1 2 1v2h-13l-15-3-9-2-4-2-8-2-16-5z",
    fill: "#BF2E27"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(849,314)",
    d: "m0 0 3 1 4 7v2h2l14 22 2 5 2 1 8 16 6 11 3 8 6 15 1 5-3-4-5-12-6-13-8-16-6-10-6-11-7-11-7-10z",
    fill: "#E33050"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(476,311)",
    d: "m0 0 6 1v2l4 2 12 9 15 9 13 7-3 1-15-8-6-2-5-3v-2l-4-1-5-4v-2l-5-2-4-3-4 2-7 10v-3l3-5 3-7z",
    fill: "#B36F5D"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(475,267)",
    d: "m0 0 7 1 1 4-3 5-5 3h-6l-3-5 1-4 3-3z",
    fill: "#30040B"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(301,328)",
    d: "m0 0h3l-2 4-9 10-3 5h-2l-2 5h-2l-2 5-2 3h-2l-2 6-7 10-10 18-3 3 1-5 5-10 9-14 12-17 9-11 2-4h2l2-4z",
    fill: "#E54F45"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(504,604)",
    d: "m0 0 4 1 11 4 13 3h24l16-4 11-4 3 1-5 2v2l-6 3h-7l-13 3h-19l-11-2-11-3-9-4z",
    fill: "#7F9AAE"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(240,645)",
    d: "m0 0 3 3 1 8h2l4 10 2 7 4 7 3 7 5 9-2 1-4-7v-2h-3l-7-15-6-14-3-11z",
    fill: "#BD2D27"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(858,617)",
    d: "m0 0 1 3-4 16-6 18-8 20-7 16-4 6-1-3 4-8 7-15 5-14 1-4h2l1-10 2-2 4-14 1-7z",
    fill: "#E55543"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(502,585)",
    d: "m0 0 6 2 8 4 7 1 3 2 10 2v2l22-1 10-1v1l-12 3h-20l-17-4-16-8z",
    fill: "#B06C58"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(73,456)",
    d: "m0 0h1v9l-2 9-2 27-1 2-1 9-1 62h-1v-70l3-21 1-13 2-6z",
    fill: "#731120"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(613,425)",
    d: "m0 0 2 4-5 5-8 6-6 2h-24l-12-6 1-3 11 5 16 1 12-2 8-6z",
    fill: "#B97665"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(504,776)",
    d: "m0 0 1 4-6 4-27 10-7 2-21 7-3-1 3-2h6v-2l18-6h4v-2l10-3 5-2 1-2 16-4z",
    fill: "#ADCFD8"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(573,362)",
    d: "m0 0h27l12 4 6 5v6l-2 3-8-1v-1h8v-7l-5-2-9-3-10-2h-14l-6 2-1 5 5 2h16v1l-19 1-5-2-1-6 3-4z",
    fill: "#670D1D"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(836,288)",
    d: "m0 0 7 6 10 13 3 3 4 7 8 11 9 14 6 12 3 4 5 10-1 3-3-4-2-5-3-6-2-2-2-5-9-15-8-12-6-8v-2h-2l-3-5-1-3h-2l-8-11-3-3z",
    fill: "#E33050"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(224,592)",
    d: "m0 0 2 3 3 17 5 20 4 13 8 22v5l-2-4-6-14-5-16-4-14-1-1-2-12-2-4z",
    fill: "#E55443"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(859,512)",
    d: "m0 0h1l2 8v45l-3 25-3 3 2-20 1-9z",
    fill: "#E55543"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(431,586)",
    d: "m0 0h5l-4 2h-2l-1 2h-7v2l-7 1-5 3-3 2-6 1-3 3-14 8-5-1 5-4 13-7 13-6 16-5z",
    fill: "#20262B"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(408,240)",
    d: "m0 0h6l-3 2-10 4-1 3-16 8-14 8-5 2-4 2-4 1 5-5 6-3 6-4 2-2 5-2 14-7z",
    fill: "#B92A25"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(309,776)",
    d: "m0 0 4 2 7 6 4 5 8 6 11 9 9 7-1 3-11-8-10-7v-2l-4-2-8-7-4-6-5-4z",
    fill: "#BA2A25"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(714,610)",
    d: "m0 0 8 6 10 9 4 5v2h2l10 13 2 5h2l1 4-3-1-3-4v-2h-3l-5-10-7-6-5-5-5-6-5-2-3-5z",
    fill: "#2E2F35"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(486,595)",
    d: "m0 0 5 1 10 6 3 1 4 4 17 5 11 2h19l13-3 4 1-7 3-9 1h-24l-16-4-12-4v-2l-7-2-6-4-5-3z",
    fill: "#79A2B3"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(771,322)",
    d: "m0 0 5 3 8 8 11 14 2 5h2l3 4v2h2l5 9 7 11 2 3-1 3-7-11-7-10-10-14-7-9v-2h-2v-2h-2l-7-8-4-4z",
    fill: "#E44847"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(328,781)",
    d: "m0 0 4 2 10 8 7 4 4 4 5 2 5 4 11 7 4 4-9-2-11-8-10-7-16-13-4-3z",
    fill: "#BC2C26"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(193,369)",
    d: "m0 0 1 2-7 16-3 7-9 24-5 16-2 9-2 6-2 9-2 2 1-9 9-32 7-19 4-10 7-15z",
    fill: "#E33050"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(798,744)",
    d: "m0 0h2l-2 5-8 9-2 5-4 2-1 4-5 5-8 7-5 5-5 1 6-7 4-2 2-4 12-12 1-2h2l2-4z",
    fill: "#BD2D27"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(655,392)",
    d: "m0 0h1v24l-5 12-4 6-5 4-13 2-2 14-2 7h-1v-7l2-6 2-9 5-2h7l1-3 4-2 5-8 1-7 2-1z",
    fill: "#B16C59"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(472,389)",
    d: "m0 0h10l2 4h-2v3l-4 2-7 1-1 2-2-5-6-1v2l-3 1 2-5 7-3z",
    fill: "#020102"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(627,386)",
    d: "m0 0h4l1 7-3 4h-2l-1 2-1-4-11 1-3 1-1-5 1-3 8-1 5 1z",
    fill: "#020202"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(137,288)",
    d: "m0 0 1 3h-2l-1 5-6 9-6 11-8 16-3 5-6 15-5 11-3 7h-2l1-4 4-9 6-15 2-2 2-6h2l1-6 4-8h2l1-6 5-8 6-10 3-6z",
    fill: "#968F96"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(814,472)",
    d: "m0 0 1 3 3 1 3 17 1 3 1 21v50h-1l-1-44-1-16-4-24-2-6z",
    fill: "#B56F5A"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(574,382)",
    d: "m0 0h18v1l-17 1-7 3-16 2v-1l-29-1v-1l11-2h18l7 1z",
    fill: "#6D0C1C"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(421,322)",
    d: "m0 0h1l1 41 5 1 4-2h8l-4 4-6 1-8-1-2-6h-2v-10l1-7 1-20z",
    fill: "#4F0514"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(249,417)",
    d: "m0 0h1l-1 7h-2l-1 7-4 10-2 4v5l-2 2-3 12h-2v8h-1v-13l7-23 6-9 2-6z",
    fill: "#C02F28"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(564,544)",
    d: "m0 0h8l-1 2-7 2-9 1h-30l-5-2v-1l34-1z",
    fill: "#6E0F1E"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(449,467)",
    d: "m0 0 4 2v5l4 10 1 6h2l1 4 6 12 10 13 12 11-1 2-8-6v-2h-2v-2h-2l-10-13-7-12-7-17z",
    fill: "#2C363B"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(810,358)",
    d: "m0 0 4 2 7 11v2h2l3 3 3 7 3 4v5h2l5 8 1 9-3-3-10-19-4-8-9-14z",
    fill: "#BD2C26"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(448,235)",
    d: "m0 0h8l-4 2-23 8-24 10-15 7 2-4 10-5 9-4 6-1v-2l20-7 7-2z",
    fill: "#E44947"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(575,744)",
    d: "m0 0 2 4 2 3v17l-4 10-7 9-10 7-9 3h-15l-11-4 3-1 5 1 5 2h12l11-4 12-11 6-14v-12l-2-4z",
    fill: "#091116"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(867,520)",
    d: "m0 0h2l1 8v24l-1 16-2 13h-1z",
    fill: "#C33129"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(548,260)",
    d: "m0 0 22 1 11 7 10 2 1 3 6 1 6 2v1h-6l-20-8-10-6h-19v2l11 5v2l-5-2-10-5-1-4z",
    fill: "#5C0718"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(575,357)",
    d: "m0 0h37l-3 2-9 1 3 2h-29l2-1z",
    fill: "#BC7A69"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(485,398)",
    d: "m0 0h9l-2 4-2 3-1 10h-4l-3-4-1-3v-8z",
    fill: "#DF9071"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(576,528)",
    d: "m0 0 3 1-7 3-6 1v2l-22 3h-9l-8-3-4-2h33l15-3z",
    fill: "#6E0F1F"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(225,501)",
    d: "m0 0h1v26l-1 7v20l1 7v26h-1l-2-25v-37z",
    fill: "#B02422"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(454,438)",
    d: "m0 0 5 1 1 1 2 15 3 12 3 6 5 15 6 10 1 1v5l-4-5-7-14-3-8v-5h-2l-5-18-1-14z",
    fill: "#A9624D"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(672,390)",
    d: "m0 0h1v7l-2 11-1 13-5 12-5 9-8 7-8 4-2-1 6-4 5-3 7-8 5-10 3-11 1-16z",
    fill: "#8398AA"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(562,400)",
    d: "m0 0h2l1 11 3 9 3 3 3 1h18l5-2 3-1 4-17h1v10l-3 7-6 5-6 1h-10l-9-1-5-4-2-9h-2z",
    fill: "#3F2C34"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(297,326)",
    d: "m0 0 2 1-3 4h-2l-2 4-8 9-5 8h-2l-2 4-7 11-5 7-2 5-3 5h-2l1-4 2-4h2l1-5 11-16 8-11 9-11 4-5z",
    fill: "#E55743"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(517,223)",
    d: "m0 0h3v2l-32 4-20 4-8 2-4-1 3-2 13-3 2-1 16-2 6-2z",
    fill: "#E55443"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(653,341)",
    d: "m0 0 7 1 3 7 2 3-2 12-5 3-11-1-7 1 4-3 2-1h8l5 1v-14l-1-7-7 2z",
    fill: "#570E1C"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(632,236)",
    d: "m0 0 11 2 21 8 3 2 5 1v2l8 2v2l5 1 9 5-2 2-16-8-11-5-25-10-6-2z",
    fill: "#E55543"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(726,982)",
    d: "m0 0 2 1-7 3-10 4-9 3-10 4-9 2-3 2-10 2-3 2-9 1-4 2h-8v-1l7-2 2-1 10-1 5-3 10-2 10-3 9-3 3-2 7-2 10-4z",
    fill: "#988E94"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(234,176)",
    d: "m0 0 2 1-11 10-8 7-4 4h-2l-1 3h-2l-1 3-4 4h-2l-1 3-10 10-10 13-4 2 2-4 6-8h2l2-4 7-7 5-6 2-1 1-3 3-1 4-5 8-7 4-4h2v-2z",
    fill: "#96929A"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(224,626)",
    d: "m0 0 3 1 2 10v3h2l1 9h2l3 10 4 9 3 8 4 8v4h-2l-7-16-9-24-6-20z",
    fill: "#E55643"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(497,400)",
    d: "m0 0h8l6 7-1 9-6 5-9-1-5-6v-7l5-6zm3 2-6 3-2 3 1 8 3 2h10l1-5 3-1v-4h-2l-2-4z",
    fill: "#571825"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(834,423)",
    d: "m0 0 2 3 2 4 2 7 5 14 3 12h2l3 12v10l1 8-3-2-1-14-2-5v-8h-2l-7-24-2-3-2-8-1-1z",
    fill: "#B62824"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(277,736)",
    d: "m0 0 3 1v2h2l6 9 2 1v3h2l9 11 9 10 2 1v2h2l5 5 1 3-4-2-7-6-7-8-6-6v-2h-2l-8-10-9-12z",
    fill: "#E55543"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(508,544)",
    d: "m0 0 12 2 5 2h30l9-1 2-1h6l-4 3-3 1-31 2-12-2-16-4z",
    fill: "#A9624D"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(852,480)",
    d: "m0 0h2l2 10 3 24v9l-1 5h-1l-3-16-1-23z",
    fill: "#C33129"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(637,438)",
    d: "m0 0h5v2l-6 2-4 3-2 6v5h-2l-1 8-1 4h-2l-2 9-1 3h-2l3-11 4-15 2-12 3-3z",
    fill: "#770F1F"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(606,223)",
    d: "m0 0 18 4 20 6 15 5 10 5-1 2-8-3-4-1v-2l-8-1-7-3-9-3-8-2-1-1-9-1-9-3z",
    fill: "#E55643"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(696,676)",
    d: "m0 0 5 2 2 2v8l-5 1-7-1-1-5 3-5z",
    fill: "#79A3B4"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(853,594)",
    d: "m0 0 1 4v10l-4 17-3 3-4 15-2 5-1-3 3-9 1-9 3-4 1-10 2-2 1-14z",
    fill: "#B62824"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(221,624)",
    d: "m0 0 2 3 3 3 6 21 1 7 6 17 3 5-1 3-4-7-3-9-4-9-2-8-2-6v-4h-2l-3-12z",
    fill: "#B92A25"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(100,722)",
    d: "m0 0 3 4 6 15 2 2 2 6 5 8v5l3 1 6 12 10 18h-3l-12-22-2-2-2-5-7-14-3-7-4-8-3-7-1-1z",
    fill: "#9C8D90"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(422,842)",
    d: "m0 0 8 1 10 3 8 3 10 3 28 6v1h-13l-4-2-9-1-8-3-7-2-21-7z",
    fill: "#E55244"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(554,264)",
    d: "m0 0h14l5 5 1 3-4 1-10-1v-2l-6-2-1-2z",
    fill: "#110303"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(617,400)",
    d: "m0 0h1v13l-4 12-9 10-5 3-4-1 2-4 4-1 7-6v-2l3-3z",
    fill: "#610919"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(426,392)",
    d: "m0 0h2v16h2l2 10v6h2l3 6v2l-4 1v-3h-2l-1-4 1-2h-2l-2-6 1-2-2-2z",
    fill: "#540815"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(579,400)",
    d: "m0 0h7l6 4 1 2v10l-7 5h-6l-7-6-1-7 3-5zm2 2-7 4v7l4 5 5 2 6-3 2-4-1-7-4-4z",
    fill: "#5B0F1D"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(590,228)",
    d: "m0 0 15 2 16 4 1 3 10 2-3 1h-6l-2-1v-2l-11-1-10-3-10-1-4-3z",
    fill: "#BB2B26"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(759,863)",
    d: "m0 0 3 1h-2v2l-25 15-12 7-18 8-10 5-3-1 12-6 13-6 10-5 7-4h2v-2l10-5 9-6z",
    fill: "#E33050"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(320,776)",
    d: "m0 0 4 2 4 3v2l4 2 13 11 17 12 9 6-3 1-11-7-3-3-5-3-18-14-3-2v-2h-2l-5-5z",
    fill: "#E55144"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(845,664)",
    d: "m0 0h1v6l-4 10h-2l-1 6-4 8-5 6-2 4h-2l2-5 8-16 8-18z",
    fill: "#BC2C26"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(69,474)",
    d: "m0 0h1v9l-3 21-1 66h-1v-71l2-11 1-11z",
    fill: "#A48988"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(532,400)",
    d: "m0 0h2v8l-3 16-6 8-7 5-2-1 3-4 4-2 3-6h2l1-13v-3h2z",
    fill: "#730D1D"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(326,306)",
    d: "m0 0m-1 1m-1 1m-1 1m-1 1m-1 1m-1 1m-1 1m-1 1m-1 1v3l-5 5-5 6-7 8-2 3h-2l-2 4-12 16h-2l4-8h2l2-5h2l2-5 11-12 1-2h2l2-4z",
    fill: "#C33129"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(752,650)",
    d: "m0 0h2l12 19 11 22-1 3-3-3-10-21-11-17z",
    fill: "#8497A9"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(594,322)",
    d: "m0 0 19 1h21l9 1v1l-14 2h-13l-24-3z",
    fill: "#3A040E"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(918,248)",
    d: "m0 0h2l8 11 7 10 1 3h2l3 6 5 7 3 5 1 4h2l6 12 2 3-4-2-5-9v-2h-2l-3-6-5-8v-2h-2l-3-6-8-10-3-5-7-9z",
    fill: "#978F95"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(647,376)",
    d: "m0 0h5l4 5 1 3 2 25 1 3h-2l-1 7-3 7-2 1 1-6 2-5v-27l-3-9-6-2z",
    fill: "#6F0D1D"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(400,248)",
    d: "m0 0 3 1-9 5-1 2-9 3-14 8h-2v2l-15 9-1-2 15-10 15-9 16-8z",
    fill: "#E55743"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(378,989)",
    d: "m0 0 9 1v2l9 1 10 4 10 2 7 3 10 1 2 2 7 1v1h-9l-5-2-9-2-6-2-7-1-3-2-8-2-10-3-7-3z",
    fill: "#5F1422"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(456,859)",
    d: "m0 0h10l9 3 9 1 7 2 21 2 2 3-11-1-21-3-2-1-10-1-5-2-9-2z",
    fill: "#E55444"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(189,704)",
    d: "m0 0 3 4 9 19 3 4 5 9 2 6h2l6 10 5 7-1 2-7-9-11-18-9-16-7-14z",
    fill: "#E33050"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(642,453)",
    d: "m0 0 2 1-5 18-4 13-4 9-4 8-2 5h-2l-1 4-6 7v-3l8-11 7-15 6-19 4-15z",
    fill: "#BBD0DE"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(706,988)",
    d: "m0 0 3 1-8 3-10 3-3 2-20 5-3 2-10 1-3 2h-8v-1h7l1-3 15-3 1-1 10-1v-2l11-1 1-3h8v-2z",
    fill: "#5F1422"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(821,928)",
    d: "m0 0 3 1-13 9-11 7-12 8-11 6-9 5-3 2-3-1 4-3 10-5 12-7 7-5 9-5 11-8z",
    fill: "#9B8D92"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(653,914)",
    d: "m0 0 3 1-13 4-17 4-9 2-20 3h-7l2-2 19-2 5-2 16-3z",
    fill: "#E33050"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(224,898)",
    d: "m0 0 4 2 10 8v2l4 2 12 9 2 1v2l4 2 18 12 2 1v2l-6-2-7-6-7-4-10-8-13-10v-2l-4-2-5-3-4-4z",
    fill: "#998E94"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(337,737)",
    d: "m0 0 4 2 12 12 4 2 1 2 5 3 6 5 4 1-1 4-5-2-14-12-6-5-10-10z",
    fill: "#590717"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(574,474)",
    d: "m0 0h6l3 3v7l-7 9-8 5-5 2-3-1h2v-2l9-4 3-3h2v-2l2-1 2-4v-5h-6l-1 2-5 3-2-1z",
    fill: "#6E0C1C"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(504,364)",
    d: "m0 0h8l7 3 1 4-5 4h-23l2-2 13-1v-1h7l-2-3-11-2z",
    fill: "#480612"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(518,326)",
    d: "m0 0 5 1 16 7 11 4 11 3v2l-11-2-10-3-16-6v-2l-6-2z",
    fill: "#3C050F"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(419,837)",
    d: "m0 0h7l5 3 4 1 8 3 6 3 8 1 3 2v2h7l5 2v1l-10-1-11-3-3-1v-2l-11-3-13-5-5-2z",
    fill: "#BF2E27"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(320,784)",
    d: "m0 0 4 2 7 5 5 5 18 14 5 3 6 4v2l-5-2-10-7-12-9-18-15z",
    fill: "#E55244"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(826,404)",
    d: "m0 0 3 1 5 11 8 20 7 24-1 3-3-7-5-17-2-3-2-8-7-17z",
    fill: "#C33129"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(475,365)",
    d: "m0 0 4 1-9 4-2 6 1 4h2l-1 4-9-3-6-4-1-5 2-1v5h3v2h5v-6l3-4z",
    fill: "#B67A6C"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(434,376)",
    d: "m0 0h5l7 8-1 4-5-5-2-3-4 1-2 7-2 9-1 11h-1v-20l3-9z",
    fill: "#651322"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(409,312)",
    d: "m0 0 2 2v9l-1 9v15l1 9v9l-2 1-2-22 1-26z",
    fill: "#482932"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(503,292)",
    d: "m0 0h10l1 4h2v2l-4 2h-3v2h-2v2l-3-1-3-7v-3z",
    fill: "#E65543"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(821,523)",
    d: "m0 0h1v65l-4 13h-1l1-13 2-12z",
    fill: "#CD836A"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(565,350)",
    d: "m0 0 9 1 4 2 25-1 5-1h11l-3 3-22 1h-21l-8-3z",
    fill: "#3C050F"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(681,300)",
    d: "m0 0 6 1 5 3v3l-13 3h-5l2-4z",
    fill: "#BBD0DE"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(548,279)",
    d: "m0 0h9l3 2-1 5-10 2-3-1-1-5z",
    fill: "#E65543"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(454,228)",
    d: "m0 0m-4 1h4v2l-9 2-9 3-20 8-8 3-7 1 4-3 23-9 17-6z",
    fill: "#E55344"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(733,872)",
    d: "m0 0 3 1-11 7-5 3-10 4-4 3-14 5-2 2-7 2-5 2-4-1 14-5 8-4 10-4 12-7 14-7z",
    fill: "#E33050"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(508,744)",
    d: "m0 0h1l-1 18h-2v2h2l1 6v4h2l3 7 5 4v3l4 2-1 2-5-5-5-4-4-7-3-10v-14l2-3z",
    fill: "#091116"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(753,354)",
    d: "m0 0 5 5 6 7v2h2l2 5h2l7 11 4 5-1 3-4-3-5-9-13-16-2-2-2-5z",
    fill: "#BF7861"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(671,349)",
    d: "m0 0h2v27l-1 16-3 10h-1l1-12 2-30z",
    fill: "#2F343A"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(477,308)",
    d: "m0 0 6 2 5 4v2l4 2 4 4-5-1-9-7v-2h-8l-2 5h-2l-2 5-5 6-1-2 7-11 2-2v-3z",
    fill: "#67101F"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(274,148)",
    d: "m0 0 1 2-3 1-5 5-4 2-1 2h-3l-1 3-5 1-8 6-7 6-2-1 3-3h2l1-3 10-7 4-2v-2l9-6 5-2z",
    fill: "#73414D"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(509,871)",
    d: "m0 0 19 1h24l11-1h12v1l-10 2h-51l-5-2z",
    fill: "#B02422"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(182,411)",
    d: "m0 0 1 3-7 21-8 33-1 7h-1v-12l6-21 2-10 3-9 2-4 2-7z",
    fill: "#E33050"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(818,383)",
    d: "m0 0 3 3 6 11 3 7 5 9 5 14 2 2 1 6-3-1-8-21-8-16-6-11z",
    fill: "#E55343"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(645,845)",
    d: "m0 0 2 1-4 3-14 4-6 2-2 1-10 1-3 2-16 1 3-2 10-2 11-3 14-3z",
    fill: "#E54D46"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(594,527)",
    d: "m0 0h3l-2 4v17l1 4h-3l-2-11-4-1-1-6 5-4z",
    fill: "#010101"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(824,383)",
    d: "m0 0 3 1 9 19 4 8 7 17v6l-5-10-2-6-5-10-4-10-7-13z",
    fill: "#E55643"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(795,334)",
    d: "m0 0 5 4 2 3v3l4 2 2 6 3 1 3 5 2 1 2 5 4 6-1 3-9-14-6-5-7-11-2-4z",
    fill: "#B52724"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(517,472)",
    d: "m0 0 4 1 5 5 9 6 5 1v2h15v-2l4-2h5l-5 4-7 2h-11l-10-3-8-6-4-6z",
    fill: "#B97665"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(169,245)",
    d: "m0 0 2 1-1 3-2 1-1 3-3 2-2 4-4 4-4 7-3 2-6 11h-2l-1 4-2 2-2 5-3 2 1-5h2l1-4 3-5 1-2h2l2-5 6-9 7-10h2l2-4z",
    fill: "#571A27"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(576,225)",
    d: "m0 0h12l8 2 12 1v2l13 2 5 2 6 1v2l2 1-10-2-19-5-17-3-12-1z",
    fill: "#E44A47"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(566,858)",
    d: "m0 0h21v1l-17 1-10 2h-40l-7-1-1-2h8l5 1h33z",
    fill: "#B02422"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(248,688)",
    d: "m0 0 4 4 2 5 2 2 3 7 10 16 8 12-1 2-2-4h-2l-12-20-6-9-6-12z",
    fill: "#E55543"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(426,283)",
    d: "m0 0h6l-1 5-3 8-3 1 2-7-3-1-8 4h-1v-5z",
    fill: "#550516"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(210,168)",
    d: "m0 0v3l-10 9-20 20-5 6-9 9-2 1 2-4 14-15 26-26z",
    fill: "#9CAEBD"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1009,624)",
    d: "m0 0h1v13l-2 5-2 12-3 12-2 4-1 8-3 7h-1v-7l2-3 2-10 2-5 1-8 2-3 1-12 1-2h2z",
    fill: "#5B1322"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(468,372)",
    d: "m0 0h1l1 7h6l5-5h34l3-2-2 4-24 1-9 2-5 2h-7l-3-3-1-4z",
    fill: "#6F1221"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(323,312)",
    d: "m0 0 2 1-12 12-1 2h-2l-2 4-4 5-5 5-9 11-2-1 8-11 5-5 3-4h2l2-5h2l2-4 5-5z",
    fill: "#B02422"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(338,670)",
    d: "m0 0 1 2-8 16h-2l-8 20-1 6-3-3 3-9 8-16 8-14z",
    fill: "#2A373C"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(472,427)",
    d: "m0 0 5 5 12 6h23l7-3 6-3-1 3-10 5h-26l-8-2-8-5z",
    fill: "#AF6956"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(534,402)",
    d: "m0 0h2v18h-2l-3 9-2 3h-2l-1 3-2-1 5-9 2-5z",
    fill: "#B67260"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(582,313)",
    d: "m0 0 22 2v1l-8 1-12-1v4h6v2l2 1h-10l-3-2v-6z",
    fill: "#3C050F"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(587,858)",
    d: "m0 0m-17 1h17l-3 2-21 2h-44l1-2h40z",
    fill: "#C33129"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(246,668)",
    d: "m0 0 2 2 6 14 10 19 6 10v2h-2l-7-12-10-19-5-10z",
    fill: "#E55443"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(636,350)",
    d: "m0 0 4 1-3 1-1 2-7 2-3 1-38 1v-1l6-1 18-1 22-4z",
    fill: "#B26D5A"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(694,313)",
    d: "m0 0 2 2-11 9-12 9-1 14-2 1-1-13 6-7 7-7 6-1 2-4z",
    fill: "#2F343A"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(496,217)",
    d: "m0 0h11l-3 2-26 4-11 3-13 2 3-3 2-1 9-1 10-3 13-2z",
    fill: "#C33129"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(690,826)",
    d: "m0 0 3 1-13 7-5 2h-3v2l-8 3-9 4-9 2 3-3 24-10z",
    fill: "#E55145"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(814,710)",
    d: "m0 0 1 2-2 3h-2l-2 6-4 5-4 7-9 11-6 8h-2l2-4 18-24 2-4h2l1-4z",
    fill: "#E55044"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(67,575)",
    d: "m0 0h1l2 7 2 28 1 1 1 8v9h-1l-2-11-1-1-2-24-1-4z",
    fill: "#601120"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(561,340)",
    d: "m0 0 18 2 2 1h22l20-3 1 2-16 3h-31l-16-3z",
    fill: "#540516"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(599,297)",
    d: "m0 0h7l5 3v3l-4 2-8-1-3-2 1-4z",
    fill: "#E65543"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(810,728)",
    d: "m0 0 4 1-8 11-4 7h-2l-2 4-7 9h-2l2-4 8-10 2-5z",
    fill: "#BC2C26"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(411,378)",
    d: "m0 0h2v3h2l1 5 1 14 2 5v12l-2-1-2-13-4-21z",
    fill: "#2E252B"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(877,736)",
    d: "m0 0h2l-2 6-6 9-4 7-6 8-4 6-9 11-3 3 2-5 8-10 1-3 3-3 7-10 10-16z",
    fill: "#E33050"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(409,789)",
    d: "m0 0 6 1 8 5 8 3 5 4v2l-10-3-5-3-11-6z",
    fill: "#9E8381"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(566,402)",
    d: "m0 0 2 4 4-2v10l4 6 1 3-5-1-3-2-3-8z",
    fill: "#DA967D"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(389,259)",
    d: "m0 0 2 1-4 4h-3v2l-17 10-5 2v2l-7 4h-3l8-7 8-5h2v-2l10-5z",
    fill: "#E55244"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(341,645)",
    d: "m0 0 2 2-4 5-2 3-2 7-7 11h-3v2l-2-1 9-16z",
    fill: "#1E2026"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(509,600)",
    d: "m0 0h8l5 2 6 1v2h6l6 2 11 1v1h-17l-9-3-7-2-9-3z",
    fill: "#010101"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(574,624)",
    d: "m0 0 3 1-9 4-13 3h-19l-1-2-3-2h6l2 1h17l15-4z",
    fill: "#809AAE"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(505,541)",
    d: "m0 0 11 1 9 3v1h-13l-6-1-1 11h-2v-12z",
    fill: "#660D1C"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(532,501)",
    d: "m0 0h31l-3 3-6 1h-16l-6-2z",
    fill: "#B4705E"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(803,434)",
    d: "m0 0 2 1 2 7 4 10 2 9 2 4 1 10-2-3-4-11-4-13-2-4z",
    fill: "#C07860"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(434,442)",
    d: "m0 0h6l2 4 8 3 3 7-1 8-2 1-1-10v-3l-4-1-8-4-1-3h-2z",
    fill: "#010101"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(468,409)",
    d: "m0 0 2 2 4 8 1 5 2 6 8 4 1 3-6-2-5-4-6-10z",
    fill: "#510715"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(211,886)",
    d: "m0 0 5 1 8 7v2l4 2 8 6v2l3 1 1 3h-2v-2l-4-2-8-7-5-2-10-10z",
    fill: "#5A1321"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(725,617)",
    d: "m0 0 3 1v2l4 2 7 8 8 10 4 6v2h2v2h-3l-9-13-3-3v-2h-2l-6-8-5-5z",
    fill: "#8796A6"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(647,334)",
    d: "m0 0 1 3-12 5-12 1v-3l13-4z",
    fill: "#420511"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(736,290)",
    d: "m0 0 5 2 7 5 5 5 7 6v2h2v2h2l4 5 2 1v2l3 1-1 2-8-7-7-7-4-3v-2l-4-2-5-4v-2h-3v-2l-4-2z",
    fill: "#E55044"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(504,66)",
    d: "m0 0h8v2l-11 2-27 2-2 1h-6l1-2 3-1 22-2z",
    fill: "#5A101F"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(677,840)",
    d: "m0 0 4 1-10 5-7 3h-3v2l-5 3-10 2h-6l4-2 30-12z",
    fill: "#BE2D27"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(835,668)",
    d: "m0 0 1 2-5 13-3 5-11 21-3 1 2-5 6-12h2l1-5 8-16z",
    fill: "#E55543"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(582,596)",
    d: "m0 0h7l-3 3-7 2-2 2-7 3-9 1 5-5 6-2z",
    fill: "#010101"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(624,501)",
    d: "m0 0 1 3-12 16-7 8-5 4-3 3v-4h2l1-3h2v-2l7-6 8-11 4-7z",
    fill: "#8597A8"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(571,426)",
    d: "m0 0 5 2h13l5 2v2l-2 1h-8v-2h-6l-2 2h-6z",
    fill: "#020101"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(296,400)",
    d: "m0 0h1v6l-2 2-2 5-4 8-5 11-1 3h-3l-1 2 1-4 5-10 2-5 6-12z",
    fill: "#BE7760"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(462,394)",
    d: "m0 0 6 1 2 5-1 9-1-4h-2l-2-2-4 3v-9z",
    fill: "#091015"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(326,664)",
    d: "m0 0 2 1-2 5-8 15-6 12-3-1 8-16z",
    fill: "#8597A8"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(490,531)",
    d: "m0 0 5 4 2 4-1 9-1 4h-2l-1 8-2 1 2-14v-8l-3-7z",
    fill: "#1F2228"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(624,468)",
    d: "m0 0h1l-1 7-6 16v3l-2 1-1 3-2 4-3 4-1-3 4-7 2-8 3-8h3l2-9z",
    fill: "#600D1C"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(334,288)",
    d: "m0 0 2 1-14 12-5 2-13 13-2-1 14-14 4-2v-3l11-6z",
    fill: "#B72924"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(616,273)",
    d: "m0 0 8 1 13 3-3 3-13-1-9-2v-2z",
    fill: "#A9624D"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(528,213)",
    d: "m0 0h34l6 2v1h-56l3-2z",
    fill: "#B02422"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(324,856)",
    d: "m0 0 12 7 22 13 11 6-4 1-10-6-3-1v-2l-6-2-10-6-12-8z",
    fill: "#E33050"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(333,651)",
    d: "m0 0 1 2-9 14-11 21-4 8-4-2 3-1 8-16 10-18z",
    fill: "#BBD0DE"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(458,456)",
    d: "m0 0 2 4 5 16 4 11-1 3-5-12-3-2v-4h-2l-1-11z",
    fill: "#430511"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(552,303)",
    d: "m0 0 1 2 9 2 6 3v4l-9-1-4-3v-2l-5-1v-3z",
    fill: "#110303"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(217,580)",
    d: "m0 0h1l1 11 1 1 3 20 2 10-1 4-3-10-5-28z",
    fill: "#E55743"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 414)",
    d: "m0 0 4 4 1 9 2 3 2 13 2 6 1 12 2 3-1 4-3-5-2-16-2-5-1-10-2-3-1-9z",
    fill: "#A18A8B"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(318,301)",
    d: "m0 0h2v2l-8 7-10 10-6 8h-3l2-5 1-3h3l2-4 5-3z",
    fill: "#BF2E27"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(445,240)",
    d: "m0 0h3l-1 3-10 2-12 5-8 3-6 3-2-1 4-3 3-1 3-3 5-2 10-2 4-2z",
    fill: "#B52723"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(685,594)",
    d: "m0 0 10 4 14 8 4 3-1 2-10-3-1-2-3-1v-2h-2v-2l-4-2-7-3z",
    fill: "#28262C"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(674,344)",
    d: "m0 0 3 6v29l-2 5h-1z",
    fill: "#BBD0DE"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(405,319)",
    d: "m0 0h1v41l-2-4-1-6v-20z",
    fill: "#BBD0DE"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(648,854)",
    d: "m0 0 2 1-5 3-10 3-10 2-2 1h-7v-1h6l1-3 13-4 10-1z",
    fill: "#B72924"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(564,483)",
    d: "m0 0 2 1-3 1-1 3-11 4-11-1-4-1v-2l-2-1 7 1h11l8-3z",
    fill: "#660F1F"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(431,388)",
    d: "m0 0h1l1 28 2 10-1-2h-2l-3-16v-11z",
    fill: "#A9624D"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(619,403)",
    d: "m0 0h2l1 5h2l1 3h-5l-1 9-1 4h-2l-1 3h-1l1-7z",
    fill: "#B77462"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(514,397)",
    d: "m0 0 4 1 2 1v13l-3 9h-3l2-9 1-10-5-1 4-1v-2z",
    fill: "#B38B83"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(564,381)",
    d: "m0 0m-28 0 28 1-3 2h-30l-6 1-7-2v-1z",
    fill: "#BF7E6E"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(573,278)",
    d: "m0 0 5 1 14 6 14 4v1h-10l-11-4-9-4z",
    fill: "#670A1A"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(986,370)",
    d: "m0 0 3 4 3 10 2 6 3 7 2 8 1 1 1 9-2 1-2-10-3-9-2-3v-7h-2l-2-9-2-2z",
    fill: "#5A1422"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(504,313)",
    d: "m0 0 5 2 9 5 17 9 9 4-3 1-15-6-17-10z",
    fill: "#821121"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(640,582)",
    d: "m0 0 16 1 6 2 10 2 9 3v2l-10-2-11-3-20-4z",
    fill: "#8697A7"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(387,89)",
    d: "m0 0 4 1-9 4-6 2-12 5-11 4-7 3v-2h3v-2l9-4 7-2 2-2 7-2z",
    fill: "#959098"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(287,352)",
    d: "m0 0 1 3-3 3-3 5-6 8-2 5h-2l-2 5-5 9-2 1 1-4 8-14 7-10 1-3 5-5z",
    fill: "#B02422"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(966,758)",
    d: "m0 0h2l-2 7-5 8-6 11-6 10-2 2-1 4h-2l2-6 5-7 6-11 3-6 5-8z",
    fill: "#978F96"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(858,617)",
    d: "m0 0 1 3-4 16-6 18h-1l1-12 2-2 4-14 1-7z",
    fill: "#E55045"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(447,465)",
    d: "m0 0h2l5 17 6 15v2h-2l-7-16-3-9z",
    fill: "#8697A7"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(776,126)",
    d: "m0 0 7 2 7 5 15 9v2l5 2 6 4v2h-2l-3-3-16-10-4-3-9-5-6-4z",
    fill: "#988F95"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(347,635)",
    d: "m0 0h2l-2 4-6 7-10 16-2 3h-2l1-5 8-11 6-9h2l2-4z",
    fill: "#8A95A3"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(469,490)",
    d: "m0 0 4 5 6 10 3 1 7 9 3 3-2 2-10-10-7-10-4-7z",
    fill: "#5E0C1C"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(552,412)",
    d: "m0 0 7 14 1 4 4 2v2l6 1 2 1v2l-5-1-7-4-6-9-2-4z",
    fill: "#6B0B1B"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(538,342)",
    d: "m0 0h2l1 2 7 3 20 5 5 2v1l-8-1-11-2-10-3v-2l-7-2z",
    fill: "#680C1C"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(230,461)",
    d: "m0 0h2l-2 11-4 20-2 1v-11l3-10 1-8h2z",
    fill: "#E54F45"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(669,381)",
    d: "m0 0h1v9l-1 12v14l-2 3-1-3v-19l2-15z",
    fill: "#171F24"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(570,373)",
    d: "m0 0 9 1h17l12 3v2h3v2l-11-3-13-2h-15l-2-1z",
    fill: "#701523"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(783,761)",
    d: "m0 0 2 1-26 26-6 5-1-3 11-9 4-5 8-7 5-5z",
    fill: "#E54D45"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(760,659)",
    d: "m0 0 4 3 4 8v2h2l7 15 1 2 4-3-2 5h-4l-9-18-7-12z",
    fill: "#BBD0DE"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(714,610)",
    d: "m0 0 8 6 7 6 1 4 4 5-5-2-4-6-3-3-5-2-3-5z",
    fill: "#1D1B21"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(448,329)",
    d: "m0 0 1 3-2 7 2 1-3 3-3 9-1 8h-1v-12l5-18z",
    fill: "#4C0514"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(677,298)",
    d: "m0 0 3 1h-2l-2 5-3 3 1 5 11-2h5l-1 2-8 2h-11l-1-1v-5h2l2-5z",
    fill: "#343238"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(475,267)",
    d: "m0 0 7 1 1 4-3 5-5 3h-6l-3-5 1-4 3-3zm-3 2-3 2v6l2 2 5-1 5-5-1-4z",
    fill: "#560617"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(175,236)",
    d: "m0 0v3l-5 6-8 11h-2l-2 4-4 6-2 1 2-5 7-11 3-3h2l2-4z",
    fill: "#9C9EA7"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(456,224)",
    d: "m0 0 3 1-4 2-1 2-11 3-10 2h-5l3-2 4-2 7-1 2-2z",
    fill: "#B82925"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(485,866)",
    d: "m0 0 18 2 2 1v2h-13l-15-3v-1z",
    fill: "#BA2B25"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(926,824)",
    d: "m0 0h2v2h-2l-2 4-3 5h-2l-2 4-8 10-2 5-2 2-3-1 6-9h2l2-4 6-8h2l2-5z",
    fill: "#988E94"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(249,797)",
    d: "m0 0 7 6 3 3v2h2l7 8 12 11v2l-4-2-20-20-7-8z",
    fill: "#E33050"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(262,586)",
    d: "m0 0 3 4 5 20 1 10 1 4-3-3-4-16-2-13z",
    fill: "#BA745E"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(566,398)",
    d: "m0 0 4 1h-2v2h4l-2 5-3 1 1 9 2 4h-3l-3-9v-11z",
    fill: "#AA9EA2"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(512,401)",
    d: "m0 0 5 1v10l-3 8-5 3-3-1 4-4h2l2-10v-4h-2z",
    fill: "#BBD0DE"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(137,288)",
    d: "m0 0 1 3h-2l-1 5-6 9-6 11-6 12-1-3 2-5h2l1-6 5-8 6-10 3-6z",
    fill: "#9A8E93"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(315,766)",
    d: "m0 0 5 3 10 10 9 7 4 4-1 2-11-9-3-2v-2l-4-2-9-9z",
    fill: "#B02422"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1018,559)",
    d: "m0 0h1v28l-1 9-1 2-1 10-2-3 1-10 1-3z",
    fill: "#8A95A2"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(231,432)",
    d: "m0 0h1l-1 8-4 12-2 8-2-1 1-11h2v-8l3-4h2z",
    fill: "#B92A25"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(800,362)",
    d: "m0 0 5 5 4 6 9 15 2 3-1 3-2-1-1-6h-2l-3-6-6-9-5-8z",
    fill: "#B02422"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(548,350)",
    d: "m0 0 6 1 20 4 14 1v1h-24l-7-2v-2l-7-1z",
    fill: "#B06C58"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(371,611)",
    d: "m0 0 3 1-5 5-10 9-7 8-4 1 1-3 11-11h2l1-3z",
    fill: "#8497A9"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(665,419)",
    d: "m0 0h2l-2 10-6 11-8 8-5 1 5-5 5-4 4-6 2-8h2z",
    fill: "#2E353A"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(559,392)",
    d: "m0 0 7 2-2 6h-2l-1 5-3-3-2-4 1-4z",
    fill: "#050303"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(788,740)",
    d: "m0 0 1 2-1 2h-2l-1 4-3 1-2 4-12 13h-2l-2 4-3 2 2-4 5-5 9-11 5-5 3-1 1-4z",
    fill: "#B02422"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(280,728)",
    d: "m0 0 4 2 4 4v2h2l3 6 11 13v2l-4-2-7-10-5-5-8-11z",
    fill: "#C13028"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(322,675)",
    d: "m0 0 2 2-2 8-5 10-2 3-2-1 1-6z",
    fill: "#232329"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(172,661)",
    d: "m0 0 2 3 5 13 5 14 5 10-1 3-6-12-3-8-5-13-2-5z",
    fill: "#E33050"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(405,608)",
    d: "m0 0 3 1-20 11-15 12-2-1 10-9 18-11z",
    fill: "#809AAE"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(669,586)",
    d: "m0 0 7 1 10 3 16 8 10 6-2 1-11-6-15-7-15-5z",
    fill: "#BBD0DE"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1015,586)",
    d: "m0 0h1v9l-1 5-1 16-2 5-1 11h-1v-16l2-2 1-19 1-8z",
    fill: "#5F1221"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(461,578)",
    d: "m0 0h2v2l-9 3-17 3-14 2-1-2 21-4 9-1z",
    fill: "#8A95A3"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(628,480)",
    d: "m0 0h1v8h-3v5l-5 6h-1v-5l3-6 1-7z",
    fill: "#050405"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(569,421)",
    d: "m0 0 5 1 3 1v-2h12l4 1 3 1-4 2h-18l-5-3z",
    fill: "#8995A4"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(567,393)",
    d: "m0 0 9 1 20 1v1l-17 1h-7l-8 3v-3z",
    fill: "#2B2B30"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(453,368)",
    d: "m0 0h1l1 8 7 5 8 3h12l-3 2-11 1-10-5-5-3z",
    fill: "#511E2A"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(411,291)",
    d: "m0 0h2l-1 8-1-4-4 1-10 6h-2v2h-3v-3l12-7z",
    fill: "#C67D66"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(802,821)",
    d: "m0 0 2 1-2 3h-2v2l-9 7-13 11-4 3h-2l1-3 8-5 5-5 11-9z",
    fill: "#E33050"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(252,700)",
    d: "m0 0h2l6 11 12 19-1 2-5-6-6-11-5-7-2-1z",
    fill: "#C12F28"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(611,381)",
    d: "m0 0 2 1-2 5-11-1-3-1-22-1v-1l22-1 12 2z",
    fill: "#501724"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(578,363)",
    d: "m0 0 5 1-4 2h-3l-1 4 3 1h5l-4 2-5 1-4-3 1-5 2-2z",
    fill: "#3C050F"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(444,362)",
    d: "m0 0 4 1 1 10-1 1h-5l-1-1v-7z",
    fill: "#010101"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(351,289)",
    d: "m0 0v3l-18 14-6 6h-2l2-4 7-6h2v-2l13-10z",
    fill: "#B02422"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(672,901)",
    d: "m0 0 2 1-10 4-6 2-17 5-1 1h-8l4-2 20-6 6-2z",
    fill: "#E33050"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(539,724)",
    d: "m0 0h9l4 2-21 1v2l-9 3-4 4-3-1 6-5 9-5z",
    fill: "#091116"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(515,594)",
    d: "m0 0 11 3 10 2 17 1v1h-25l-12-4z",
    fill: "#750D1E"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(841,435)",
    d: "m0 0 3 1 5 16 2 8 1 1v7l-2-1-7-24z",
    fill: "#E44C46"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(486,394)",
    d: "m0 0h21v1l-16 1-11 2-1 10-2-1-1-7 4-4z",
    fill: "#681221"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(733,336)",
    d: "m0 0 5 2 7 6 6 7 2 1 2 5v3l-12-13-10-10z",
    fill: "#C37C65"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(791,673)",
    d: "m0 0 1 2-2 5h-2l-1 5-8 11-3-3 5-5 9-14z",
    fill: "#BD755F"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(574,477)",
    d: "m0 0h6l1 1v5l-3 5-1-3v-4l-4 2-7 3-3-1 7-5h3z",
    fill: "#400510"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(840,408)",
    d: "m0 0h2l4 8 3 8 1 7-2-3-1-4-3-1-5-12z",
    fill: "#B82A25"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(90,391)",
    d: "m0 0h1v7l-1 2h-2v7l-2 3-2 9-2 4-1 6h-1v-7l2-4 2-10 4-12z",
    fill: "#5D1523"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(497,400)",
    d: "m0 0h8l6 7-1 9-5 4-6-1v-1l7-1 1-4 2-1 1-4h-2l-3-4-8-2z",
    fill: "#561E29"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(955,306)",
    d: "m0 0 4 3 8 17v2h2l3 8-4-1v-5l-3-1-2-6-2-2v-5l-3-1-2-5z",
    fill: "#511724"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(496,262)",
    d: "m0 0 8 1-1 2-8 3-2 1h-6l-1-3z",
    fill: "#560617"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(544,226)",
    d: "m0 0h18l6 1 18 1v1h-30l-12-2z",
    fill: "#B02422"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(629,73)",
    d: "m0 0 13 3 9 2 2 1 9 1 3 3-4-1-13-1-2-1v-2l-16-1z",
    fill: "#561321"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(573,65)",
    d: "m0 0h15l17 3 13 1-4 2-22-2-8-2-11-1z",
    fill: "#8D93A0"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(297,754)",
    d: "m0 0 4 1 11 11v2l4 2 4 4v2l-4-2-12-12v-2l-4-2v-2l-3-1z",
    fill: "#E55443"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(847,627)",
    d: "m0 0h1l-1 9-8 23-1 2-2-1 3-9 5-14 2-9z",
    fill: "#C33129"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(433,444)",
    d: "m0 0h3l2 3 7 3 4 2 1 9v5l-2-1-2-9-2-4-12-6z",
    fill: "#282C32"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(549,402)",
    d: "m0 0h1l3 18 5 9 2 4-6-3-4-7v-7l-1-4z",
    fill: "#AF6A57"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(570,363)",
    d: "m0 0h8v1l-6 2-1 5 5 2h16v1l-19 1-5-2-1-6z",
    fill: "#5F0819"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(278,360)",
    d: "m0 0h2l-1 5-8 11-6 11-3 2 2-5 6-11 6-9z",
    fill: "#C33129"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(275,353)",
    d: "m0 0v3l-7 11-5 7-2 5-3 5h-2l1-4 2-4h2l1-5 11-16z",
    fill: "#E55443"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(612,316)",
    d: "m0 0h33l-3 1v2h-27z",
    fill: "#3C050F"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(539,295)",
    d: "m0 0h5l2 3v5l-5 1-4-4 1-4z",
    fill: "#110304"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(549,262)",
    d: "m0 0h19l4 3v2l-4-1v-2h-14l-1 3-5-2z",
    fill: "#39040E"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(592,397)",
    d: "m0 0h8l3 4-1 10-3 4v-7l2-6-6-1v-2h-3z",
    fill: "#D98C70"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(370,318)",
    d: "m0 0 2 1-9 7-5 5-5 4-5 2 1-3 5-4h2l2-4 8-6z",
    fill: "#C07861"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(548,260)",
    d: "m0 0 20 1v1l-19 1v2l11 5v2l-5-2-10-5-1-4z",
    fill: "#560617"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(474,228)",
    d: "m0 0h14l-4 2-16 3-8 2-4-1 3-2 13-3z",
    fill: "#E54E45"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(450,74)",
    d: "m0 0 4 1-2 2-17 3-12 2h-2v2h-2l1-3 13-3 6-2 9-1z",
    fill: "#5D1321"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(918,867)",
    d: "m0 0h2l-1 4-4 5h-2l-2 4-3 3h-2v2h-2l-2 4-3 3-3-1 7-7 1-2 5-3 5-5z",
    fill: "#394048"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(721,757)",
    d: "m0 0 4 1-7 7-10 6v-4l9-7h3z",
    fill: "#4B0513"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(828,696)",
    d: "m0 0 1 3-7 13h-2l-2 6-5 7h-2l2-4 6-11h2l2-5 4-8z",
    fill: "#E55444"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(709,666)",
    d: "m0 0h1l1 7h3l1 1v8l-5 1h-1z",
    fill: "#110303"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(476,610)",
    d: "m0 0 5 1 7 5v2l5 2-3 2-4-2v-2l-6-2v-2h-3z",
    fill: "#010101"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(449,467)",
    d: "m0 0 4 2v5l4 10 1 6h2l1 7h-2l-7-17z",
    fill: "#322930"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(560,433)",
    d: "m0 0 12 5 16 1h8v1l-5 1h-13l-11-1-7-4z",
    fill: "#A9624D"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(546,298)",
    d: "m0 0 2 4 9-1 3 3-6-1-4 1v6h2v2l-3-1-2-5h-8l3-2 3-1z",
    fill: "#560617"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(852,904)",
    d: "m0 0 2 1-8 7-9 7-7 6-6 3 2-4 6-4h2v-2l17-13z",
    fill: "#979096"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(365,818)",
    d: "m0 0 5 2 11 7 7 4 5 2 2 3-7-2-7-4-16-10z",
    fill: "#E55543"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(889,701)",
    d: "m0 0 1 4-6 11-2 5-9 15-1-3 9-16 6-13h2z",
    fill: "#E33050"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(592,399)",
    d: "m0 0h3v2l6 1v5l-1 5-2 4h-1l-1-8-2-5v-3z",
    fill: "#BBD0DE"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(449,392)",
    d: "m0 0 5 5 2 8 5 1-2 2-5-1-3-4-2-7z",
    fill: "#470512"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(502,358)",
    d: "m0 0 8 3v1l-22 1-8 2 1-3 13-2z",
    fill: "#B67361"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(520,226)",
    d: "m0 0h16v1l-12 2-20 1-7-1v-1z",
    fill: "#B02422"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(397,87)",
    d: "m0 0h5l-4 2-1 2-10 2-2 2-7 2-10 4-3-1 5-3 6-2 10-4 9-2z",
    fill: "#5E1623"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(288,836)",
    d: "m0 0h2l5 5 13 10 9 7h-3l-6-4-9-7-11-9z",
    fill: "#E33050"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(162,624)",
    d: "m0 0 3 4 2 12 5 16v5l-2-2-5-17-3-13z",
    fill: "#E33050"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(384,617)",
    d: "m0 0m-1 1m-1 1m-1 1m-2 1h2l-2 4-8 7-5 5-2-2 5-6z",
    fill: "#293F45"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(584,525)",
    d: "m0 0h4l-2 4-7 4-9 1-4-1 12-4z",
    fill: "#460512"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(637,438)",
    d: "m0 0h5v2l-6 2-4 3-2 6v5h-2l1-16z",
    fill: "#570816"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(478,367)",
    d: "m0 0 3 1-6 4-1 4 3 1-2 1 1 2-6-1-1-7 2-2z",
    fill: "#430511"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(325,304)",
    d: "m0 0h3v2l-8 7-13 13-1 2h-2v-3l5-5h2l1-3h2l1-3h2l1-3h2v-2z",
    fill: "#E55643"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(477,291)",
    d: "m0 0 6 4 7 7-4 2-2-5-7-3h-3-2l2-4z",
    fill: "#460512"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(608,232)",
    d: "m0 0 10 1 4 2v2l10 2-3 1h-6l-2-1v-2l-11-1-2-1z",
    fill: "#B92A25"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(427,54)",
    d: "m0 0h13v1l-12 2-18 5h-5l4-2 6-1v-2z",
    fill: "#70747E"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(442,1007)",
    d: "m0 0 21 2 7 2 6 2v1h-7l-5-2-17-2-5-2z",
    fill: "#561926"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(235,640)",
    d: "m0 0 2 3 7 18 2 6v5l-2-4-6-14-3-9z",
    fill: "#E55543"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(224,493)",
    d: "m0 0 1 3-2 16-1 16h-1v-27l2-6z",
    fill: "#E55343"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(496,428)",
    d: "m0 0h11l4 1-2 4-17-2z",
    fill: "#020101"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(507,394)",
    d: "m0 0h7l7 3v11h-1v-9l-10-2-19-1v-1z",
    fill: "#402B34"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(771,322)",
    d: "m0 0 5 3 8 8 7 9v2h-2l-3-4v-2h-2v-2h-2l-7-8-4-4z",
    fill: "#E44747"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(499,65)",
    d: "m0 0h14v1l-29 4h-10v-1z",
    fill: "#8E939F"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(283,941)",
    d: "m0 0 5 1v2l10 4 1 2 5 1v2l5 3 1 2-5-2-9-5v-2l-5-1-8-6z",
    fill: "#591624"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(365,888)",
    d: "m0 0 9 3 12 6 13 5 1 2-6-1-20-9-8-4z",
    fill: "#E33050"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(267,808)",
    d: "m0 0 4 2 4 4v2h2l5 5 5 4v2l4 2 2 3-5-2-8-8-8-7-5-5z",
    fill: "#E33050"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(232,766)",
    d: "m0 0 5 5 18 22v3l-4-5-5-5-11-14-3-4z",
    fill: "#E33050"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(822,688)",
    d: "m0 0 1 2-7 14h-2l-1 4-7 10-1-2 9-15h2l1-5z",
    fill: "#B02422"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(753,654)",
    d: "m0 0 4 5 9 15 1 4h-2l-5-9-6-9-2-2z",
    fill: "#2B3136"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(65,570)",
    d: "m0 0h1l2 18 2 15v8h-1l-2-15-2-10z",
    fill: "#8C94A1"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(608,575)",
    d: "m0 0 12 3 14 2 6 2v1h-7l-7-2-13-2-5-2z",
    fill: "#8896A5"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(579,400)",
    d: "m0 0h7v1l-5 1-4 3-2 1v7l5 5 6 2v1h-6l-7-6-1-7 3-5z",
    fill: "#4A222D"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(480,398)",
    d: "m0 0h3v2h-2l2 11 3 8 3 2v2l3 1-5-1-5-6-2-5-1-12z",
    fill: "#B1837B"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(603,361)",
    d: "m0 0 9 3 6 3 3 6-1 5h-1l-2-7-5-4-12-4z",
    fill: "#B26E5B"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(593,266)",
    d: "m0 0h7l16 4 9 3 3 3-12-3-5-2-14-3z",
    fill: "#BC2C26"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(241,142)",
    d: "m0 0 2 1-5 5-7 6-4 2-5 5-4 3-2-1 11-10 12-9z",
    fill: "#95ABBB"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(618,1011)",
    d: "m0 0 2 1-3 2-17 1-8 2h-8l4-3 8-1 20-1z",
    fill: "#67101F"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(430,854)",
    d: "m0 0 5 1 13 4 16 4v1h-9v-2l-11-1-7-3-6-2z",
    fill: "#B02422"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(416,837)",
    d: "m0 0 7 1 9 4 12 4 4 3-7-1-9-3-13-5z",
    fill: "#C33129"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(857,558)",
    d: "m0 0h1v13l-2 13-1 10h-1v-18z",
    fill: "#B02422"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(268,468)",
    d: "m0 0h1v11l-6 21h-1v-7l2-5 2-12z",
    fill: "#C07861"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(617,400)",
    d: "m0 0h1v13l-4 12-2 1 4-23z",
    fill: "#700E1E"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(456,322)",
    d: "m0 0 3 1-1 7-1 4-3 1-1-1v-9z",
    fill: "#010101"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(656,246)",
    d: "m0 0 5 1 10 5 2 4h-3v-2l-7-1-2-2-5-1z",
    fill: "#BA2B25"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(706,988)",
    d: "m0 0 3 1-8 3-10 3-3 2-10 2v-3l11-1 1-3h8v-2z",
    fill: "#5A1623"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(137,794)",
    d: "m0 0 4 4 10 16 5 7-1 3-9-13-2-3v-3h-2l-5-9z",
    fill: "#949099"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(775,758)",
    d: "m0 0v3l-21 21-2-1 4-4 3-5 5-3 5-5z",
    fill: "#C02F28"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(767,678)",
    d: "m0 0 3 4 5 11v4h-3l-4-10 1-3-3-1z",
    fill: "#242127"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(858,590)",
    d: "m0 0 1 2-2 7-1 12-3 7h-1l1-10 2-11z",
    fill: "#E55543"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(531,540)",
    d: "m0 0h12v4h-14z",
    fill: "#010101"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(854,493)",
    d: "m0 0h1l3 25v10h-1l-3-16z",
    fill: "#B02422"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(521,399)",
    d: "m0 0h1v14l-5 10-3 3h-5l1-2 5-3h2l2-9z",
    fill: "#5B1321"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(560,413)",
    d: "m0 0h4l1 8-3 2-4-2v-7z",
    fill: "#040405"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(586,396)",
    d: "m0 0h11v1h-5v5l2 2v10h-1l-1-10-6-3z",
    fill: "#949099"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(619,394)",
    d: "m0 0h5l1 6-2-2-1 8-1-3h-2l-1 4-1-10z",
    fill: "#2D353B"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(269,372)",
    d: "m0 0 1 2-8 15-5 8-1-4 8-14z",
    fill: "#E54F45"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(974,293)",
    d: "m0 0 3 3 5 9v2h2v2h2l2 11-3-4-4-8v-2h-2l-5-9z",
    fill: "#868D9A"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(597,220)",
    d: "m0 0 11 1 5 2 9 1 2 1v2l-9-1-18-4z",
    fill: "#C33129"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(655,56)",
    d: "m0 0 13 2 20 5v2l4 1-7-1-2-1-9-1-7-3-12-3z",
    fill: "#83929F"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(400,831)",
    d: "m0 0 6 2 12 5 6 3v1h-6l-18-9z",
    fill: "#E44E46"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(371,826)",
    d: "m0 0 7 1 8 5 3 3 5 3-2 1-11-6-10-6z",
    fill: "#B72924"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(304,757)",
    d: "m0 0 3 1 5 6 14 14 2 1v2l-4-2-5-5-7-6-7-8z",
    fill: "#C33129"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(217,600)",
    d: "m0 0h2l4 21 2 9-3-3-5-21z",
    fill: "#C33129"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(486,563)",
    d: "m0 0 2 1-2 7-5 4-15 4-3-1 3-2 12-3 5-1z",
    fill: "#8497A9"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(221,560)",
    d: "m0 0h1l2 21v11h-2l-1-7z",
    fill: "#E55543"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(635,449)",
    d: "m0 0h3l-1 9-3 5-1 4-1-3h-2v-2h2l1-7z",
    fill: "#010101"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(350,277)",
    d: "m0 0h2v2l-9 7-4 4-5 3-3 1v2l-3-1 11-10 9-6z",
    fill: "#E54D45"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(375,256)",
    d: "m0 0h5l-4 4-7 6-7 2-5 2 5-5 6-3 6-4z",
    fill: "#B52824"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(891,218)",
    d: "m0 0 7 6 9 11 1 3h2l-1 2-3-2v-2l-4-2-4-5v-2h-2v-3l-4-2z",
    fill: "#5C1221"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(419,837)",
    d: "m0 0h7l5 3 4 1 8 3 6 3-3 1-22-8-5-2z",
    fill: "#B02422"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(552,726)",
    d: "m0 0h5l11 7 7 9-1 2-3-3v-2h-2l-4-5-9-5-4-2z",
    fill: "#091116"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(76,648)",
    d: "m0 0 3 3 1 2 1 10 2 3 2 10 1 4h-2l-2-5-1-7-2-3-2-12z",
    fill: "#A18B8C"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(431,586)",
    d: "m0 0h5l-4 2h-2l-1 2h-7v2l-7 1-4 2-4-1 9-4z",
    fill: "#33272F"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1013,469)",
    d: "m0 0h1l1 16 2 7v7l-3-1-1-7z",
    fill: "#63101F"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(429,416)",
    d: "m0 0 2 3 1 5h2l3 6v2l-4 1v-3h-2l-1-4 1-2h-2l-2-6z",
    fill: "#4E0713"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(104,728)",
    d: "m0 0 4 5 3 8 2 6 3 3 2 4-1 3-3-4-3-5-2-6-5-10z",
    fill: "#581926"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(298,682)",
    d: "m0 0 3 3 6 9 4 4-3 3-9-13z",
    fill: "#C37B64"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(486,595)",
    d: "m0 0 5 1 10 6 3 2-6 1-10-7-2-1z",
    fill: "#7B9FB1"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(657,397)",
    d: "m0 0h1l1 12 1 3h-2l-1 7-3 7-2 1 1-6 3-10z",
    fill: "#5B0817"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(508,327)",
    d: "m0 0h3v2l5 2 8 4 6 6-5-1-2-1v-2l-5-2-8-3v-2l-2-1z",
    fill: "#410510"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(413,294)",
    d: "m0 0h2l1 6-2 8-4 2 1-9z",
    fill: "#242228"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(673,256)",
    d: "m0 0 5 1 14 7 10 6-3 1-4-3-13-6-5-3z",
    fill: "#B02422"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(578,620)",
    d: "m0 0 4 1-10 5-15 4h-5v-2l16-3z",
    fill: "#7AA1B3"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(992,382)",
    d: "m0 0 2 1 2 9 2 3 1 7 2 3 1 9h-2l-1-8-2-3-2-8-2-5-2-7z",
    fill: "#978F96"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(810,361)",
    d: "m0 0 3 1 7 11 6 10-4-1-2-6h-2l-4-8-4-6z",
    fill: "#E54C46"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(782,752)",
    d: "m0 0h2l-2 4-11 12-1 2-3-1 6-7z",
    fill: "#E55344"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(237,665)",
    d: "m0 0h2l3 6 4 10 2 3v4h-2l-7-16z",
    fill: "#E54E45"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(629,582)",
    d: "m0 0 14 1 7 3 1 2h-5l-3-2-12-1-2-1z",
    fill: "#1D1F25"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(509,477)",
    d: "m0 0h1l1 7 4 2 5 5 3 5-5-2-9-9-1-7z",
    fill: "#740E1D"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(510,384)",
    d: "m0 0h10l3 1v2h9l-1 2h-9l-8-1z",
    fill: "#580816"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(565,350)",
    d: "m0 0 9 1 4 2 14 1v1h-19l-8-3z",
    fill: "#460512"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(642,278)",
    d: "m0 0 6 1 8 4-3 1-7-3h-5l-4 2h-8v-2l8-1z",
    fill: "#560617"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(608,278)",
    d: "m0 0 20 2v3h-9l-7-1-1-2z",
    fill: "#4A0513"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(910,240)",
    d: "m0 0 5 5 9 11 4 5-1 3-4-5v-2h-2l-4-6-4-4v-3h-2z",
    fill: "#5D1422"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(664,240)",
    d: "m0 0 8 1 17 9 1 2-7-2-10-5-9-4z",
    fill: "#C33129"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(848,178)",
    d: "m0 0 5 2 5 4 5 5 6 7-5-2v-2h-2l-4-4-10-8z",
    fill: "#5B1422"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(888,869)",
    d: "m0 0 2 1-9 10-5 5h-2l-1 3-4 2 2-4 5-4 4-5 3-3h2l2-4z",
    fill: "#988F95"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(272,712)",
    d: "m0 0h2l3 5v2l3 1 5 9 2 5-7-6-6-11z",
    fill: "#B02422"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(249,674)",
    d: "m0 0 3 1 4 8 5 8 3 5-2 1-4-7v-2h-3l-6-13z",
    fill: "#BA2B25"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(455,493)",
    d: "m0 0 2 1 7 14 8 11h-3l-8-11-6-12z",
    fill: "#BBD0DE"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(856,448)",
    d: "m0 0 2 4 3 12v5l-3-1-2-9z",
    fill: "#B82925"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(485,414)",
    d: "m0 0 1 2 3-1 4 5 3 1v2h-7v-2l-4-2-1-4z",
    fill: "#92AABC"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(464,402)",
    d: "m0 0 2 1v2h2l1 13-2-3-3-7-4 1 2-5z",
    fill: "#671926"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(410,381)",
    d: "m0 0 2 1 4 23-2 3-2-12-2-7z",
    fill: "#8398AA"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(645,378)",
    d: "m0 0h6l-4 2-7 10-2 5-3 1 1-7h2l2-5z",
    fill: "#5C1421"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(606,367)",
    d: "m0 0 5 1 5 3 1 5-1 2-8-2 4-3-4-4z",
    fill: "#3B040E"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(411,364)",
    d: "m0 0h2l2 16-2 1v-3h-2l-1-2v-11z",
    fill: "#21181F"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(681,296)",
    d: "m0 0 5 2 9 6 1 4-4-1v-3l-4-1-8-4z",
    fill: "#BD7863"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(545,293)",
    d: "m0 0 4 3 1 3 10 1v2l6 1v1h-6l-3-2h-9l-1-4h-2z",
    fill: "#801020"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(872,168)",
    d: "m0 0 6 2 6 8 7 6v2h-3v-2h-2l-6-7-4-4v-2l-4-2z",
    fill: "#8F98A2"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(359,983)",
    d: "m0 0 7 1v2l8 1 2 2 8 2 4 3h-5l-3-2-7-2-10-4z",
    fill: "#9B8D92"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(667,834)",
    d: "m0 0h4v2l-15 6-7-1v-1l7-2 1-1 8-1z",
    fill: "#BD2D27"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(993,696)",
    d: "m0 0h1v6h-2l-2 9-4 10-3 7-1-3 5-14 2-3 2-7z",
    fill: "#9F8B8D"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(230,652)",
    d: "m0 0 2 4 8 20 2 4-1 3-4-7-3-9-4-9z",
    fill: "#B02422"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(378,609)",
    d: "m0 0v3l-5 4h-2l-1 3-6 4-2 3-3-1 7-7z",
    fill: "#363138"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(604,404)",
    d: "m0 0h1v10l-3 7-6 5h-4v-2l5-2 3-1z",
    fill: "#541E2A"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(96,370)",
    d: "m0 0h1v5l-2 2-3 10-3 9-2 5h-1v-5l2-3 2-9h2l2-10z",
    fill: "#9E8C8F"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(648,344)",
    d: "m0 0h3v2l-17 6h-4v-2l12-4z",
    fill: "#661221"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(292,325)",
    d: "m0 0 2 1-1 5-10 11-2-1 3-3 2-5z",
    fill: "#BB2C26"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(712,812)",
    d: "m0 0 2 1-5 5-10 6-5 2-3-1 12-7 7-4z",
    fill: "#E44947"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(725,800)",
    d: "m0 0 2 1-7 6-5 5h-5l2-3h2l1-3 5-1v-2z",
    fill: "#B72924"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(350,634)",
    d: "m0 0h2v6l-2 3-8 2 2-4z",
    fill: "#21242A"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(232,624)",
    d: "m0 0 3 3 2 9 3 9-1 3-3-5-4-14z",
    fill: "#C33129"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(249,417)",
    d: "m0 0h1l-1 7h-2l-1 7-4 10-3 4 1-6 5-12 2-6z",
    fill: "#B02422"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(600,397)",
    d: "m0 0 4 2 1 5-3 13-2 4-3 1 5-15v-6z",
    fill: "#AD857F"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(779,391)",
    d: "m0 0 5 3 6 11v5l-4-5-5-9z",
    fill: "#C77E66"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(574,382)",
    d: "m0 0h18v1l-17 1-3 2h-11l1-2z",
    fill: "#791020"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(753,354)",
    d: "m0 0 5 5 6 7v2h2l2 5-6-4-6-7-2-5z",
    fill: "#B8715B"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(282,352)",
    d: "m0 0h2l-2 5-2 3h-2l-2 6-5 7-2-2z",
    fill: "#E44847"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(694,313)",
    d: "m0 0 2 2-11 9-4 3-3-1 1-3 4-2 5-1 2-4z",
    fill: "#2A2B31"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(471,310)",
    d: "m0 0 4 1-3 6h-2l-2 5-5 6-1-2 7-11 2-2z",
    fill: "#5E0818"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(752,113)",
    d: "m0 0 6 2 18 9v2l-6-2-7-3-1-2-6-2-4-2z",
    fill: "#949199"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(758,856)",
    d: "m0 0h2l-1 3-4 1v2l-5 3-8 5-6 2 2-3 9-5z",
    fill: "#E33050"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(609,518)",
    d: "m0 0h2l-2 4-4 4h-2v2l-3 3h-2l-1 5h-1v-5l5-5z",
    fill: "#2D353A"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(491,518)",
    d: "m0 0h3v2l4 2 9 5v1h-5l-11-7z",
    fill: "#6B101F"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(436,448)",
    d: "m0 0 8 3 4 8v6l-2-1-3-10-8-4z",
    fill: "#8298AB"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(822,398)",
    d: "m0 0 4 5 8 17-1 3v-2h-2l-3-8-6-11z",
    fill: "#B02422"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(682,301)",
    d: "m0 0h5l2 5-3 1h-8l2-4z",
    fill: "#FAFCFC"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(330,994)",
    d: "m0 0 6 2 19 8v1l-7-1-8-3-10-5z",
    fill: "#1F2127"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(257,924)",
    d: "m0 0 11 7 5 4 7 4v2l-6-2-7-6-7-4-3-3z",
    fill: "#93919A"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(668,836)",
    d: "m0 0m-2 1h2v2l-5 3-15 5-2-1 10-5z",
    fill: "#E55643"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(311,699)",
    d: "m0 0 2 3 5 10-1 3-7-9z",
    fill: "#4D0514"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(246,668)",
    d: "m0 0 2 2 6 14 3 6-1 2-5-8-5-10z",
    fill: "#E4414A"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(67,575)",
    d: "m0 0h1l2 7v21h-1l-2-15z",
    fill: "#521925"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(611,513)",
    d: "m0 0 4 1-3 4-5 3-8 7-2-1 5-5h2v-2h2l1-3h4z",
    fill: "#18161C"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(559,483)",
    d: "m0 0h5l-5 4-7 2h-11l-7-2v-1l17 1h4v-2z",
    fill: "#AD6753"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(573,426)",
    d: "m0 0h22l-1 3h-18z",
    fill: "#091116"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(511,407)",
    d: "m0 0 4 2-3 9h-2l-1 3h-3l4-8z",
    fill: "#8A96A4"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(824,383)",
    d: "m0 0 3 1 9 19 1 2-3-1-10-19z",
    fill: "#E55344"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(513,362)",
    d: "m0 0h7l2 3v8l-4 2 1-6-3-5z",
    fill: "#B4705D"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(791,343)",
    d: "m0 0 5 5 1 4h2l3 4v2h2l1 4-4-2-11-15z",
    fill: "#E44D46"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(656,284)",
    d: "m0 0 7 1 17 9-1 3-3-3-12-5-8-4z",
    fill: "#560617"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(272,732)",
    d: "m0 0h2l11 15-1 2-8-7-3-7z",
    fill: "#BF2E27"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1009,717)",
    d: "m0 0h1v5l-6 12h-2v5h-2l-1 2 2-10h3l3-9z",
    fill: "#464B51"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(229,616)",
    d: "m0 0h1l5 19 1 5h-2l-3-8-3-11z",
    fill: "#E44C46"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(232,616)",
    d: "m0 0h1l1 7 2 2 2 10 2 2v8l-2-3-3-9-2-8-1-1z",
    fill: "#B02422"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(502,589)",
    d: "m0 0 6 1 7 3-1 4-9-3v-3l-3-1z",
    fill: "#560816"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(588,568)",
    d: "m0 0 2 1 5 11-2 4-4 3h-2v-2h2v-2l4-1-1-4h-2z",
    fill: "#B47768"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(578,540)",
    d: "m0 0h6l1 2-2 3v-2l-5 1-7 2-2-3z",
    fill: "#5B1422"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(613,490)",
    d: "m0 0 1 3-9 14-3 2 2-7 8-10z",
    fill: "#B06B58"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(647,379)",
    d: "m0 0h5l3 5 1 6-1 7h-1l-1-9h-1l-1-6-7 1z",
    fill: "#B67D70"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(639,367)",
    d: "m0 0 1 3-9 8-4 2h-3v-2l10-6z",
    fill: "#681120"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(374,273)",
    d: "m0 0 2 1-2 3-7 3-11 8h-2l1-3 11-7 5-4z",
    fill: "#B02422"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(827,161)",
    d: "m0 0 5 2v2l5 2 10 9v2l-3-1-4-4v-2l-4-2-5-2-4-4z",
    fill: "#5D1221"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(776,128)",
    d: "m0 0 5 1 7 5 6 3 5 4-1 2-9-6-3-1-3-3-7-4z",
    fill: "#5F101F"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(240,645)",
    d: "m0 0 3 3 1 8h2l4 10-1 4-3-5-6-17z",
    fill: "#B02422"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(600,558)",
    d: "m0 0h2l5 12 2 5h-3l-6-13z",
    fill: "#8796A6"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(559,496)",
    d: "m0 0h2l1 3-2 1h-27v-3l2 1h19z",
    fill: "#400510"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(231,475)",
    d: "m0 0h1v5h-2v9l-2 9-2 2 1-8 2-15z",
    fill: "#B02422"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(434,442)",
    d: "m0 0h6l2 4 5 3-1 3-4-3-5-2-1-3h-2z",
    fill: "#040608"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(250,390)",
    d: "m0 0 1 2-8 16-1-3 3-9z",
    fill: "#BD2D26"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(370,270)",
    d: "m0 0 2 1-5 5-5 2v2l-7 4h-3l8-7 8-5h2z",
    fill: "#E55443"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(448,235)",
    d: "m0 0h8l-4 2-19 6 1-3 4-2 9-2z",
    fill: "#E55244"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(488,230)",
    d: "m0 0 4 1-4 2-11 1-5 2h-8v-1l8-2 1-1 12-1z",
    fill: "#B02422"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(758,966)",
    d: "m0 0 4 1-13 7-10 4-3-1 8-4 7-3z",
    fill: "#9B8E92"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(684,839)",
    d: "m0 0 3 1-12 6-7 3-1 1h-6l3-2 16-7z",
    fill: "#B02422"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(847,623)",
    d: "m0 0 1 4-2 5-4 14-2 2 4-20z",
    fill: "#B02422"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(419,587)",
    d: "m0 0 4 1-7 3-11 4h-3v-2l11-4z",
    fill: "#8D94A0"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(584,542)",
    d: "m0 0h2l1 5v15h-1l-2-8z",
    fill: "#770E1E"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(704,272)",
    d: "m0 0 5 2 7 5 4 1 5 6-4-1-10-7-7-4z",
    fill: "#B02422"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(674,253)",
    d: "m0 0h6v2l5 1 9 5-2 2-16-8z",
    fill: "#E55145"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(875,200)",
    d: "m0 0 4 1 3 3v2l3 1v3l3 1 2 4-4-2v-2l-3-1v-2l-3-1-5-6z",
    fill: "#A1A7B2"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(338,973)",
    d: "m0 0 4 1 11 5 7 3-1 2-9-3-10-5z",
    fill: "#939199"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 670)",
    d: "m0 0 2 1-1 9-2 3-2 9-3 4v-5l2-3 2-9 1-1z",
    fill: "#959098"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(799,654)",
    d: "m0 0 1 3-3 9h-2l-1 6-4 2 2-5 6-13z",
    fill: "#C67E67"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(704,654)",
    d: "m0 0 5 5 1 7-2 7h-1v-12l-3-4z",
    fill: "#231118"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(341,645)",
    d: "m0 0 2 2-4 5-2 3-1 5-4 3-2-1 10-16z",
    fill: "#352930"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(587,556)",
    d: "m0 0 4 2v6l1 4-1 3v-2l-3-1-1-2z",
    fill: "#540815"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(496,543)",
    d: "m0 0 3 3v8l-4 4-1-6z",
    fill: "#010101"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(460,498)",
    d: "m0 0 3 4 7 11v3l-5-5-6-10z",
    fill: "#8199AC"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(68,493)",
    d: "m0 0 2 1v7l-1 2-1 9h-2l1-16z",
    fill: "#4E1825"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(847,432)",
    d: "m0 0 3 4 5 15v3h-2l-4-10z",
    fill: "#E44A46"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(672,390)",
    d: "m0 0h1v7l-3 16h-1v-13z",
    fill: "#809AAE"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(798,344)",
    d: "m0 0 4 2 6 9 3 4-1 2-4-4v-2h-2v-3h-2l-4-6z",
    fill: "#E55643"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(520,338)",
    d: "m0 0 5 1 11 4 8 4-3 1-15-6-6-3z",
    fill: "#761020"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(673,327)",
    d: "m0 0 2 2-5 6v13h-2v-15l3-4h2z",
    fill: "#091116"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(685,835)",
    d: "m0 0v3l-9 4-8 3 1-3 5-3z",
    fill: "#E55144"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(289,741)",
    d: "m0 0 2 1v2l3 1 6 9h-4v-2h-2l-5-8z",
    fill: "#E44C46"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(804,740)",
    d: "m0 0v3l-2 4h-2l-2 4-7 9h-2l2-4 8-10 1-2h2z",
    fill: "#B02422"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(337,737)",
    d: "m0 0 4 2 12 12h-3l-10-9-3-3z",
    fill: "#660A1A"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(775,697)",
    d: "m0 0h2l-1 4-5 8h-2l1-5 4-6z",
    fill: "#4A0513"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(348,657)",
    d: "m0 0v3l-5 7h-2l-1 3h-2l1-4 3-4h2l2-4z",
    fill: "#274951"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1007,645)",
    d: "m0 0h1v9l-2 4-2 10-3 3 1-5 3-12z",
    fill: "#9D8C8F"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(491,541)",
    d: "m0 0h1v11l-2 10-3 2 1-6z",
    fill: "#8C94A1"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(473,516)",
    d: "m0 0 7 6 9 8-1 2-8-6v-2h-2v-2h-2l-3-4z",
    fill: "#2E353A"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(518,494)",
    d: "m0 0 5 2 9 4v2l-9-1-5-6z",
    fill: "#B4705E"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(626,488)",
    d: "m0 0h3l-3 9-3 5h-2l-1-3 5-6z",
    fill: "#25272D"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(511,472)",
    d: "m0 0h6l5 4-1 2-4-3h-5l-3 3-1 5h-1v-7z",
    fill: "#A9624D"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(255,397)",
    d: "m0 0 1 3-6 12-3 7h-1v-5l2-6 3-4z",
    fill: "#E44847"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(448,398)",
    d: "m0 0 2 3 3 6 2 2 4 1v2l-7-1-4-5z",
    fill: "#A9624D"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(261,368)",
    d: "m0 0 1 2-10 18-4 4 2-5 5-10z",
    fill: "#B02422"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(736,290)",
    d: "m0 0 5 2 7 5 5 5 1 2-4-1-6-5v-2h-3v-2l-4-2z",
    fill: "#E55743"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(536,289)",
    d: "m0 0 7 2 2 3h-10l-4 1 2-4z",
    fill: "#881421"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(815,266)",
    d: "m0 0 4 2 8 8v2h2l3 4-1 2-9-9-7-8z",
    fill: "#E33050"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(420,239)",
    d: "m0 0 2 1-1 2-12 4-3 2h-5l4-3z",
    fill: "#E44549"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(668 1e3)",
    d: "m0 0 3 1-4 3-9 1-4 2h-8v-1l7-2 2-1 10-1z",
    fill: "#A08B8D"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(472,855)",
    d: "m0 0 17 1 3 2-1 1-11-1-8-2z",
    fill: "#C02F28"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(730,800)",
    d: "m0 0m-1 1m-1 1 2 2-5 2v2l-10 6-2-1 13-10z",
    fill: "#E55443"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(244,687)",
    d: "m0 0 4 5 2 1 3 5v6l-3-1v-5h-2l-4-8z",
    fill: "#B62824"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(601,564)",
    d: "m0 0 2 2 5 10 5 2-1 2-5-2-3-3-1-5-3-1z",
    fill: "#2C2F35"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(636,395)",
    d: "m0 0 1 2-3 10-5 3-4-2v-1l6-1 4-10z",
    fill: "#740D1D"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(471,381)",
    d: "m0 0h7l6 2v1l-6 1h-8l-1-3z",
    fill: "#809AAE"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(618,368)",
    d: "m0 0 4 2 1 4 5 2-4 3h-4v-6z",
    fill: "#B57F73"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(219,336)",
    d: "m0 0 1 2-8 14-4 6-1-3 8-13z",
    fill: "#E33050"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(720,279)",
    d: "m0 0 5 1 6 4v2l5 1-1 4-2-1v-2l-5-2-8-6z",
    fill: "#E4414A"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(203,207)",
    d: "m0 0v3l-7 7-6 7-3-1 5-5h2l2-4 5-6z",
    fill: "#561624"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(691,994)",
    d: "m0 0 3 1-4 3-7 1-3 2-9 1-1-2 10-2 10-3z",
    fill: "#978F96"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(616,859)",
    d: "m0 0h6l-1 2-11 3h-10v-1l11-2z",
    fill: "#E55743"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(422,849)",
    d: "m0 0 10 3 8 3v1h-5l-1-1-8-1v-2l-4-1z",
    fill: "#C12F28"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(985,715)",
    d: "m0 0 1 3-5 10-2 6h-1l1-9 2-2 2-7z",
    fill: "#5B1422"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(995,688)",
    d: "m0 0v3l-2 9-2 2-2 7-1-3 2-8h2v-7z",
    fill: "#531624"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(282,653)",
    d: "m0 0 5 5 3 6v6l-4-5-3-7z",
    fill: "#BC755F"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(742,635)",
    d: "m0 0 5 5 4 6v2h2v2h-3l-9-13z",
    fill: "#8199AC"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(226,588)",
    d: "m0 0 2 3 1 2 2 15 1 5-3-2-2-15z",
    fill: "#B02422"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(459,580)",
    d: "m0 0 2 1-4 3-13 2-7 1v-2l17-3z",
    fill: "#2A373C"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(472,424)",
    d: "m0 0 1 2 4 2v2l8 4 1 3-6-2-5-4-3-4z",
    fill: "#6C0B1C"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(669,413)",
    d: "m0 0h1v8l-4 11h-2l2-10z",
    fill: "#90929D"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(262,389)",
    d: "m0 0 2 4-5 7h-3l1-5z",
    fill: "#BB2B26"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(818,383)",
    d: "m0 0 3 3 6 11 1 1v6l-2-3-8-15z",
    fill: "#E55044"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(506,332)",
    d: "m0 0 15 8 4 3-6-1-13-7z",
    fill: "#BF7E6E"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(342,208)",
    d: "m0 0h2v2l-10 5-9 6-2-1 10-7z",
    fill: "#E33050"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(254,160)",
    d: "m0 0h2v2l-11 8-7 6-2-1 3-3h2l1-3 10-7z",
    fill: "#959098"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(616,70)",
    d: "m0 0 5 1 14 1 5 3-4 1-5-2-15-2z",
    fill: "#A18B8C"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(826,950)",
    d: "m0 0h3l-2 4-10 6-5 2 2-3h2l1-3 7-3z",
    fill: "#3F343B"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(893,894)",
    d: "m0 0 3 1-10 10-5 2 6-7z",
    fill: "#50616B"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(211,886)",
    d: "m0 0 5 1 4 4 3 5 1 2-4-2-9-9z",
    fill: "#845E66"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(100,722)",
    d: "m0 0 3 4 6 15 2 2-1 3-4-7-3-5-2-6-1-1z",
    fill: "#91929C"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(617,488)",
    d: "m0 0 1 3v3l-2 1-1 3-2 4-3 4-1-3z",
    fill: "#480512"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(564,483)",
    d: "m0 0 2 1-3 1-1 3-4 2-10 1 1-2 10-3z",
    fill: "#740D1E"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(445,439)",
    d: "m0 0h8l3 2 2 5v10h-1l-3-13-2-2-7-1z",
    fill: "#4E0514"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(670,383)",
    d: "m0 0h2v9l-3 10h-1l1-12z",
    fill: "#2A373C"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(588,367)",
    d: "m0 0h8l4 2-4 2h-8z",
    fill: "#010101"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(454,357)",
    d: "m0 0h1l-1 11-1 9-2-3v-10h2z",
    fill: "#740D1E"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(723,326)",
    d: "m0 0 4 2 9 7-1 2-5-2-7-7z",
    fill: "#C17962"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(636,1007)",
    d: "m0 0h7l-4 2-1 1-7 1h-10l1-2h14z",
    fill: "#571825"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(756,991)",
    d: "m0 0h2l-1 3-9 2v2l-10 2 2-2z",
    fill: "#6C7884"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(353,803)",
    d: "m0 0 5 2 11 8 2 2-5-1-11-8z",
    fill: "#E44249"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(309,776)",
    d: "m0 0 4 2 7 6 5 7-8-4-3-5-5-4z",
    fill: "#C23028"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(831,697)",
    d: "m0 0 1 2-7 13-2 1-1-3 4-6h2l2-6z",
    fill: "#B72924"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(631,485)",
    d: "m0 0 1 4-6 12h-2l2-6z",
    fill: "#8896A5"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(900,407)",
    d: "m0 0 4 5 1 7 2 3 1 8-2-2-6-17z",
    fill: "#E33050"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(306,388)",
    d: "m0 0v3l-8 13h-1v-5l4-7z",
    fill: "#C87F67"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(409,347)",
    d: "m0 0h1l1 9v9l-2 1-1-16z",
    fill: "#2C353B"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(410,295)",
    d: "m0 0 2 4-2 13h-3l1-8z",
    fill: "#8A95A3"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(728,288)",
    d: "m0 0 4 2 12 9v2l-8-4-4-4-2-1v-2h-2z",
    fill: "#B02422"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(653,234)",
    d: "m0 0 6 1 9 3 6 3 1 2-11-3v-2l-7-1z",
    fill: "#B02422"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(488,228)",
    d: "m0 0h4v2l-7 2h-12l3-2z",
    fill: "#C33129"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(616,861)",
    d: "m0 0h6v2l-7 2-4 2h-8v-1h7l1-3z",
    fill: "#BB2B26"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(944,795)",
    d: "m0 0 1 3-1 2h-2l-2 5-4 6-2 1 1-4h2v-4h2l2-6z",
    fill: "#5B1422"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(736,793)",
    d: "m0 0m-1 1m-1 1m-1 1v3l-12 9-2-1 8-7z",
    fill: "#C33129"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(491,786)",
    d: "m0 0h7l-5 4-8 1 1-3z",
    fill: "#7C9FB1"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(405,594)",
    d: "m0 0h6l-4 4-6 1-3 3-3-1 8-6z",
    fill: "#19181D"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(418,586)",
    d: "m0 0 4 1-13 4-9 4-2-1 9-5z",
    fill: "#BBD0DE"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(493,579)",
    d: "m0 0 3 1 2 4 6 4-3 1-6-3-3-5z",
    fill: "#5D1724"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(512,477)",
    d: "m0 0 7 1-2 2h-4l1 4-3 1-1-1v-6z",
    fill: "#410510"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(638,454)",
    d: "m0 0 1 4-3 11h-2l-1-6 3-5z",
    fill: "#26262C"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(490,426)",
    d: "m0 0 19 1 3 2h-17l-5-2z",
    fill: "#091116"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(58,416)",
    d: "m0 0h1l-1 9-2 6-1 8h-1v-14l3-1z",
    fill: "#7C757B"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(249,415)",
    d: "m0 0 1 2-3 5-3 9-2 1 2-9z",
    fill: "#C33129"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(313,375)",
    d: "m0 0 1 4-6 9-5 3 2-4 6-9z",
    fill: "#BD7661"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(475,365)",
    d: "m0 0 4 1-9 4-2 6 1 4h-2l-1-2v-7l6-5z",
    fill: "#A9624D"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(350,335)",
    d: "m0 0 2 1-7 7h-2l-2 4-2 1 2-6 3-1 1-3z",
    fill: "#C77F67"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(491,304)",
    d: "m0 0 5 1 7 5 1 3-6-2-7-6z",
    fill: "#6C0B1C"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(365,265)",
    d: "m0 0m-2 1h2l-1 3-12 8-2-1 7-6z",
    fill: "#C33129"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(341,215)",
    d: "m0 0 3 1-9 6-5 4-6 2 4-4 12-8z",
    fill: "#E33050"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(776,126)",
    d: "m0 0 7 2 7 5 5 3-1 2-12-7-6-4z",
    fill: "#998E94"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(682,87)",
    d: "m0 0 6 1 1 1 9 2 3 2v2l-5-2-10-2-1-3z",
    fill: "#5D1322"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(132,785)",
    d: "m0 0 4 1 6 11 1 5-4-5-7-11z",
    fill: "#5C1220"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(755,776)",
    d: "m0 0 2 1-10 9-3 3-3-1 10-9 1-2z",
    fill: "#B02422"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(798,744)",
    d: "m0 0h2l-2 5-9 11h-2l2-4z",
    fill: "#C33129"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(256,688)",
    d: "m0 0h2l7 13 1 4-4-4-6-11z",
    fill: "#C33129"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(231,649)",
    d: "m0 0h3l3 10 1 1v5l-3-3-4-11z",
    fill: "#E55244"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(539,602)",
    d: "m0 0h13v2l-2 1h-8l-3-1z",
    fill: "#250308"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(553,600)",
    d: "m0 0h10v1l-8 1-3 1h-16v-2z",
    fill: "#4F0515"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(461,468)",
    d: "m0 0 2 3 6 16-1 3-5-12-2-6z",
    fill: "#550516"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(490,404)",
    d: "m0 0 1 3v7l5 7-4-1-4-6 1-9z",
    fill: "#B38278"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(690,307)",
    d: "m0 0h5v2l-10 2h-6v-2z",
    fill: "#8B95A2"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(720,280)",
    d: "m0 0 4 2 9 6 1 3-4-2-5-2-5-5z",
    fill: "#C02F28"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(576,272)",
    d: "m0 0 5 1 1 4 2 1h-6l-2-1-1-4z",
    fill: "#110303"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(365,267)",
    d: "m0 0h3v2l-15 9-1-2z",
    fill: "#E55743"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(188,220)",
    d: "m0 0 2 1-10 13-4 2 2-4 6-8h2z",
    fill: "#998E93"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(504,226)",
    d: "m0 0h8v2l-15 1-5 1v-2l2-1z",
    fill: "#C12F28"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(595,219)",
    d: "m0 0h14l6 3 5 1v1h-7l-10-3-8-1z",
    fill: "#B02422"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(504,66)",
    d: "m0 0h8v2l-12 1h-8v-1z",
    fill: "#521B28"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(780,848)",
    d: "m0 0 2 1-3 1-1 3-4 1v2l-6 4-3-1z",
    fill: "#E33050"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(623,848)",
    d: "m0 0h7l-4 2-5 2-13 2v-2l12-2z",
    fill: "#B02422"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(975,787)",
    d: "m0 0 1 2-3 7-3 5-3 1 2-5z",
    fill: "#616D77"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(87,682)",
    d: "m0 0 2 4 2 1 1 9h2l1 5h-2l-3-5-2-8-1-1z",
    fill: "#601523"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(858,617)",
    d: "m0 0 1 3-4 16h-1v-7l2-10z",
    fill: "#E54A47"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(681,590)",
    d: "m0 0 14 6v2l-15-5z",
    fill: "#8398AA"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(865,574)",
    d: "m0 0h1v7l-1 3-1 11h-1v-17z",
    fill: "#E55443"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(572,492)",
    d: "m0 0 4 1-8 5-5 2-3-1h2v-2l9-4z",
    fill: "#5C1926"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(616,480)",
    d: "m0 0 1 3-6 12-2 1 1-6h2l3-9z",
    fill: "#BF7E6E"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(797,425)",
    d: "m0 0 4 1 3 10-1 4-5-12z",
    fill: "#C87F66"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(531,404)",
    d: "m0 0h1v8l-2 10-2 2 1-13v-3h2z",
    fill: "#4D0514"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(619,403)",
    d: "m0 0h2l1 5h2l1 3-7 1z",
    fill: "#AE837B"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(485,401)",
    d: "m0 0h4l-1 5-2 6-2-1v-9z",
    fill: "#BBD0DE"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(115,326)",
    d: "m0 0 1 3-3 7-3 6-2 5h-2l2-6 3-7h2l1-6z",
    fill: "#93919A"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(655,324)",
    d: "m0 0 3 1v5l-4 1-2-4-4-2z",
    fill: "#0A0E11"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(683,312)",
    d: "m0 0h5l-2 3-13 1-4-1 1-2h11z",
    fill: "#0C1116"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(766,304)",
    d: "m0 0 4 2 7 6 5 6-1 2-15-15z",
    fill: "#B02422"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(641,280)",
    d: "m0 0 7 1 9 4 1 2-5-1-12-5z",
    fill: "#3C050F"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(145,279)",
    d: "m0 0 1 3-3 1-1 4-2 2-2 5-3 2 1-5h2l1-4 3-5z",
    fill: "#5E1221"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(275,259)",
    d: "m0 0v3l-10 10h-2l2-4 6-5z",
    fill: "#EB405A"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(643,1007)",
    d: "m0 0 3 1-9 4h-11v-1l12-2z",
    fill: "#8796A6"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(911,843)",
    d: "m0 0 1 3-3 3-2 5-2 2-3-1 6-9h2z",
    fill: "#AA9FA4"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(707,812)",
    d: "m0 0h5l-5 5-6 2 4-6z",
    fill: "#BD2D27"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(304,773)",
    d: "m0 0 3 1v2h2l8 8-1 2-10-9z",
    fill: "#B02422"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(782,766)",
    d: "m0 0 2 1-7 8-3 3h-2v-2h2l2-5z",
    fill: "#B42623"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(804,644)",
    d: "m0 0 1 4-1 3h-2l-1 7-3 2 3-12 1-2h2z",
    fill: "#BA735D"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1009,624)",
    d: "m0 0h1v13l-3 8h-1v-8l1-2h2z",
    fill: "#580C1C"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(465,410)",
    d: "m0 0 2 2 4 11 1 4h-2l-4-8z",
    fill: "#A9624D"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(635,400)",
    d: "m0 0h1v6l-5 5-7-1v-2h-2l1-2 4 3 7-2z",
    fill: "#A9624D"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(657,387)",
    d: "m0 0h1v6h2l-1 15h-1l-1-11z",
    fill: "#36040D"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(484,363)",
    d: "m0 0 3 1-12 6-6 2 1-3z",
    fill: "#720D1D"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(664,301)",
    d: "m0 0 2 1-6 7-6 5-2-2 8-7z",
    fill: "#3C050F"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(382,257)",
    d: "m0 0m-2 1h2v2l-12 7-3-1z",
    fill: "#E54B46"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(363,99)",
    d: "m0 0 2 1-8 4-11 4v-2h3v-2l9-4z",
    fill: "#8D93A0"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(476,1013)",
    d: "m0 0h16v2l4 2-12-2-8-1z",
    fill: "#511623"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(324,965)",
    d: "m0 0 6 1v2l6 1v2l5 1-4 1-10-5z",
    fill: "#5D1321"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(874,912)",
    d: "m0 0 1 2-7 8-6 2 5-5z",
    fill: "#5D6B76"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(469,855)",
    d: "m0 0 11 2 6 1v1h-13l-4-2z",
    fill: "#E54F45"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(180,851)",
    d: "m0 0 4 2 4 5 3 3-1 3-4-5-5-5z",
    fill: "#5A1422"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(966,758)",
    d: "m0 0h2l-2 7-5 8-1 3-2-1 2-5 5-8z",
    fill: "#8C94A1"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(261,716)",
    d: "m0 0 3 1 8 13-1 2-5-6z",
    fill: "#C33129"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(589,586)",
    d: "m0 0h2l-1 3-10 5-3-1 4-3z",
    fill: "#680E1E"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(858,573)",
    d: "m0 0h1v17l-3 3z",
    fill: "#E43E4A"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(489,562)",
    d: "m0 0h2l-2 6-3 6-4 2-1-2 4-3z",
    fill: "#2F343A"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(590,520)",
    d: "m0 0 4 1-1 2-10 4-4 1 4-4z",
    fill: "#6E0C1C"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 415)",
    d: "m0 0 3 3 1 2 1 9 2 5h-3l-2-13-2-3z",
    fill: "#581C28"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(415,405)",
    d: "m0 0 2 1v11l-3-1v-8z",
    fill: "#8896A5"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(506,398)",
    d: "m0 0h7l3 2h-4v5l-4-3v-2h-2z",
    fill: "#8399AC"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(540,395)",
    d: "m0 0h6l1 2-10 2-3 3-1-4z",
    fill: "#67101F"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(597,375)",
    d: "m0 0 11 2v2h3v2l-11-3-3-1z",
    fill: "#571B28"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(635,366)",
    d: "m0 0h2l-2 6-5 4-4-1 4-1 2-4z",
    fill: "#BC7B6A"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(646,363)",
    d: "m0 0h8l2 1v2h-9l-7 1 4-3z",
    fill: "#6C0D1D"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(646,347)",
    d: "m0 0 3 1-5 4-8 1 1-2h3v-2z",
    fill: "#BA7867"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(988,320)",
    d: "m0 0 3 3v2l4 2 1 9-3-4-5-10z",
    fill: "#6B737F"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(424,286)",
    d: "m0 0 5 1-3 3h-3l-4 2-3-1 3-3z",
    fill: "#3C050F"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(607,271)",
    d: "m0 0 9 1v2l3 1h-8l-4-2z",
    fill: "#DF6145"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(671,252)",
    d: "m0 0 11 5 5 3-2 1-8-4-5-2z",
    fill: "#C33129"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(445,240)",
    d: "m0 0h3l-1 3-10 2-7 2 1-2 7-3z",
    fill: "#B02422"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(443,239)",
    d: "m0 0h2l-1 3-8 2-5 2-4-1z",
    fill: "#C33129"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(342,107)",
    d: "m0 0 4 1-5 3h-5l-1 3-8 2 1-2 6-3 7-3z",
    fill: "#9A8E93"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(621,1011)",
    d: "m0 0h5l-4 3-2 1h-15v-1l12-1z",
    fill: "#A78885"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(378,989)",
    d: "m0 0 9 1v2h6l2 3-10-2-7-3z",
    fill: "#5A1522"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(930,854)",
    d: "m0 0 1 3-2 3h-2l-2 4-4 6-1-3z",
    fill: "#241D24"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(700,816)",
    d: "m0 0 3 1-6 4-5 3h-4v-2l5-2z",
    fill: "#B02422"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(752,650)",
    d: "m0 0h2l6 9v3h-2l-6-9z",
    fill: "#8C94A1"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(227,642)",
    d: "m0 0h2l3 9-1 3v-2h-2l-2-3z",
    fill: "#BD2D26"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(489,533)",
    d: "m0 0 3 3 1 3v8h-3l-1-11z",
    fill: "#8299AB"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(490,531)",
    d: "m0 0 4 3 1 10-2 3-2-11-2-4z",
    fill: "#2A373C"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(814,472)",
    d: "m0 0 1 3 3 1v12h-1l-3-11z",
    fill: "#C98067"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(72,452)",
    d: "m0 0h1v12l-3 10h-1v-7l2-5z",
    fill: "#AA8783"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1010,449)",
    d: "m0 0h2l1 12 2 3-1 4-3-5z",
    fill: "#959098"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(418,418)",
    d: "m0 0 2 1 4 12v4l-2-2-4-11z",
    fill: "#2C353B"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(552,412)",
    d: "m0 0 2 4 4 11-1 2-5-9z",
    fill: "#771221"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(580,401)",
    d: "m0 0h8l5 5v8h-1l-1-7-5-4-6-1z",
    fill: "#6C1725"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(464,397)",
    d: "m0 0 3 1 1 7h-2l-2-2-3 2 2-7z",
    fill: "#2A373C"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(114,332)",
    d: "m0 0h1v6l-3 1-1 4-3 7-1-3 2-5 3-6z",
    fill: "#5A1724"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(476,299)",
    d: "m0 0 4 1-1 6-3 1-2-6z",
    fill: "#010101"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(426,296)",
    d: "m0 0 1 4-3 7-2 1 1-7v-3z",
    fill: "#4B0513"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(411,291)",
    d: "m0 0h2l-1 8-1-4-8 1 2-3z",
    fill: "#B37767"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(965,277)",
    d: "m0 0 3 1 6 11-1 4-6-12z",
    fill: "#393B43"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(169,245)",
    d: "m0 0 2 1-1 3-2 1-1 3-3 2-2 4-3-1 1-2h2l2-4z",
    fill: "#581221"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(293,974)",
    d: "m0 0 5 1 8 4v2l2 1-4-1-11-6z",
    fill: "#9EADBB"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(668,908)",
    d: "m0 0h7l-4 2-10 3-5 1 1-2 10-3z",
    fill: "#E33050"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(471,864)",
    d: "m0 0h9l5 2v1h-9l-5-1z",
    fill: "#C33129"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(694,832)",
    d: "m0 0 2 1-4 3h-2l-1 3-8 1 5-4z",
    fill: "#C02F28"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(146,805)",
    d: "m0 0 1 2h2l2 5 4 4-1 3-8-11z",
    fill: "#571221"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(748,798)",
    d: "m0 0 2 1-4 4-5 4-4 1 4-5z",
    fill: "#B02422"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(341,793)",
    d: "m0 0 12 9v2l-4-2-9-7z",
    fill: "#E54F45"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(364,760)",
    d: "m0 0 5 3 4 1-1 4-5-2-3-4z",
    fill: "#490513"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(771,681)",
    d: "m0 0 3 4 3 6-1 3-3-3-3-9z",
    fill: "#8A95A2"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(583,617)",
    d: "m0 0 4 1-1 3-6 3-3-1 4-4h2z",
    fill: "#7F9AAE"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(502,585)",
    d: "m0 0 6 2 1 3 4 1 2 2-5-1-7-4z",
    fill: "#B26E5B"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(475,576)",
    d: "m0 0 3 1-2 1h-6l1 3h-9l1-2z",
    fill: "#282A30"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(850,474)",
    d: "m0 0 2 2 2 17-3-2z",
    fill: "#B02422"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(238,445)",
    d: "m0 0 2 3-3 9-2 7-2-1 3-12z",
    fill: "#B02422"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(482,431)",
    d: "m0 0 5 2 3 3v-2h2l1 2 3 2-10-1-1-3-4-1z",
    fill: "#3E050F"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(530,424)",
    d: "m0 0 2 4-3 4h-2l-1 3-2-1 5-9z",
    fill: "#B77462"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(599,415)",
    d: "m0 0 1 3-3 5-5-2 2-1 2-4z",
    fill: "#CBA79C"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(510,407)",
    d: "m0 0h1l-1 9-5 4-6-1v-1l7-1 1-4 2-1z",
    fill: "#34252D"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(417,402)",
    d: "m0 0 2 3v12l-2-1-1-13z",
    fill: "#2A373C"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(495,401)",
    d: "m0 0 5 1-3 2-4 4h-2v6h-1v-7z",
    fill: "#691120"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(562,400)",
    d: "m0 0h2l1 13h-3z",
    fill: "#46232C"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(408,368)",
    d: "m0 0 2 3 1 10h-2l-2-5z",
    fill: "#8A95A2"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(321,365)",
    d: "m0 0h2l-2 4-6 8-1-4 4-5h2z",
    fill: "#C47C64"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(408,358)",
    d: "m0 0h1l1 13-3 1-1-13z",
    fill: "#809AAE"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(444,342)",
    d: "m0 0 1 4-2 6-1 8h-1v-12l2-5z",
    fill: "#550516"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(977,345)",
    d: "m0 0 1 3h2l3 7 1 3-2 2-5-11z",
    fill: "#91929C"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(653,341)",
    d: "m0 0 7 1v8h-1l-1-7-7 2z",
    fill: "#591B27"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(464,330)",
    d: "m0 0h2l-3 9-2 1-2 3 1-7 1-2h2z",
    fill: "#B87563"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(771,312)",
    d: "m0 0 7 6 4 5-4-1-2-1v-3l-3-1v-2h-2z",
    fill: "#E44648"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(661,300)",
    d: "m0 0h3l-2 4-6 5 1-5z",
    fill: "#5F0918"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(415,846)",
    d: "m0 0 5 1 2 4 4 2-5-1-5-2z",
    fill: "#BA2A25"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(839,648)",
    d: "m0 0 1 3-4 10-2 6h-1l1-8 4-9z",
    fill: "#B02422"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(807,632)",
    d: "m0 0h1v9l-2 3h-2l-1 2 1-6z",
    fill: "#C67D65"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(714,610)",
    d: "m0 0 7 5 1 4-5-1-3-5z",
    fill: "#222429"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(497,575)",
    d: "m0 0 2 4-1 3 4 2 1 3-5-2-3-3z",
    fill: "#B67766"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(502,556)",
    d: "m0 0h2v6l-2 4h-2l-1 2 2-9z",
    fill: "#690B1B"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(624,501)",
    d: "m0 0 1 3-7 10-2-2 6-10z",
    fill: "#809AAE"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(73,456)",
    d: "m0 0h1v9l-2 9-2 1 1-7z",
    fill: "#641624"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(812,461)",
    d: "m0 0 2 1 2 9-1 4-4-10z",
    fill: "#BD765F"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(847,453)",
    d: "m0 0 2 1 3 7v7l-2-1-3-11z",
    fill: "#E44747"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(280,435)",
    d: "m0 0h2l-3 9-2 7h-1v-8z",
    fill: "#CB836A"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(665,419)",
    d: "m0 0h2l-2 10-3 3-1-2 1-4h2z",
    fill: "#332930"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(307,315)",
    d: "m0 0v3l-8 8-2-1 8-9z",
    fill: "#E54E45"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(689,311)",
    d: "m0 0h7l2 2-5 2-4 2z",
    fill: "#12161B"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(812,264)",
    d: "m0 0 3 1-3 2 2 4 4 4v2h-2v-2l-3-1-3-4 1-5z",
    fill: "#E33050"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(141,243)",
    d: "m0 0v3l-5 8-5 4 2-4 7-10z",
    fill: "#97A6B4"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(697,90)",
    d: "m0 0 4 1 9 3 4 3h-5l-2-2-9-3z",
    fill: "#9D8D90"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(343,975)",
    d: "m0 0h6l11 6-3 1-10-5z",
    fill: "#611322"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(775,958)",
    d: "m0 0 2 1-9 5-3 2-3-1 4-3z",
    fill: "#92919B"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(854,900)",
    d: "m0 0h2l-2 4-6 4h-2v-2h2v-3l6-1z",
    fill: "#561523"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(904,882)",
    d: "m0 0h2v3h-2l-2 4-3 3-3-1 7-7z",
    fill: "#556570"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(654,850)",
    d: "m0 0h2l-1 3-9 3h-6l4-2z",
    fill: "#C33129"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(386,832)",
    d: "m0 0 9 4 5 3-3 1-11-6z",
    fill: "#C33129"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(799,725)",
    d: "m0 0 1 3-8 10-2 1 2-4 6-9z",
    fill: "#B02422"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(384,641)",
    d: "m0 0h6l-4 2-10 2-4 1 2-4z",
    fill: "#29393E"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(494,591)",
    d: "m0 0 6 2 6 4-4 1-6-3v-2h-2z",
    fill: "#010101"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(647,584)",
    d: "m0 0 13 2 1 2h-10z",
    fill: "#242B31"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(487,571)",
    d: "m0 0 1 3-4 4h-6v-3l7-1z",
    fill: "#16161C"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(863,504)",
    d: "m0 0h2l1 2v9l-3-3z",
    fill: "#E55244"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(495,497)",
    d: "m0 0 7 3v6l-4-2-3-5z",
    fill: "#FE6673"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(265,480)",
    d: "m0 0h1v10l-3 10h-1v-7l2-5z",
    fill: "#AF6A56"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(230,461)",
    d: "m0 0h2l-2 11-2 2v-10h2z",
    fill: "#E44747"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(560,433)",
    d: "m0 0 9 4v2l2 1-5-1-6-3z",
    fill: "#B67361"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(651,427)",
    d: "m0 0 1 2-1 5-6 4-3-1 6-5z",
    fill: "#6C0E1D"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(603,431)",
    d: "m0 0h2l-2 5-3 2-4-1 2-4 4-1z",
    fill: "#5C0917"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(497,326)",
    d: "m0 0 4 1 5 5-3 1-6-4z",
    fill: "#B87564"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(685,310)",
    d: "m0 0h5l-1 2-8 2h-6l1-2z",
    fill: "#2D353B"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(762,304)",
    d: "m0 0 4 2 5 5v3l-3-1-3-4v-2l-3-1z",
    fill: "#E45445"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(336,296)",
    d: "m0 0h2v2l-9 7-1-3z",
    fill: "#E44448"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(479,293)",
    d: "m0 0 4 2 7 7-4 2-3-6z",
    fill: "#4F0514"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(709,270)",
    d: "m0 0 12 7 1 2-7-2-6-4z",
    fill: "#E55343"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(450,72)",
    d: "m0 0h3v2l-5 2-11 1v-2l10-2z",
    fill: "#92919B"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(576,66)",
    d: "m0 0h8v2l6 1v1l-8-1-7-1z",
    fill: "#481421"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(806,963)",
    d: "m0 0 2 1-5 5-6 1 4-4z",
    fill: "#64656D"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(790,947)",
    d: "m0 0 2 1-5 4-5 3h-3v-2h3v-2h4v-3z",
    fill: "#5C1523"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(422,842)",
    d: "m0 0 8 1 6 3-1 2-13-5z",
    fill: "#E55843"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(674,830)",
    d: "m0 0 3 1-4 4h-6l-2 2-3-1 4-3h6v-2z",
    fill: "#B32623"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(828,696)",
    d: "m0 0 1 3-6 11-2-2 6-11z",
    fill: "#E54E45"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(315,686)",
    d: "m0 0h2l-2 5-3 6-3-1z",
    fill: "#8C94A1"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(319,677)",
    d: "m0 0 2 1-2 5-2 3h-2l2-6z",
    fill: "#8298AB"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(332,655)",
    d: "m0 0h2l-2 5-3 5h-2l1-5z",
    fill: "#8E939F"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1012,614)",
    d: "m0 0h2l-2 7-1 11h-1v-16z",
    fill: "#4A232D"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(851,614)",
    d: "m0 0 1 4-3 9h-1v-7l2-5z",
    fill: "#C33129"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(598,608)",
    d: "m0 0 2 1-8 6-6 3v-2h2v-2l7-4z",
    fill: "#7AA1B2"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(626,579)",
    d: "m0 0 11 2 3 2h-7l-7-2z",
    fill: "#8C94A1"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(583,549)",
    d: "m0 0h1l3 13-1 4-3-7z",
    fill: "#A9624D"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(493,552)",
    d: "m0 0 2 1-1 7-3 6-1-4z",
    fill: "#0D1116"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(613,493)",
    d: "m0 0 1 3-6 11-3-1z",
    fill: "#7E1020"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(454,486)",
    d: "m0 0 2 1 4 10v2h-2l-4-9z",
    fill: "#90929C"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(231,432)",
    d: "m0 0h1l-1 8-3 8h-1v-7l3-5z",
    fill: "#C33129"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(241,414)",
    d: "m0 0 1 4-3 5-2 4-1-3 4-9z",
    fill: "#E55843"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(488,384)",
    d: "m0 0h18v1l-13 1-5 1z",
    fill: "#38040E"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(440,378)",
    d: "m0 0 5 5 1 4-2 1-4-5z",
    fill: "#601120"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(411,378)",
    d: "m0 0h2v3h2l-1 7h-2z",
    fill: "#2A262D"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(662,364)",
    d: "m0 0v3l-1 3h-5l-2-4 7-1z",
    fill: "#111217"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(338,282)",
    d: "m0 0 2 1-4 5-6 4-2-1z",
    fill: "#B02422"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(350,277)",
    d: "m0 0h2v2l-9 7-4-1 9-6z",
    fill: "#E44847"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(708,272)",
    d: "m0 0 12 6v2l-5-1-7-5z",
    fill: "#C33129"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(666,83)",
    d: "m0 0h8l6 3v1h-5l-1-1-7-1z",
    fill: "#65101F"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(405,84)",
    d: "m0 0 3 1-4 2-7 1-2 2-4-1 4-3z",
    fill: "#A18A8B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar1);
export default __webpack_public_path__ + "static/media/avatar-1.62c2335d94d582d0a939dce343598d96.svg";
export { ForwardRef as ReactComponent };